import * as tslib_1 from "tslib";
var CompanyPageController = /** @class */ (function () {
    /*@ngInject*/
    function CompanyPageController($scope, $rootScope, $state, $transitions, $timeout, $compile, $filter, $uibModal, genericService, StorageService, userService, companyService, planService, dateTimeUtilityService, userRoleService, alertsAndNotificationsService, COMPANYMANAGEMENTCONSTANTS, MESSAGECONSTANTS, uibModalService, resumeService) {
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$transitions = $transitions;
        this.$timeout = $timeout;
        this.$compile = $compile;
        this.$filter = $filter;
        this.$uibModal = $uibModal;
        this.genericService = genericService;
        this.StorageService = StorageService;
        this.userService = userService;
        this.companyService = companyService;
        this.planService = planService;
        this.dateTimeUtilityService = dateTimeUtilityService;
        this.userRoleService = userRoleService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.COMPANYMANAGEMENTCONSTANTS = COMPANYMANAGEMENTCONSTANTS;
        this.MESSAGECONSTANTS = MESSAGECONSTANTS;
        this.uibModalService = uibModalService;
        this.resumeService = resumeService;
    }
    CompanyPageController.prototype.$onInit = function () {
        var _this = this;
        this.$stateParams = this.$transition$.params();
        this._initializeVariables();
        this._initializeWizard();
        this._initializeCompany();
        this.getCompanyTypes();
        this._handleBrowserEvents();
        this.$timeout(function () {
            _this._setMobileNumberSettings();
        }, 2000);
    };
    CompanyPageController.prototype._initializeVariables = function () {
        this.isTransitionAbortRequired = true;
        this.loggedInUserDetails = this.StorageService.get('userDetails');
        this.newlyCreatedCompanyId = null;
        this.fourDotFiveCompanyAdmin;
        this.assignClient2StaffingCompany; //NP
        this.industrySublist = []; //NP
        this.count = 0;
        this.confirmationAtStep;
        this.valid = false;
        this.showConfirmationPopup = false;
        this.updatedAssessementFlow;
        this.companyStepOneSaved = false;
        this.companyStepTwoSaved = false;
        this.companyStepThreeSaved = false;
        this.companyStepFourSaved = false;
        this.companyStepFiveSaved = false;
        this.stepOneChanged = false;
        this.stepTwoChanged = false;
        this.stepThreeChanged = false;
        this.stepFourChanged = false;
        this.stepFiveChanged = false;
        this.stepSixChanged = false;
        this.getDetailsOfCompany;
        this.fourDotFiveAdminObject = null;
        this.oldFourDotFiveAdminId = null;
        this.clientOrBuUpdateInProgress = false;
        this.clientOrBuCreationInProgress = false;
        this.vendorUpdateInProgress = false;
        this.resumePullCounts = [5, 10, 15, 20, 25];
        this.isCompanyDeleted = false;
        this.isActivePlanExists = true;
        this.isFuturePlanExists = false;
        this.isPlanChosen = false;
        this.futurePlanName = "";
        this.isAssociatedClientUpdateInProgress = false;
        this.isContactSelected = true;
        this.isStepReadOnlyForCompanyAdmin = true;
        this.isLocationChange = false;
        this.isLocationChangeInitial = false;
        this.accessTimeOptionsDisabled = false;
        this.disableActionButtons = false;
        this.hasUnsavedJobBoardCredentials = false;
        this.hasUnsavedAssessmentCredentials = false;
        this.industryListOfCompany = 0;
        this.oldCheckedAdmin = null;
        this.cancelClicked = false;
        this.newCompanyCreation = false;
        this.zipCodeCalling = false;
        this.zipCodeCallCompleted = false;
        this.saveButtonClicked = false;
        this.nextButtonClicked = false;
        this.nextButtonFlag = 0;
        this.saveButtonFlag = 0;
        this.addJobBoardByPasswordFlag = true;
        this.buttonWorkFlowText = 'Add';
        this.form = {};
        this.form.companyDetailsForm = {};
        this.form.companyContactPersonDetailsForm = {};
        this.form.companySecondaryContactPersonDetailsForm = {};
        this.form.contactForm = {};
        this.form.company4dot5AdminDetailsForm = {};
        this.form.companyAssessmentFlowDetailsForm = {};
        this.form.addCredentialsForm = {};
        this.maskedMobilePhoneSecondarycursorPosition = true;
        //This is the UI object (Transient object)
        this.companyManagement = {};
        this.CompanyManagementReset = {};
        this.companyManagement.company = {}; //Step 1 object
        this.companyManagement.contactList = []; //Step 2 object
        this.fourDotFiveAdminsList = []; //Step 3 object
        this.selectedPlan = {}; //Step 4 object
        this.futurePlan = {};
        this.AssessmentWorkFlow = []; //Step 5 object
        this.vendors = []; //Step 6 object
        this.phoneValidationStatuses = [];
        //This is the Saved object (Saved object),the object that will be sent while saving the step details.
        this.savedCompanyManagement = {};
        this.savedCompanyManagement.company = {}; //Step 1 object
        this.savedCompanyManagement.contactList = []; //Step 2 object
        this.savedFourDotFiveAdmin = []; //Step 3 object
        this.savedCurrentActivePlan = {}; //Step 4 object
        this.savedAssessmentWorkFlow = []; //Step 5 object
        this.savedCompanyManagementCopy = {};
        this.savedCompanyManagementCopy.company = {};
        this.savedCompanyManagementCopy.contactList = [];
        this.savedFourDotFiveAdminCopy = [];
        this.savedCurrentActivePlanCopy = {};
        this.savedAssessmentWorkFlowCopy = [];
        this.preferences = null;
        this.jobBoardCredentialListCopy = null;
        this.errorInSavingPrefsCheck = false;
        this.cancelNotClicked = true;
        this.invalidZipcode = false;
        this.licensePreferencesFetched = false;
        this.isCompanyDetailsSaveCalled = false; //flag used to make getworkflow settings api call
        this.planDetailsFetched = false;
        this.isTestLinkReadOnly = true;
        this.selectedIndustryGroup = null;
        this.laststep = false;
        this.TypeOfCompany = 'Company';
        this.showRemoveButton = false;
        if (!this.$stateParams.accessMode) {
            this.accessMode = 'view';
        }
        this.IndustrySubList = [];
        this.SelectedIndustrySubList = [];
        this.typeaheadNotSelected = true;
        this.triggerCount = 0;
        this.delimitedCompanyOrClientName = null;
        this.companyTypes = [];
        this.lastStepCompleted = false;
        this.showCreateCompanyHeading = true;
        this.ClientOrBuUpdate = false;
        this.ClientOrBuCreate = false;
        this.IndustryGroupList = [];
        this.IndustrySubGroupList = [];
        this.dataLastLabel = 'Complete';
        this.selectedSubGroup = false;
        this.industriesInPanel = [];
        this.temp = [];
        this.primaryContactWTFormat = '+1 201-555-0123';
        this.primaryContactWTFormat1 = '+1 201-555-0123';
        this.primaryContactMNFormat = '+1 201-555-0123';
        this.secondaryContactWTFormat = '+1 201-555-0123';
        this.secondaryContactMNFormat = '+1 201-555-0123';
        this.primaryContactWTCountryCode = 'us';
        this.primaryContactWTCountryCode1 = 'us';
        this.primaryContactMNCountryCode = 'us';
        this.secondaryContactWTCountryCode = 'us';
        this.secondaryContactMNCountryCode = 'us';
        this.isValidPrimaryMobileEntered = false;
        this.isValidPrimaryWorkPhoneEntered = false;
        this.isValidSecondaryMobileEntered = false;
        this.isValidSecondaryWorkPhoneEntered = false;
        this.jobSourceType = [];
        this.isAddressValid = false;
        this.tempObj = null;
        this.errorOcurred = false;
        this.isCountyExists = false;
        this.JobBoardCredential = {};
        this.JobBoardCredential.sourceType;
        this.JobBoardCredential.userName;
        this.JobBoardCredential.key = "";
        this.selectedAccessTime = [];
        this.keyaccess;
        this.usernameaccess;
        this.buttonAssessment = "Add";
        this.selectedAssesmentIndex;
        this.assessmentTypeList = ["Codility", "Interview Mocha"];
        this.useAccountCredDetailsList = ["4dot5", "My Own"];
        this.useAccountCredDetailsList1 = ["4dot5", "My Own"];
        this.matchCountList = [1, 2, 3, 5];
        this.accessMode = this.$stateParams.accessMode;
        this.readOnlyForClientOrBU = false;
        this.isUserSuperUserOr4dot5Admin = this.userRoleService.isLoggedInUserSuperUserOr4dot5Admin();
        // this.isUserAnAdmin = this.userRoleService.isLoggedInUserAnAdmin();
        this.isCompanyVendor = this.companyService.isCompanyVendor();
        this.isCompanyAdmin = this.userRoleService.isLoggedInUserCompanyAdmin();
    };
    CompanyPageController.prototype._setMobileNumberSettings = function () {
        var _this = this;
        $("#maskedWorkPhone").keyup(function () {
            if (document.getElementById('maskedWorkPhone').value.length > 0) {
                _this.workTelephoneDirty = true;
            }
            else {
                _this.workTelephoneDirty = false;
            }
        });
        $("#maskedWorkPhone1").keyup(function () {
            if (document.getElementById('maskedWorkPhone1').value.length > 0) {
                _this.mobileNumberDirty = true;
            }
            else {
                _this.mobileNumberDirty = false;
            }
        });
        $("#maskedWorkPhoneSecondary").keyup(function () {
            console.log("maskedWorkPhoneSecondary");
            if (document.getElementById('maskedWorkPhoneSecondary').value.length > 0) {
                _this.workTelephoneDirty = true;
            }
            else {
                _this.workTelephoneDirty = false;
            }
        });
        $("#maskedMobilePhoneSecondary").keyup(function () {
            if (document.getElementById('maskedMobilePhoneSecondary').value.length > 0) {
                _this.mobileNumberDirty = true;
            }
            else {
                _this.mobileNumberDirty = false;
            }
        });
        $("#maskedWorkPhone").on("countrychange", function (e, countryData) {
            //console.log('e : ' + angular.toJson(e));
            console.log('countryData p workTelephone change: ' + angular.toJson(countryData));
            _this.primaryContactWTCountryCode = countryData.iso2;
            _this.$timeout(function () {
                if (_this.primaryContactWTCountryCode !== undefined) {
                    _this.setPrimaryContactWTCountryCode();
                }
            }, 200);
        });
        $("#maskedWorkPhone1").on("countrychange", function (e, countryData) {
            //console.log('e : ' + angular.toJson(e));
            console.log('countryData p workTelephone change: ' + angular.toJson(countryData));
            _this.primaryContactWTCountryCode1 = countryData.iso2;
            if (_this.primaryContactWTCountryCode1 !== undefined) {
                _this.setPrimaryContactWTCountryCode1();
            }
        });
        $("#maskedMobilePhone").on("countrychange", function (e, countryData) {
            //console.log('e : ' + angular.toJson(e));
            console.log('countryData p mobileNumber change: ' + angular.toJson(countryData));
            _this.primaryContactMNCountryCode = countryData.iso2;
            _this.$timeout(function () {
                if (_this.primaryContactMNCountryCode !== undefined) {
                    _this.setPrimaryContactMNCountryCode();
                }
            }, 200);
        });
        angular.element("#maskedWorkPhoneSecondary").on("countrychange", function (e, countryData) {
            //console.log('e : ' + angular.toJson(e));
            console.log('countryData s workTelephone change: ' + angular.toJson(countryData));
            _this.secondaryContactWTCountryCode = countryData.iso2;
            _this.$timeout(function () {
                if (_this.secondaryContactWTCountryCode !== undefined) {
                    _this.setSecondaryContactWTCountryCode();
                }
            }, 200);
        });
        angular.element("#maskedMobilePhoneSecondary").on("countrychange", function (e, countryData) {
            //console.log('e : ' + angular.toJson(e));
            console.log('countryData s mobileNumber change: ' + angular.toJson(countryData));
            _this.secondaryContactMNCountryCode = countryData.iso2;
            _this.$timeout(function () {
                if (_this.secondaryContactMNCountryCode !== undefined) {
                    _this.setSecondaryContactMNCountryCode();
                }
            }, 200);
        });
        this.$timeout(function () {
            console.log('now entered');
            if (angular.isDefined(_this.form.companyContactPersonDetailsForm)) {
                _this.form.companyContactPersonDetailsForm.$setPristine();
            }
        }, 5000);
    };
    CompanyPageController.prototype._initializeWizard = function () {
        this.$timeout(function () {
            {
                $('#myWizard').wizard()
                    .on('actionclicked.fu.wizard', function (event, data) {
                    var wizardoperations = localStorage.getItem('myStorage-wizardoperations');
                    console.log('wizardoperations : ' + wizardoperations);
                    if ((wizardoperations === null) || (wizardoperations !== 'true')) {
                        console.log('preventing');
                        event.preventDefault();
                    }
                });
                // $('.custom-file-upload').bind("click", function () {
                //     $('#inputImage').trigger('click');
                // });
                $('#select-company-logo').bind("click", function () {
                    $('#company.headerLogo').trigger('click');
                });
                $('#select-company-small-logo').bind("click", function () {
                    $('#company.smallHeaderLogo').trigger('click');
                });
                $('#inputImage').change(function () {
                    var filepath = $('#inputImage').val();
                    var filename = filepath.split('\\').pop().split('/').pop(); //str.split('\\').pop().split('/').pop();
                    $('#companypicname').html(filename);
                });
            }
        }, 500);
    };
    CompanyPageController.prototype._initializeCompany = function () {
        var _this = this;
        /**
         * Conditions to check whether its Client create or Client update.
         */
        if (this.StorageService.get('clientOrBuCreationInProgress') !== null) {
            //Condition is satified if Client Creation is in progress.
            if (this.$rootScope.userDetails.company.companyType == 'Corporation') {
                this.TypeOfCompany = 'BusinessUnit';
                //this.companyManagement.company.companyType = 'BusinessUnit';
            }
            else if (this.$rootScope.userDetails.company.companyType == 'StaffingCompany') {
                this.TypeOfCompany = 'Client';
                //this.companyManagement.company.companyType = 'Client';
            }
            this.ClientOrBuCreate = true;
            this.clientOrBuCreationInProgress = true;
            this.StorageService.remove('clientOrBuCreationInProgress');
            // INDUSTRY CODE                getIndustryGroups();
        }
        else if (!_.isNull(this.StorageService.get('clientOrBuToBeUpdated')) || !_.isNull(this.$stateParams.clientOrBuObject)) {
            //Condition is satified if Client Updation is in progress.
            if (this.$rootScope.userDetails.company.companyType == 'Corporation') {
                this.TypeOfCompany = 'BusinessUnit';
            }
            else if (this.$rootScope.userDetails.company.companyType == 'StaffingCompany') {
                this.TypeOfCompany = 'Client';
                this.isAssociatedClientUpdateInProgress = this.$stateParams.isAssociatedClient ? true : false;
            }
            this.genericService.getObjects(this.COMPANYMANAGEMENTCONSTANTS.CONTROLLER.GET_COMPANY + '/' + this.$stateParams.clientOrBuObject.company.id).subscribe(function (data) {
                _this.clientOrBuUpdateInProgress = true;
                _this.ClientOrBuUpdate = true;
                if (_this.isAssociatedClientUpdateInProgress) {
                    _this._getSharedClientDescription(_this.$stateParams.clientOrBuObject.company.id, function (description) {
                        var sharedClientObject = angular.copy(_this.$stateParams.clientOrBuObject);
                        sharedClientObject.company.description = description.clientDescription;
                        _this.companyManagement = angular.copy(sharedClientObject);
                        _this.CompanyManagementReset = angular.copy(_this.companyManagement);
                        _this._saveStepOne(data.body);
                    });
                }
                else {
                    _this.companyManagement = angular.copy(data.body);
                    _this.CompanyManagementReset = angular.copy(data.body);
                    _this._saveStepOne(data.body);
                }
            });
            if (this.accessMode == 'view') {
                //This condition is satisfied when user doesnot have access to edit the company details and hence all fields are disabled.
                // this.companyDetailsUpdateModeByCompanyAdmin = true;
                this.readOnlyForClientOrBU = true;
                this.$timeout(function () {
                    angular.element('.access').attr({ 'readonly': true, 'disabled': true });
                    angular.element('.hostaccess').attr({ 'readonly': true, 'disabled': true });
                }, 500);
            }
        }
        /**
         * Conditions to check for Vendor update.
         */
        else if (this.$stateParams.vendorId !== null) {
            this.vendorUpdateInProgress = true;
            if (this.$rootScope.userDetails.company.companyType == 'Corporation') {
                this.TypeOfCompany = 'Vendor';
            }
            this.companyService.getCompanyDetails(this.$stateParams.vendorId, function (data) {
                _this.companyService.getVendorContacts(_this.$stateParams.vendorId, _this.$rootScope.userDetails.company.companyId, function (vendorContacts) {
                    data.contactList = angular.copy(vendorContacts);
                    angular.forEach(data.contactList, function (val, key) {
                        val.primary = val.isPrimary;
                    });
                    _this.companyManagement = angular.copy(data);
                    _this.CompanyManagementReset = angular.copy(_this.companyManagement);
                    console.log('this.CompanyManagementReset  ' + angular.toJson(_this.CompanyManagementReset.fourDotFiveAdmin));
                    _this.savedCompanyManagement.company = angular.copy(_this.companyManagement.company);
                    _this.savedCompanyManagement.contactList = angular.copy(_this.companyManagement.contactList);
                    _this.savedCompanyManagement.companyState = angular.copy(_this.companyManagement.companyState);
                    console.log('vendor : ' + _this.companyManagement);
                    _this.editCompanyName = _this.companyManagement.company.name.substring(0, 57);
                    _this.editCompanyNameOnHover = _this.companyManagement.company.name;
                    if (_this.companyManagement.company.name.length > 57) {
                        _this.editCompanyName = _this.editCompanyName + '...';
                    }
                    _this.getAddressDetails(_this.companyManagement.company.zipcode, 'updateaddress');
                    _this.originalStepOne = angular.copy(_this.companyManagement.company);
                    _this.originalStepTwo = angular.copy(_this.companyManagement.contactList);
                    if (_this.companyManagement.contactList.length > 1) {
                        _this.showRemoveButton = true;
                        _this.isValidPrimaryMobileEntered = true;
                        _this.isValidPrimaryWorkPhoneEntered = true;
                        _this.isValidSecondaryMobileEntered = true;
                        _this.isValidSecondaryWorkPhoneEntered = true;
                        angular.forEach(_this.phoneValidationStatuses, function (status, key) {
                            status.isValidWorkNumber = true;
                            status.isValidMobileNumber = true;
                        });
                    }
                    else if (_this.companyManagement.contactList.length == 1) {
                        _this.isValidPrimaryMobileEntered = true;
                        _this.isValidPrimaryWorkPhoneEntered = true;
                    }
                }, function (error) {
                    _this.alertsAndNotificationsService.showBannerMessage(error, 'danger');
                });
            }, function (error) {
                //do nothing
            });
        }
        /**
         * This condition separates whether the module is loaded
         * on account of Company view/update or Host Company view/update.
         * @access for create, view and update
         */
        else if ((this.StorageService.get('companyDetails') != null || this.$rootScope.userDetails.roleScreenRef.role.name == 'CorporateAdmin' || this.$rootScope.userDetails.roleScreenRef.role.name == 'StaffingAdmin') && !this.clientOrBuCreationInProgress && !this.clientOrBuUpdateInProgress && !this.vendorUpdateInProgress && this.StorageService.get('SelectedHostCompany') == null) {
            // This condition is satisfied when a company is selected from popup or Role is CorporateAdmin or role is StaffingAdmin
            // and
            // user not in creation/ updation of client and selected company is not host company.
            // view or update company access
            if (this.StorageService.get('companyDetails') != null) {
                if (angular.isDefined(this.StorageService.get('companyDetails').companyId)) {
                    this.getDetailsOfCompany = this.StorageService.get('companyDetails').companyId;
                }
                else {
                    this.getDetailsOfCompany = this.StorageService.get('companyDetails');
                }
            }
            else {
                console.log('Rootscope details');
                this.getDetailsOfCompany = this.$rootScope.userDetails.company.companyId;
            }
            this.genericService.getObjects(this.COMPANYMANAGEMENTCONSTANTS.CONTROLLER.GET_COMPANY + '/' + this.getDetailsOfCompany).subscribe(function (data) {
                _this.companyManagement = data.body;
                _this.CompanyManagementReset = angular.copy(_this.companyManagement);
                console.log('this.CompanyManagementReset  ' + angular.toJson(_this.CompanyManagementReset.fourDotFiveAdmin));
                //Setting the phone number values to be true
                if (data.body.contactList.length == 1) {
                    _this.isValidPrimaryMobileEntered = true;
                    _this.isValidPrimaryWorkPhoneEntered = true;
                }
                else if (data.body.contactList.length > 1) {
                    _this.isValidPrimaryMobileEntered = true;
                    _this.isValidPrimaryWorkPhoneEntered = true;
                    _this.isValidSecondaryMobileEntered = true;
                    _this.isValidSecondaryWorkPhoneEntered = true;
                    angular.forEach(_this.phoneValidationStatuses, function (status, key) {
                        status.isValidWorkNumber = true;
                        status.isValidMobileNumber = true;
                    });
                }
                _this.getAddressDetails(data.body.company.zipcode, 'updateaddress');
                _this.originalStepOne = angular.copy(_this.companyManagement.company);
                _this.savedCompanyManagement.company = angular.copy(_this.companyManagement.company);
                console.log('this.originalStepOne  ' + angular.toJson(_this.originalStepOne));
                _this.originalStepTwo = angular.copy(_this.companyManagement.contactList);
                _this.savedCompanyManagement.contactList = angular.copy(_this.companyManagement.contactList);
                _this.originalStepThree = angular.copy(_this.companyManagement.fourDotFiveAdmin);
                _this.savedFourDotFiveAdmin = angular.copy(_this.companyManagement.fourDotFiveAdmin);
                console.log('...................................' + angular.toJson(_this.savedFourDotFiveAdmin));
                //  INDUSTRY CODE                 this.SelectedIndustrySubList = angular.copy(this.companyManagement.company.industryList);
                if (_this.companyManagement.fourDotFiveAdmin !== null) {
                    //This is satisfied when a company has 4dot5 admin assigned.
                    _this.oldFourDotFiveAdminId = _this.companyManagement.fourDotFiveAdmin.userId;
                    _this.companyManagement.fourDotFiveAdmin.ticked = true;
                    _this.originalStepThree.ticked = true;
                    _this.fourDotFiveAdminsList = [];
                    _this.genericService.getObjects(_this.COMPANYMANAGEMENTCONSTANTS.CONTROLLER.GET_4DOT5_ADMINS).subscribe(function (data) {
                        if (_this.$rootScope.userDetails.roleScreenRef.role.name == '4dot5SuperUser' || _this.$rootScope.userDetails.roleScreenRef.role.name == '4dot5Admin') {
                            data.body.forEach(function (element) {
                                if (element.userId == _this.companyManagement.fourDotFiveAdmin.userId) {
                                    element.ticked = true;
                                }
                                else {
                                    element.ticked = false;
                                }
                                _this.fourDotFiveAdminsList.push(element);
                            }, _this);
                        }
                        else {
                            console.log('Pushing: ');
                            _this.fourDotFiveAdminsList.push(_this.companyManagement.fourDotFiveAdmin);
                        }
                        _this.get4Dot5AdminFullName();
                        _this.getUserConfiguration();
                    }, function (error) {
                        if (_this.$rootScope.isOnline) {
                            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                        }
                        //INDUSTRY CODE                            getIndustryGroups();
                    });
                }
                else if (_this.isSuperUser(_this.$rootScope.userDetails.roleScreenRef.role) && (_this.companyManagement.fourDotFiveAdmin == null)) {
                    //This is satisfied when a company has is saved as a draft company and hence 4dot5 admin is still not assigned.
                    _this.get4dot5admins();
                }
                if (data.body.contactList.length > 1) {
                    //This condition is satisfied when the selected company has Secondary Contact assigned and hence it has to be shown.
                    _this.showRemoveButton = true;
                    //Setting phone number values to be true.
                    _this.isValidSecondaryWorkPhoneEntered = true;
                    _this.isValidSecondaryMobileEntered = true;
                }
            }, function (error) {
                if (_this.$rootScope.isOnline) {
                    _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                }
            });
            this.hostCompanySelected = false;
            this.companyDetailsUpdateMode = false;
            this.companyDetailsUpdateModeByCompanyAdmin = false;
            this.assessmentOrJobBoardCredentialsUpdated = false;
            this.showCreateCompanyHeading = false;
            if (this.$rootScope.userDetails.roleScreenRef.role.name == '4dot5SuperUser' || this.$rootScope.userDetails.roleScreenRef.role.name == '4dot5Admin') {
                //This condition is satisfied when user has access to edit the company details.
                console.log('Enabling all');
                this.companyDetailsUpdateMode = true;
                this.showCreateCompanyHeading = false;
                this.StorageService.remove('wizardoperations');
                this.$timeout(function () {
                    angular.element('.access').attr({ 'readonly': false, 'disabled': false });
                }, 500);
            }
            else {
                //This condition is satisfied when user doesnot have access to edit the company details and hence all fields are disabled.
                this.companyDetailsUpdateModeByCompanyAdmin = true;
                this.$timeout(function () {
                    angular.element('.access').attr({ 'readonly': true, 'disabled': true });
                    angular.element('.hostaccess').attr({ 'readonly': true, 'disabled': true });
                }, 500);
            }
            this.accessMode = angular.copy(this.$stateParams.accessMode);
        }
        else if (this.StorageService.get('SelectedHostCompany') != null) {
            //This condition is satisfied when selected company is a host company.
            console.log('Details of Host company');
            this.companyDetailsUpdateMode = false;
            this.hostCompanySelected = true;
            this.TypeOfCompany = 'Host';
            this.genericService.getObjects(this.COMPANYMANAGEMENTCONSTANTS.CONTROLLER.GET_COMPANY + '/' + this.StorageService.get('SelectedHostCompany').companyId).subscribe(function (data) {
                _this.companyManagement = data.body;
                _this.CompanyManagementReset = angular.copy(_this.companyManagement);
                console.log('this.CompanyManagementReset  ' + angular.toJson(_this.CompanyManagementReset.fourDotFiveAdmin));
                _this.savedCompanyManagement.company = angular.copy(_this.companyManagement.company);
                _this.savedCompanyManagement.contactList = angular.copy(_this.companyManagement.contactList);
                _this.getAddressDetails(data.body.company.zipcode, 'updateaddress');
                _this.originalStepOne = angular.copy(_this.companyManagement.company);
                console.log('this.originalStepOne  ' + angular.toJson(_this.originalStepOne));
                // INDUSTRY CODE                 delete this.originalStepOne['industryGroup'];
                // INDUSTRY CODE               delete this.originalStepOne['industryList'];
                _this.originalStepTwo = angular.copy(_this.companyManagement.contactList);
                _this.originalStepFive = angular.copy(_this.companyManagement.licensePreferences);
                //Updating the SavedCompanyManagement object after getting company details.
                _this.savedAssessmentWorkFlow = angular.copy(_this.companyManagement.licensePreferences);
                //  INDUSTRY CODE    this.SelectedIndustrySubList = angular.copy(this.companyManagement.company.industryList);
                _this.AssessmentWorkFlow = _this.companyManagement.licensePreferences;
                _this.accessMode = angular.copy(_this.$stateParams.accessMode);
                if (data.body.contactList.length > 1) {
                    //This condition is satisfied when the selected company has Secondary Contact assigned and hence it has to be shown.
                    _this.showRemoveButton = true;
                }
                if (_this.$rootScope.userDetails.roleScreenRef.role.name == '4dot5SuperUser' || _this.$rootScope.userDetails.roleScreenRef.role.name == '4dot5Admin') {
                    console.log('Enabling all');
                    _this.companyDetailsUpdateMode = true;
                    _this.showCreateCompanyHeading = false;
                    _this.StorageService.remove('wizardoperations');
                    _this.$timeout(function () {
                        angular.element('.access').attr({ 'readonly': true, 'disabled': true });
                        angular.element('.hostaccess').attr({ 'readonly': true, 'disabled': true });
                    }, 500);
                }
                else {
                    _this.$timeout(function () {
                        angular.element('.access').attr({ 'readonly': true, 'disabled': true });
                        angular.element('.hostaccess').attr({ 'readonly': true, 'disabled': true });
                    }, 500);
                }
                // INDUSTRY CODE     getIndustryGroups();
            }, function (error) {
                if (_this.$rootScope.isOnline) {
                    _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                }
            });
        }
        this.$scope.$watchCollection("form.companydetailsform", function (newValue, oldValue) {
            if (_this.form.companyDetailsForm.$dirty) {
                _this.cancelNotClicked = true;
            }
        });
    };
    CompanyPageController.prototype._saveStepOne = function (data) {
        console.log('this.CompanyManagementReset  ' + angular.toJson(this.CompanyManagementReset.fourDotFiveAdmin));
        this.savedCompanyManagement.company = angular.copy(this.companyManagement.company);
        this.savedCompanyManagement.contactList = angular.copy(this.companyManagement.contactList);
        //set phone validation statuses
        if (this.companyManagement.contactList.length == 0) {
            this.showRemoveButton = false;
        }
        for (var i = 0; i < this.companyManagement.contactList.length; i++) {
            if (i > 0) {
                var validationStatus = {
                    emptyWorkNumber: false,
                    invalidWorkNumber: false,
                    isValidWorkNumber: false,
                    emptyMobileNumber: false,
                    invalidMobileNumber: false,
                    isValidMobileNumber: false
                };
                this.phoneValidationStatuses.push(validationStatus);
            }
        }
        //As its a draft there should not be exception as duplicate client while saving.
        this.savedCompanyManagement.companyState = angular.copy(this.companyManagement.companyState);
        console.log('client : ' + this.companyManagement);
        this.editCompanyName = this.companyManagement.company.name.substring(0, 57);
        this.editCompanyNameOnHover = this.companyManagement.company.name;
        if (this.companyManagement.company.name.length > 57) {
            this.editCompanyName = this.editCompanyName + '...';
        }
        this.getAddressDetails(this.companyManagement.company.zipcode, 'updateaddress');
        this.StorageService.remove('clientOrBuToBeUpdated');
        this.originalStepOne = angular.copy(this.companyManagement.company);
        this.originalStepTwo = angular.copy(this.companyManagement.contactList);
        if (this.companyManagement.contactList.length > 1) {
            this.showRemoveButton = true;
            this.isValidPrimaryMobileEntered = true;
            this.isValidPrimaryWorkPhoneEntered = true;
            this.isValidSecondaryMobileEntered = true;
            this.isValidSecondaryWorkPhoneEntered = true;
            angular.forEach(this.phoneValidationStatuses, function (status, key) {
                status.isValidWorkNumber = true;
                status.isValidMobileNumber = true;
            });
        }
        else if (this.companyManagement.contactList.length == 1) {
            this.isValidPrimaryMobileEntered = true;
            this.isValidPrimaryWorkPhoneEntered = true;
        }
    };
    CompanyPageController.prototype._getSharedClientDescription = function (clientId, successCallback) {
        var _this = this;
        var companyId = this.$rootScope.userDetails.company.companyId;
        this.companyService.getSharedClientDescription(companyId, clientId, function (data) {
            if (successCallback) {
                successCallback(data);
            }
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, "danger");
        });
    };
    CompanyPageController.prototype._setSharedClientDescription = function (successCallback, errorCallback) {
        var descriptionDetails = {
            companyId: this.$rootScope.userDetails.company.companyId,
            clientId: this.companyManagement.company.id,
            note: this.companyManagement.company.description
        };
        this.companyService.setSharedClientDescription(descriptionDetails, function (data) {
            if (successCallback) {
                successCallback(data);
            }
        }, function (error) {
            if (errorCallback) {
                errorCallback();
            }
        });
    };
    /**
     * This method works for triggerng button clicks on save button
     *  only for on blur validations
     */
    CompanyPageController.prototype.saveButtonTrigger = function () {
        var _this = this;
        console.log('this.saveButtonTrigger');
        var saveButtonClick = this.$timeout(function () {
            angular.element('.btn-save').triggerHandler('click');
        }, 0).then(function () {
            _this.saveButtonClicked = false;
            _this.nextButtonClicked = false;
            _this.$timeout.cancel(saveButtonClick);
        });
    };
    CompanyPageController.prototype.stepMoved = function ($index, jobType) {
        this.workflowStepsOrderToRender[jobType].splice($index, 1);
    };
    /**
     * This method works for triggerng button clicks on save button
     *  only for on blur validations
     */
    CompanyPageController.prototype.nextButtonTrigger = function () {
        var _this = this;
        var nextbtnclick = this.$timeout(function () {
            console.log('triggering next button click');
            angular.element('.btn-next').triggerHandler('click');
        }, 0).then(function () {
            console.log('in this.nextButtonTrigger callback');
            _this.zipCodeCalling = false;
            _this.zipCodeCallCompleted = false;
            _this.nextButtonClicked = false;
            _this.saveButtonClicked = false;
            _this.triggerCount = 0;
            _this.$timeout.cancel(nextbtnclick);
        });
    };
    CompanyPageController.prototype.onSlideClick = function (direction) {
        if (direction == 'right') {
            event.preventDefault();
            $('#content').animate({
                scrollLeft: "+=400px"
            }, "slow");
        }
        else {
            event.preventDefault();
            $('#content').animate({
                scrollLeft: "-=400px"
            }, "slow");
        }
    };
    CompanyPageController.prototype.isPrimaryContactWTValid = function (workPhoneValue) {
        if (workPhoneValue !== "") {
            if ($("#maskedWorkPhone").intlTelInput("isValidNumber")) {
                console.log('p WorkTelephone Valid');
                this.isValidPrimaryWorkPhoneEntered = true;
                this.companyManagement.contactList[0].workPhone = this.$filter('phonenumber')(workPhoneValue, this.primaryContactWTFormat);
                this.form.companyContactPersonDetailsForm.maskedWorkPhone.$setValidity('ng-intl-tel-input', true);
            }
            else {
                console.log('p work telephone not valid');
                this.emptyCompanyWorkNumber = false;
                this.invalidCompanyWorkNumber = true;
                this.isValidPrimaryWorkPhoneEntered = false;
                this.primaryWorkTelephoneValueTrim = document.getElementById('maskedWorkPhone').value;
                this.companyManagement.contactList[0].workPhone = this.primaryWorkTelephoneValueTrim.replace(/ |-/gm, '');
                console.log(this.companyManagement.contactList[0].workPhone);
                this.form.companyContactPersonDetailsForm.maskedWorkPhone.$setValidity('ng-intl-tel-input', false);
            }
        }
        else {
            this.emptyCompanyWorkNumber = true;
            this.invalidCompanyWorkNumber = false;
            console.log('CompanyWorkNumber empty');
            this.isValidPrimaryWorkPhoneEntered = false;
        }
    };
    CompanyPageController.prototype.isPrimaryContactWTValid1 = function (mobileNumberValue) {
        if (mobileNumberValue !== "") {
            this.form.companyContactPersonDetailsForm.maskedWorkPhone1.visited = true;
            if ($("#maskedWorkPhone1").intlTelInput("isValidNumber")) {
                console.log('p WorkTelephone1 Valid');
                this.isValidPrimaryMobileEntered = true;
                this.companyManagement.contactList[0].mobilePhone = this.$filter('phonenumber')(mobileNumberValue, this.primaryContactWTFormat1);
                this.form.companyContactPersonDetailsForm.maskedWorkPhone1.$setValidity('ng-intl-tel-input', true);
            }
            else {
                console.log('p work telephone1 not valid');
                this.emptyCompanyMobileNumber = false;
                this.invalidCompanyMobileNumber = true;
                this.primaryMobileTelephoneValueTrim = document.getElementById('maskedWorkPhone1').value;
                this.companyManagement.contactList[0].mobilePhone = this.primaryMobileTelephoneValueTrim.replace(/ |-/gm, '');
                console.log(this.companyManagement.contactList[0].mobilePhone);
                this.form.companyContactPersonDetailsForm.maskedWorkPhone1.$setValidity('ng-intl-tel-input', false);
                this.isValidPrimaryMobileEntered = false;
            }
        }
        else {
            this.emptyCompanyMobileNumber = true;
            this.invalidCompanyMobileNumber = false;
            console.log('mobileNumberValue empty');
            this.isValidPrimaryMobileEntered = false;
        }
    };
    /**
     *  This is to handle long string
     */
    CompanyPageController.prototype.get4Dot5AdminFullName = function () {
        for (var p = 0; p < this.fourDotFiveAdminsList.length; p++) {
            if (this.fourDotFiveAdminsList[p].lastName != null) {
                var output = this.fourDotFiveAdminsList[p].firstName + " " + this.fourDotFiveAdminsList[p].lastName;
            }
            else {
                var output = this.fourDotFiveAdminsList[p].firstName;
            }
            if (output.length > 57) {
                this.fourDotFiveAdminsList[p]["fullName"] = output.substring(0, 57) + "...";
            }
            else {
                this.fourDotFiveAdminsList[p]["fullName"] = output;
            }
        }
    };
    CompanyPageController.prototype.setPrimaryContactWTCountryCode = function () {
        var _this = this;
        $("#maskedWorkPhone").intlTelInput("setCountry", this.primaryContactWTCountryCode);
        this.primaryContactWTFormat = document.getElementById("maskedWorkPhone").placeholder;
        var maskValidator = [];
        for (var index = 0; index < this.primaryContactWTFormat.length; index++) {
            if (angular.isNumber(this.primaryContactWTFormat[index])) {
                console.log('Num: ' + this.primaryContactWTFormat[index]);
            }
            else {
                console.log('Char: ' + this.primaryContactWTFormat[index]);
            }
        }
        this.$timeout(function () {
            _this.isPrimaryContactWTValid(_this.companyManagement.contactList[0].workPhone);
        }, 500);
    };
    CompanyPageController.prototype.setPrimaryContactWTCountryCode1 = function () {
        $("#maskedWorkPhone1").intlTelInput("setCountry", this.primaryContactWTCountryCode1);
        this.primaryContactWTFormat1 = document.getElementById("maskedWorkPhone1").placeholder;
        this.isPrimaryContactWTValid1(this.companyManagement.contactList[0].mobilePhone);
    };
    CompanyPageController.prototype.setPrimaryContactMNCountryCode = function () {
        var _this = this;
        $("#maskedMobilePhone").intlTelInput("setCountry", this.primaryContactMNCountryCode);
        this.primaryContactMNFormat = document.getElementById("maskedMobilePhone").placeholder;
        this.$timeout(function () {
            _this.isPrimaryContactMNValid();
        }, 500);
    };
    CompanyPageController.prototype.setPrimaryContactNExamples = function () {
        this.primaryContactWTFormat = document.getElementById("maskedWorkPhone").placeholder;
        this.primaryContactWTFormat1 = document.getElementById("maskedWorkPhone1").placeholder;
        this.primaryContactMNFormat = document.getElementById("maskedMobilePhone").placeholder;
    };
    CompanyPageController.prototype.isSecondaryContactWTValid = function (secondaryWorkNumberValue) {
        if (secondaryWorkNumberValue !== "") {
            this.form.companySecondaryContactPersonDetailsForm.maskedWorkPhoneSecondary.visited = true;
            if ($("#maskedWorkPhoneSecondary").intlTelInput("isValidNumber")) {
                console.log('p maskedWorkPhoneSecondary Valid');
                this.companyManagement.contactList[1].workPhone = this.$filter('phonenumber')(secondaryWorkNumberValue, this.secondaryContactWTFormat);
                this.form.companySecondaryContactPersonDetailsForm.maskedWorkPhoneSecondary.$setValidity('ng-intl-tel-input', true);
                this.isValidSecondaryWorkPhoneEntered = true;
            }
            else {
                this.emptyCompanySecondaryWorkNumber = false;
                this.invalidCompanySecondaryWorkNumber = true;
                this.isValidSecondaryWorkPhoneEntered = false;
                this.secondaryWorkTelephoneValueTrim = document.getElementById('maskedWorkPhoneSecondary').value;
                this.companyManagement.contactList[1].workPhone = this.secondaryWorkTelephoneValueTrim.replace(/ |-/gm, '');
                this.form.companySecondaryContactPersonDetailsForm.maskedWorkPhoneSecondary.$setValidity('ng-intl-tel-input', false);
            }
        }
        else {
            this.emptyCompanySecondaryWorkNumber = true;
            this.invalidCompanySecondaryWorkNumber = false;
            this.isValidSecondaryWorkPhoneEntered = false;
        }
    };
    CompanyPageController.prototype.isContactWTValid = function (workNumber, index) {
        var selectorId = "#contactWorkPhone" + index;
        var id = "contactWorkPhone" + index;
        if (workNumber !== "") {
            if ($(selectorId).intlTelInput("isValidNumber")) {
                console.log("p maskedWorkPhoneContact " + index + " Valid");
                this.companyManagement.contactList[index].workPhone = this.$filter('phonenumber')(workNumber, this.secondaryContactWTFormat);
                this.phoneValidationStatuses[index - 1].isValidWorkNumber = true;
            }
            else {
                this.phoneValidationStatuses[index - 1].emptyWorkNumber = false;
                this.phoneValidationStatuses[index - 1].invalidWorkNumber = true;
                this.phoneValidationStatuses[index - 1].isValidWorkNumber = false;
                var contactWorkTelephoneValueTrim = document.getElementById(id).value;
                this.companyManagement.contactList[index].workPhone = contactWorkTelephoneValueTrim.replace(/ |-/gm, '');
            }
        }
        else {
            this.phoneValidationStatuses[index - 1].emptyWorkNumber = true;
            this.phoneValidationStatuses[index - 1].invalidWorkNumber = false;
            this.phoneValidationStatuses[index - 1].isValidWorkNumber = false;
        }
    };
    CompanyPageController.prototype.isSecondaryContactMNValid = function (secondaryMobileNumberValue) {
        if (secondaryMobileNumberValue !== "") {
            this.form.companySecondaryContactPersonDetailsForm.maskedMobilePhoneSecondary.visited = true;
            if ($("#maskedMobilePhoneSecondary").intlTelInput("isValidNumber")) {
                this.isValidSecondaryMobileEntered = true;
                this.companyManagement.contactList[1].mobilePhone = this.$filter('phonenumber')(secondaryMobileNumberValue, this.secondaryContactMNFormat);
                this.form.companySecondaryContactPersonDetailsForm.maskedMobilePhoneSecondary.$setValidity('ng-intl-tel-input', true);
            }
            else {
                this.emptyCompanySecondaryMobilePhone = false;
                this.invalidCompanySecondaryMobilePhone = true;
                this.isValidSecondaryMobileEntered = false;
                this.secondaryMobileTelephoneValueTrim = document.getElementById('maskedMobilePhoneSecondary').value;
                this.companyManagement.contactList[1].mobilePhone = this.secondaryMobileTelephoneValueTrim.replace(/ |-/gm, '');
                this.form.companySecondaryContactPersonDetailsForm.maskedMobilePhoneSecondary.$setValidity('ng-intl-tel-input', false);
            }
        }
        else {
            this.emptyCompanySecondaryMobilePhone = true;
            this.invalidCompanySecondaryMobilePhone = false;
            this.isValidSecondaryMobileEntered = false;
        }
    };
    CompanyPageController.prototype.isContactMNValid = function (mobileNumber, index) {
        if (mobileNumber !== "") {
            var selectorId = "#contactMobilePhone" + index;
            var id = "contactMobilePhone" + index;
            if ($(selectorId).intlTelInput("isValidNumber")) {
                this.phoneValidationStatuses[index - 1].isValidMobileNumber = true;
                this.companyManagement.contactList[index].mobilePhone = this.$filter('phonenumber')(mobileNumber, this.secondaryContactMNFormat);
            }
            else {
                this.phoneValidationStatuses[index - 1].emptyMobileNumber = false;
                this.phoneValidationStatuses[index - 1].invalidMobileNumber = true;
                this.phoneValidationStatuses[index - 1].isValidMobileNumber = false;
                var contactMobileTelephoneValueTrim = document.getElementById(id).value;
                this.companyManagement.contactList[index].mobilePhone = contactMobileTelephoneValueTrim.replace(/ |-/gm, '');
            }
        }
        else {
            this.phoneValidationStatuses[index - 1].emptyMobileNumber = true;
            this.phoneValidationStatuses[index - 1].invalidMobileNumber = false;
            this.phoneValidationStatuses[index - 1].isValidMobileNumber = false;
        }
    };
    CompanyPageController.prototype.setSecondaryContactWTCountryCode = function () {
        var _this = this;
        $("#maskedWorkPhoneSecondary").intlTelInput("setCountry", this.secondaryContactWTCountryCode);
        this.secondaryContactWTFormat = document.getElementById("maskedWorkPhoneSecondary").placeholder;
        this.$timeout(function () {
            _this.isSecondaryContactWTValid(document.getElementById("maskedWorkPhoneSecondary").value);
        }, 500);
    };
    CompanyPageController.prototype.setSecondaryContactMNCountryCode = function () {
        var _this = this;
        $("#maskedMobilePhoneSecondary").intlTelInput("setCountry", this.secondaryContactMNCountryCode);
        this.secondaryContactMNFormat = document.getElementById("maskedMobilePhoneSecondary").placeholder;
        this.$timeout(function () {
            _this.isSecondaryContactMNValid(document.getElementById("maskedMobilePhoneSecondary").value);
        }, 500);
    };
    CompanyPageController.prototype.setSecondaryContactNExamples = function () {
        this.secondaryContactWTFormat = document.getElementById("maskedWorkPhoneSecondary").placeholder;
        this.secondaryContactMNFormat = document.getElementById("maskedMobilePhoneSecondary").placeholder;
    };
    CompanyPageController.prototype.getCurrentStep = function () {
        return $('#myWizard').wizard('selectedItem').step;
    };
    CompanyPageController.prototype.isUserManagementTabActive = function () {
        var stepIndex = $('#myWizard').wizard('selectedItem').step;
        return stepIndex == 3;
    };
    CompanyPageController.prototype.single = function () {
        //console.log('image : '+angular.toJson(this.profilePic));
    };
    CompanyPageController.prototype.cleanContactList = function () {
        // for(var i = 0; i < this.companyManagement.contactList.length; i++) {
        //     if(this.companyManagement.contactList[i].isHiringManager == true && this.companyManagement.contactList[i].firstName == undefined && this.companyManagement.contactList[i].workPhone == undefined && this.companyManagement.contactList[i].mobilePhone == undefined) {
        //         this.companyManagement.contactList.splice(i, 1);
        //     }
        // }
        for (var i = 0; i < this.companyManagement.contactList.length; i++) {
            if (this.companyManagement.contactList[i].primary !== undefined) {
                delete this.companyManagement.contactList[i].primary;
            }
        }
        for (var i = 0; i < this.savedCompanyManagement.contactList.length; i++) {
            if (this.savedCompanyManagement.contactList[i].isHiringManager == true && this.savedCompanyManagement.contactList[i].firstName == undefined && this.savedCompanyManagement.contactList[i].workPhone == undefined && contact.mobilePhone == undefined) {
                this.savedCompanyManagement.contactList.splice(i, 1);
            }
        }
        for (var i = 0; i < this.savedCompanyManagement.contactList.length; i++) {
            if (this.savedCompanyManagement.contactList[i].primary !== undefined) {
                delete this.savedCompanyManagement.contactList[i].primary;
            }
        }
        if (this.originalStepTwo) {
            for (var i = 0; i < this.originalStepTwo.length; i++) {
                if (this.originalStepTwo[i].primary !== undefined) {
                    delete this.originalStepTwo[i].primary;
                }
            }
        }
    };
    /**
     * This method is called during company update,host company update, client update and if address is changed and cancel is clicked in step 1.
     * This would be sent over HTTPS if the page is served via HTTPS
     */
    CompanyPageController.prototype.getAddressDetails = function (zipcode, type, callback) {
        var _this = this;
        if (angular.isDefined(this.form.companyDetailsForm.zipcode) && this.form.companyDetailsForm.zipcode.$valid) {
            this.validzipcode = true;
        }
        else {
            this.validzipcode = false;
        }
        this.cities = [];
        this.states = [];
        this.counties = [];
        this.countries = [];
        var locations = [];
        if (type != 'copycomanyaddress') {
            document.getElementById("copyCompanyAddress").checked = false;
        }
        this.copyCompanyAddress = false;
        var url = 'maps.googleapis.com/maps/api/geocode/json?address=' + zipcode + '&key=' + this.MESSAGECONSTANTS.GEOCODING.API_KEY;
        if (angular.isDefined(zipcode) && !angular.equals(zipcode, '')) {
            console.log('validzipcode calling google api');
            $.getJSON({
                url: 'https://maps.googleapis.com/maps/api/geocode/json?address=' + zipcode + '&key=' + this.MESSAGECONSTANTS.GEOCODING.API_KEY,
                data: {
                    sensor: false,
                },
                success: function (data, textStatus) {
                    console.log('Data: ' + data.status + ' textStatus: ' + textStatus);
                    var createGeoLocation = function (addressdetails, postalname) {
                        console.log(' addressdetails ' + angular.toJson(addressdetails) + 'postalname ' + angular.toJson(postalname));
                        var addressobj = {};
                        for (var p = 0; p < addressdetails.address_components.length; p++) {
                            for (var t = 0; t < addressdetails.address_components[p].types.length; t++) {
                                switch (addressdetails.address_components[p].types[t]) {
                                    case 'country':
                                        addressobj.country = addressdetails.address_components[p].long_name;
                                        addressobj.countryCode = addressdetails.address_components[p].short_name;
                                        break;
                                    case 'administrative_area_level_2':
                                        addressobj.county = addressdetails.address_components[p].long_name;
                                        break;
                                    case 'administrative_area_level_1':
                                        addressobj.state = addressdetails.address_components[p].long_name;
                                        break;
                                    case 'locality':
                                        if (angular.isDefined(postalname) && postalname !== '') {
                                            addressobj.city = postalname;
                                        }
                                        else {
                                            addressobj.city = addressdetails.address_components[p].long_name;
                                        }
                                        break;
                                    default:
                                        break;
                                }
                            }
                        }
                        if (angular.isUndefined(addressobj.city) || angular.isUndefined(addressobj.state) || angular.isUndefined(addressobj.country)) {
                            for (var p = 0; p < addressdetails.address_components.length; p++) {
                                for (var t = 0; t < addressdetails.address_components[p].types.length; t++) {
                                    switch (addressdetails.address_components[p].types[t]) {
                                        case 'locality':
                                            if (angular.isUndefined(addressobj.state)) {
                                                addressobj.state = addressdetails.address_components[p].long_name;
                                            }
                                            if (angular.isUndefined(addressobj.country)) {
                                                addressobj.country = addressdetails.address_components[p].long_name;
                                                addressobj.countryCode = addressdetails.address_components[p].short_name;
                                            }
                                            break;
                                        case 'administrative_area_level_2':
                                            if (angular.isUndefined(addressobj.city)) {
                                                if (angular.isDefined(postalname) && postalname !== '') {
                                                    addressobj.city = postalname;
                                                }
                                                else {
                                                    addressobj.city = addressdetails.address_components[p].long_name;
                                                }
                                            }
                                            if (angular.isUndefined(addressobj.state)) {
                                                addressobj.state = addressdetails.address_components[p].long_name;
                                            }
                                            if (angular.isUndefined(addressobj.country)) {
                                                addressobj.country = addressdetails.address_components[p].long_name;
                                                addressobj.countryCode = addressdetails.address_components[p].short_name;
                                            }
                                            break;
                                        case 'administrative_area_level_3':
                                            if (angular.isUndefined(addressobj.city)) {
                                                if (angular.isDefined(postalname) && postalname !== '') {
                                                    addressobj.city = postalname;
                                                }
                                                else {
                                                    addressobj.city = addressdetails.address_components[p].long_name;
                                                }
                                            }
                                            break;
                                        case 'administrative_area_level_4':
                                            if (angular.isUndefined(addressobj.city)) {
                                                if (angular.isDefined(postalname) && postalname !== '') {
                                                    addressobj.city = postalname;
                                                }
                                                else {
                                                    addressobj.city = addressdetails.address_components[p].long_name;
                                                }
                                            }
                                            break;
                                        case 'sublocality' || 'sublocality_level_1' || 'sublocality_level_5':
                                            if (angular.isDefined(postalname) && postalname !== '') {
                                                addressobj.city = postalname;
                                            }
                                            else {
                                                addressobj.city = addressdetails.address_components[p].long_name;
                                            }
                                            break;
                                        case 'administrative_area_level_1':
                                            if (angular.isUndefined(addressobj.city)) {
                                                if (angular.isDefined(postalname) && postalname !== '') {
                                                    addressobj.city = postalname;
                                                }
                                                else {
                                                    addressobj.city = addressdetails.address_components[p].long_name;
                                                }
                                                if (angular.isUndefined(addressobj.country)) {
                                                    addressobj.country = addressdetails.address_components[p].long_name;
                                                    addressobj.countryCode = addressdetails.address_components[p].short_name;
                                                }
                                            }
                                            break;
                                    }
                                }
                            }
                        }
                        return addressobj;
                    };
                    var checkCountyExists = function (locations, company) {
                        for (var i = 0; i < locations.length; i++) {
                            if (angular.equals(locations[i].city, company.city) &&
                                angular.isDefined(locations[i].county) && (locations.county !== null) &&
                                angular.isDefined(company.county) &&
                                (company.county !== null) && angular.equals(locations[i].county, company.county)) {
                                return true;
                            }
                        }
                        return false;
                    };
                    console.log('data : ' + angular.toJson(data));
                    if (data.status === 'OK') {
                        console.log('OK....');
                        _this.validzipcode = true;
                        console.log('validzipcode 699' + _this.validzipcode);
                        for (var i = 0; i < data.results.length; i++) {
                            if (angular.isDefined(data.results[i].postcode_localities) && (data.results[i].postcode_localities.length > 0)) {
                                for (var k = 0; k < data.results[i].postcode_localities.length; k++) {
                                    if ((data.results[i].types[0] === 'postal_code')) {
                                        console.log('entered zipcode is a postal code');
                                        var location = createGeoLocation(data.results[i], data.results[i].postcode_localities[k]);
                                        locations.push(angular.copy(location));
                                    }
                                    else {
                                        console.log('entered zipcode is not a postal code');
                                    }
                                }
                            }
                            else {
                                if ((data.results[i].types[0] === 'postal_code')) {
                                    console.log('entered zipcode is a postal code');
                                    var location = createGeoLocation(data.results[i]);
                                    locations.push(angular.copy(location));
                                }
                                else {
                                    console.log('entered zipcode is not a postal code');
                                }
                            }
                        }
                        _this.temp = locations;
                        if (locations.length) {
                            _this.temp.city = locations[0].city;
                            _this.temp.addressState = locations[0].state;
                            console.log('locations[0].county  ' + locations[0].county);
                            _this.temp.county = (angular.isUndefined(locations[0].county)) ? null : locations[0].county;
                            if (angular.isDefined(locations[0].county) && (locations[0].county !== null)) {
                                _this.isCountyExists = true;
                            }
                            else {
                                _this.isCountyExists = false;
                            }
                            _this.temp.country = locations[0].country;
                            _this.temp.countryCode = locations[0].countryCode;
                            console.log('temp  ' + angular.toJson(location));
                            _this.zipCodeCallCompleted = true;
                        }
                        console.log('this.cancelClicked : ' + _this.cancelClicked + ' type is: ' + type + '  this.temp' + angular.toJson(_this.temp));
                        if ((type === 'createaddress' || type === 'copycomanyaddress') && !_this.cancelClicked && locations.length) {
                            console.log('in createaddress');
                            _this.companyManagement.company.city = locations[0].city;
                            _this.companyManagement.company.addressState = locations[0].state;
                            _this.companyManagement.company.county = (angular.isUndefined(locations[0].county)) ? null : locations[0].county;
                            if (angular.isDefined(locations[0].county) && (locations[0].county !== null)) {
                                _this.isCountyExists = true;
                            }
                            else {
                                _this.isCountyExists = false;
                            }
                            _this.companyManagement.company.country = locations[0].country;
                            _this.companyManagement.company.countryCode = locations[0].countryCode;
                            _this.validzipcode = true;
                            _this.zipCodeCallCompleted = true;
                        }
                        else if (type === 'zipchanged' && !_this.cancelClicked && locations.length) {
                            console.log('in zipchanged............');
                            _this.companyManagement.company.city = locations[0].city;
                            _this.companyManagement.company.addressState = locations[0].state;
                            _this.companyManagement.company.county = (angular.isUndefined(locations[0].county)) ? null : locations[0].county;
                            if (angular.isDefined(locations[0].county) && (locations[0].county !== null)) {
                                _this.isCountyExists = true;
                            }
                            else {
                                _this.isCountyExists = false;
                            }
                            _this.companyManagement.company.country = locations[0].country;
                            _this.companyManagement.company.countryCode = locations[0].countryCode;
                            _this.validzipcode = true;
                            _this.zipCodeCallCompleted = true;
                        }
                        else if (type === 'updateaddress' && !_this.cancelClicked && locations.length) {
                            _this.zipCodeCallCompleted = true;
                        }
                        else if (_this.cancelClicked) {
                            locations = angular.copy(_this.temp);
                            _this.geoLocations = angular.copy(_this.temp);
                            _this.geoLocationscopy = angular.copy(_this.copyOfGeoLocations);
                            _this.companyManagement.company.city = _this.originalStepOne.city;
                            _this.companyManagement.company.addressState = _this.originalStepOne.addressState;
                            _this.companyManagement.company.county = _this.originalStepOne.county;
                            if (checkCountyExists(angular.copy(locations), angular.copy(_this.originalStepOne))) {
                                _this.isCountyExists = true;
                            }
                            else {
                                _this.isCountyExists = false;
                            }
                            _this.companyManagement.company.country = _this.originalStepOne.country;
                            _this.companyManagement.company.country = _this.originalStepOne.countryCode;
                            _this.validzipcode = true;
                            _this.zipCodeCallCompleted = true;
                            console.log('after setting location ' + angular.toJson(_this.geoLocations));
                            console.log('after setting geo loc ' + angular.toJson(_this.copyOfGeoLocations));
                        }
                        else if (locations.length) {
                            if (checkCountyExists(angular.copy(locations), angular.copy(_this.originalStepOne))) {
                                _this.isCountyExists = true;
                            }
                            else {
                                _this.isCountyExists = false;
                            }
                            if (angular.isDefined(_this.originalStepTwo[0]) && angular.isDefined(_this.originalStepTwo[0].workPhone)) {
                                _this.companyManagement.contactList[0].workPhone = angular.copy(_this.originalStepTwo[0].workPhone);
                                _this.companyManagement.contactList[0].mobilePhone = angular.copy(_this.originalStepTwo[0].mobilePhone);
                            }
                            if (angular.isDefined(_this.originalStepTwo[1]) && angular.isDefined(_this.originalStepTwo[1].workPhone)) {
                                _this.companyManagement.contactList[1].workPhone = angular.copy(_this.originalStepTwo[1].workPhone);
                                _this.companyManagement.contactList[1].mobilePhone = angular.copy(_this.originalStepTwo[1].mobilePhone);
                            }
                            var elements = angular.element("#maskedMobilePhone");
                            angular.forEach(elements, function (element) {
                                _this.$compile(element)(_this.$scope);
                            });
                            _this.zipCodeCallCompleted = true;
                        }
                    }
                    else if (data.status === 'ZERO_RESULTS') {
                        _this.validzipcode = false;
                        console.log('Setting false: ' + _this.companyManagement.company.zipcode);
                        if (!_this.cancelClicked) {
                            console.log('if ');
                            _this.validzipcode = false;
                            if (!_this.invalidZipcode) {
                                _this.invalidZipcode = true;
                            }
                            locations = [];
                            _this.companyManagement.company.city = '';
                            _this.companyManagement.company.addressState = '';
                            _this.companyManagement.company.county = '';
                            _this.isCountyExists = false;
                            _this.companyManagement.company.country = '';
                            _this.companyManagement.company.countryCode = '';
                            _this.zipCodeCallCompleted = true;
                        }
                        else {
                            locations = angular.copy(_this.copyOfGeoLocations);
                            _this.geoLocations = angular.copy(_this.copyOfGeoLocations);
                            _this.geoLocationscopy = angular.copy(_this.copyOfGeoLocations);
                            _this.companyManagement.company.city = _this.originalStepOne.city;
                            _this.companyManagement.company.addressState = _this.originalStepOne.addressState;
                            _this.companyManagement.company.county = _this.originalStepOne.county;
                            if (checkCountyExists(angular.copy(locations), angular.copy(_this.originalStepOne))) {
                                _this.isCountyExists = true;
                            }
                            else {
                                _this.isCountyExists = false;
                            }
                            _this.companyManagement.company.country = _this.originalStepOne.country;
                            _this.companyManagement.company.countryCode = _this.originalStepOne.countryCode;
                            _this.zipCodeCallCompleted = true;
                        }
                    }
                    _this.geoLocations = locations;
                    _this.geoLocationscopy = locations;
                    if (!_this.geoLocations.length) {
                        _this.validzipcode = false;
                        if (!_this.invalidZipcode) {
                            _this.invalidZipcode = true;
                        }
                        _this.companyManagement.company.city = '';
                        _this.companyManagement.company.addressState = '';
                        _this.companyManagement.company.county = '';
                        _this.isCountyExists = false;
                        _this.companyManagement.company.country = '';
                        _this.zipCodeCallCompleted = true;
                    }
                    _this.$scope.$apply();
                    if (typeof callback != "undefined") {
                        return callback(_this.geoLocations);
                    }
                },
                error: function (data) {
                    console.log('Error: ' + angular.toJson(data));
                    _this.invalidZipcode = true;
                    _this.isCountyExists = false;
                    if (typeof callback != "undefined") {
                        return callback('success');
                    }
                }
            });
        }
        else {
            console.log('in else');
            this.geoLocations = [];
            this.isCountyExists = false;
            if (typeof callback != "undefined") {
                return callback('success');
            }
        }
    };
    /**
     * Get Address details.
     */
    CompanyPageController.prototype.getZipCodeDetails = function (zipcode, type) {
        var _this = this;
        this.nextButtonClicked = false;
        this.saveButtonClicked = false;
        if (this.form.companyDetailsForm.zipcode.$valid) {
            if (angular.isDefined(zipcode)) {
                this.cancelClicked = false;
            }
            this.validzipcode = true;
            this.zipCodeCalling = true;
            this.zipCodeCallCompleted = false;
            this.getAddressDetails(zipcode, type, function (response) {
                if (angular.isDefined(_this.savedCompanyManagement.company.county) && (_this.savedCompanyManagement.company.county !== null)
                    && (_this.companyManagement.company.zipcode === _this.savedCompanyManagement.company.zipcode)) {
                    _this.companyManagement.company.county = _this.savedCompanyManagement.company.county;
                    // this.$scope.safeApply();
                }
                if (_this.saveButtonClicked) {
                    _this.saveButtonTrigger();
                }
                else if (_this.nextButtonClicked) {
                    _this.nextButtonTrigger();
                }
            });
        }
        else {
            this.cancelNotClicked = false;
            this.saveButtonClicked = false;
            this.nextButtonClicked = false;
            this.cities = [];
            this.states = [];
            this.counties = [];
            this.countries = [];
            this.geoLocations = [];
            this.geoLocationscopy = [];
            this.companyManagement.company.city = '';
            this.companyManagement.company.addressState = '';
            this.companyManagement.company.county = '';
            this.isCountyExists = false;
            this.companyManagement.company.country = '';
            this.companyManagement.company.countryCode = '';
        }
    };
    CompanyPageController.prototype.isMinimumLengthGreater = function (minValue, maxValue) {
        if (maxValue == 'unlimited') {
            return false;
        }
        else {
            return parseInt(minValue) > parseInt(maxValue);
        }
    };
    CompanyPageController.prototype.isPasswordRestrictionsValid = function () {
        return (!this.companyManagement.userConfiguration.passwordSettings[0].complexityRestrictionEnabled
            || (this.companyManagement.userConfiguration.passwordSettings[0].complexityRestrictionEnabled
                && $('#checkbox-group-user :checkbox:checked').length > 0))
            &&
                (!this.companyManagement.userConfiguration.passwordSettings[1].complexityRestrictionEnabled
                    || (this.companyManagement.userConfiguration.passwordSettings[1].complexityRestrictionEnabled
                        && $('#checkbox-group-administrator :checkbox:checked').length > 0))
            &&
                !this.isMinimumLengthGreater(this.companyManagement.userConfiguration.passwordSettings[0].minimumLength, this.companyManagement.userConfiguration.passwordSettings[0].maximumLength)
            &&
                !this.isMinimumLengthGreater(this.companyManagement.userConfiguration.passwordSettings[1].minimumLength, this.companyManagement.userConfiguration.passwordSettings[1].maximumLength);
    };
    /**
     * This method is used to delete company details
     */
    CompanyPageController.prototype.deleteCompanyDetails = function () {
        this.getDeleteCompanyDetails();
    };
    CompanyPageController.prototype.getDeleteCompanyDetails = function () {
        var _this = this;
        this.companyService.getDeleteCompanyInfo(this.$rootScope.userDetails.company.companyId, function (data) {
            _this.changeStateObject = {
                companyId: _this.$rootScope.userDetails.company.companyId,
                companyName: _this.$rootScope.userDetails.company.companyName,
                candidatesCount: data.numberOfCandiddates,
                requisitionsCount: data.numberOfRequisitions,
                usersCount: data.numberOfUsers,
                clientOrBuCount: data.numberOfClientOrBUs
            };
            _this.launchCompanyStateChangeModal('Delete');
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    CompanyPageController.prototype.launchCompanyStateChangeModal = function (changeToState) {
        var _this = this;
        if (changeToState !== 'Delete') {
            this.changeStateObject = {
                companyId: this.$rootScope.userDetails.company.companyId,
                companyName: this.$rootScope.userDetails.company.companyName
            };
        }
        var companyStateChangeModal = this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            component: 'changeCompanyStateModal',
            windowTopClass: 'four-dot-five-modal-small',
            resolve: {
                companyInfo: function () {
                    return _this.changeStateObject;
                },
                changeToState: function () {
                    return changeToState;
                }
            }
        });
        companyStateChangeModal.result.then(function (callbackObject) {
            if (callbackObject.callbackType == 'delete') {
                _this.deleteCompanyDetailsLocally();
            }
            else if (callbackObject.callbackType == 'stateChange') {
                _this.$rootScope.userDetails.company.companyState = changeToState;
                _this.companyService.setCompanyStateLabel();
                _this.StorageService.set('userDetails', angular.copy(_this.$rootScope.userDetails), { 'expires': new Date(Date.now() + _this.$rootScope.tokenvalidity) });
                _this.getCompany(_this.$rootScope.userDetails.company.companyId);
            }
        }, function (dismiss) {
            //do nothing
        });
    };
    CompanyPageController.prototype.deleteCompanyDetailsLocally = function () {
        this.StorageService.remove('companyDetails');
        this.StorageService.remove('SelectedHostCompany');
        this.$rootScope.userDetails.company.companyId = null;
        this.$rootScope.userDetails.company.companyName = null;
        this.$rootScope.userDetails.company.companyType = null;
        this.$rootScope.userDetails.company.companySelected = false;
        this.$rootScope.companyDeletedShowPopup = true;
        console.log('this.$rootScope.companyDeletedShowPopup : ' + this.$rootScope.companyDeletedShowPopup);
        this.StorageService.set('userDetails', angular.copy(this.$rootScope.userDetails), { 'expires': new Date(Date.now() + this.$rootScope.tokenvalidity) });
        this.isCompanyDeleted = true;
        this.$state.go('missioncontrol', null, { reload: true });
    };
    CompanyPageController.prototype.getCompany = function (companyId) {
        var _this = this;
        this.genericService.getObjects(this.COMPANYMANAGEMENTCONSTANTS.CONTROLLER.GET_COMPANY + '/' + companyId).subscribe(function (data) {
            _this.companyManagement = data.body;
            _this.CompanyManagementReset = angular.copy(_this.companyManagement);
            console.log('this.CompanyManagementReset  ' + angular.toJson(_this.CompanyManagementReset.fourDotFiveAdmin));
            //Setting the phone number values to be true
            if (data.body.contactList.length == 1) {
                _this.isValidPrimaryMobileEntered = true;
                _this.isValidPrimaryWorkPhoneEntered = true;
            }
            else if (data.body.contactList.length > 1) {
                _this.isValidPrimaryMobileEntered = true;
                _this.isValidPrimaryWorkPhoneEntered = true;
                _this.isValidSecondaryMobileEntered = true;
                _this.isValidSecondaryWorkPhoneEntered = true;
                angular.forEach(_this.phoneValidationStatuses, function (status, key) {
                    status.isValidWorkNumber = true;
                    status.isValidMobileNumber = true;
                });
            }
            _this.getAddressDetails(data.body.company.zipcode, 'updateaddress');
            _this.originalStepOne = angular.copy(_this.companyManagement.company);
            _this.savedCompanyManagement.company = angular.copy(_this.companyManagement.company);
            console.log('this.originalStepOne  ' + angular.toJson(_this.originalStepOne));
            _this.originalStepTwo = angular.copy(_this.companyManagement.contactList);
            _this.savedCompanyManagement.contactList = angular.copy(_this.companyManagement.contactList);
            _this.originalStepThree = angular.copy(_this.companyManagement.fourDotFiveAdmin);
            _this.savedFourDotFiveAdmin = angular.copy(_this.companyManagement.fourDotFiveAdmin);
            console.log('...................................' + angular.toJson(_this.savedFourDotFiveAdmin));
            if (_this.companyManagement.fourDotFiveAdmin !== null) {
                //This is satisfied when a company has 4dot5 admin assigned.
                _this.oldFourDotFiveAdminId = _this.companyManagement.fourDotFiveAdmin.userId;
                _this.companyManagement.fourDotFiveAdmin.ticked = true;
                _this.originalStepThree.ticked = true;
                _this.fourDotFiveAdminsList = [];
                _this.genericService.getObjects(_this.COMPANYMANAGEMENTCONSTANTS.CONTROLLER.GET_4DOT5_ADMINS).subscribe(function (data) {
                    if (_this.$rootScope.userDetails.roleScreenRef.role.name == '4dot5SuperUser' || _this.$rootScope.userDetails.roleScreenRef.role.name == '4dot5Admin') {
                        data.body.forEach(function (element) {
                            if (element.userId == _this.companyManagement.fourDotFiveAdmin.userId) {
                                element.ticked = true;
                            }
                            else {
                                element.ticked = false;
                            }
                            _this.fourDotFiveAdminsList.push(element);
                        }, _this);
                    }
                    else {
                        console.log('Pushing: ');
                        _this.fourDotFiveAdminsList.push(_this.companyManagement.fourDotFiveAdmin);
                    }
                    _this.get4Dot5AdminFullName();
                }, function (error) {
                    if (_this.$rootScope.isOnline) {
                        _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                    }
                });
            }
            else if (_this.isSuperUser(_this.$rootScope.userDetails.roleScreenRef.role) && (_this.companyManagement.fourDotFiveAdmin == null)) {
                //This is satisfied when a company has is saved as a draft company and hence 4dot5 admin is still not assigned.
                _this.get4dot5admins();
            }
            if (data.body.contactList.length > 1) {
                //This condition is satisfied when the selected company has Secondary Contact assigned and hence it has to be shown.
                _this.showRemoveButton = true;
                //Setting phone number values to be true.
                _this.isValidSecondaryWorkPhoneEntered = true;
                _this.isValidSecondaryMobileEntered = true;
            }
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    CompanyPageController.prototype.unCheckSelected4dot5Admin = function (selectedAdmin) {
        for (var i = 0; i < this.fourDotFiveAdminsList.length; i++) {
            if (this.fourDotFiveAdminsList[i].userId === selectedAdmin.userId) {
                this.fourDotFiveAdminsList[i].ticked = false;
            }
        }
    };
    CompanyPageController.prototype.getUserConfiguration = function (successCallback) {
        var _this = this;
        if (this.companyManagement.userConfiguration == null) {
            this.companyService.getUserConfiguration(function (configurationResponse) {
                _this.companyManagement.userConfiguration = angular.copy(configurationResponse);
                if (successCallback) {
                    successCallback();
                }
            }, function (error) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, "danger");
            });
        }
        else {
            if (successCallback) {
                successCallback();
            }
        }
    };
    /**
     * This method is called to get list of 4dot5 Admins companyId
     */
    CompanyPageController.prototype.get4dot5admins = function () {
        var _this = this;
        this.genericService.getObjects(this.COMPANYMANAGEMENTCONSTANTS.CONTROLLER.GET_4DOT5_ADMINS).subscribe(function (data) {
            _this.fourDotFiveAdminsList = data.body;
            console.log('Get4dot5admins received is : ' + angular.toJson(_this.companyManagement.fourDotFiveAdmin));
            console.log('Original step 3 is : ' + angular.toJson(_this.originalStepThree));
            _this.get4Dot5AdminFullName();
            _this.getUserConfiguration();
            //INDUSTRY CODE         getIndustryGroups();
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
            //INDUSTRY CODE         getIndustryGroups();
        });
    };
    CompanyPageController.prototype.getAllPlans = function () {
        var _this = this;
        this.planService.getAllPlans(this.companyManagement.company.companyType, function (data) {
            _this.plans = data;
            var priority = 0;
            angular.forEach(_this.plans, function (value, key) {
                priority++;
                value.enabled = false;
                value.planActionText = "Choose Plan";
                value.priority = value.plan.toLowerCase() == "vendor only" ? 0 : priority;
            });
            console.log('plans');
            console.log(_this.plans);
            _this.plansCopy = angular.copy(_this.plans);
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    CompanyPageController.prototype.setPlanPriorities = function (planType) {
        var _this = this;
        var priority = 0;
        //assign chosen plan
        if (planType == 'currentPlan') {
            angular.forEach(this.plans, function (plan, key) {
                priority++;
                if (plan.id == _this.selectedPlan.planHeaderDto.planFeaturesCapabilityId) {
                    plan.enabled = true;
                    plan.priority = plan.plan.toLowerCase() == "vendor only" ? 0 : priority;
                    plan.planActionText = "Modify Plan";
                    _this.savedCurrentActivePlanPriority = plan.priority;
                    _this.savedCurrentActivePlanName = plan.plan;
                }
                else {
                    plan.enabled = false;
                    plan.priority = plan.plan.toLowerCase() == "vendor only" ? 0 : priority;
                    plan.planActionText = "Choose Plan";
                }
            });
        }
        else {
            angular.forEach(this.plans, function (plan, key) {
                priority++;
                if (plan.id == _this.futurePlan.planHeaderDto.planFeaturesCapabilityId) {
                    _this.savedFuturePlanPriority = priority;
                }
            });
        }
    };
    CompanyPageController.prototype.setFuturePlanName = function () {
        var _this = this;
        angular.forEach(this.plans, function (plan, key) {
            if (plan.id == _this.futurePlan.planHeaderDto.planFeaturesCapabilityId) {
                _this.futurePlanName = plan.plan;
            }
        });
    };
    /**
     * This method will have a track of which forward recipient is selected
     */
    CompanyPageController.prototype.fourDotFiveAdminChosen = function () {
        if (angular.isDefined(this.companyManagement.fourDotFiveAdmin) && !angular.equals(this.companyManagement.fourDotFiveAdmin, null) && angular.isDefined(this.selectedFourDotFiveAdmin[0])) {
            console.log('this.companyManagement.fourDotFiveAdmin.userId  ' + this.companyManagement.fourDotFiveAdmin.userId + this.companyManagement.fourDotFiveAdmin.firstName + '  ' + this.selectedFourDotFiveAdmin[0].userId + '  ' + this.selectedFourDotFiveAdmin[0].firstName);
            if (angular.equals(this.companyManagement.fourDotFiveAdmin.userId, this.selectedFourDotFiveAdmin[0].userId)) {
                this.unCheckSelected4dot5Admin(this.selectedFourDotFiveAdmin[0]);
                this.companyManagement.fourDotFiveAdmin = {};
                this.form.company4dot5AdminDetailsForm.$setDirty();
            }
            else {
                this.companyManagement.fourDotFiveAdmin = angular.copy(this.selectedFourDotFiveAdmin[0]);
                console.log('******************************************* ' + angular.toJson(this.companyManagement.fourDotFiveAdmin));
                this.form.company4dot5AdminDetailsForm.$setDirty();
            }
        }
        else {
            this.companyManagement.fourDotFiveAdmin = angular.copy(this.selectedFourDotFiveAdmin[0]);
            this.CompanyManagementReset = angular.copy(this.companyManagement);
            console.log('new 4dot5 admin selected : ' + angular.toJson(this.CompanyManagementReset.fourDotFiveAdmin));
            this.form.company4dot5AdminDetailsForm.$setDirty();
        }
    };
    CompanyPageController.prototype.updatedAssessementFlowChanges = function (updatedLicencePrefs) {
        console.log('Original updated licence prefs: ' + updatedLicencePrefs.length);
        console.log('Original updated licence prefs: ' + angular.toJson(updatedLicencePrefs));
        for (var index = 0; index < updatedLicencePrefs.length; index++) {
            console.log('Object: ' + updatedLicencePrefs[index]);
            if (!(updatedLicencePrefs[index].licensePrefDetailsList[0].disabled == this.AssessmentWorkFlow[index].licensePrefDetailsList[0].disabled)) {
                console.log('There was change in: ' + this.updatedAssessementFlowChanges[index].name);
                this.AssessmentWorkFlow[index].disabled = updatedLicencePrefs[index].disabled;
            }
        }
        console.log('UI Assesement Flow: ' + angular.toJson(this.AssessmentWorkFlow));
    };
    /**
     * This method is called to get Assesement workflow steps.
     */
    CompanyPageController.prototype.getAssessmentWorkFlow = function (companyId, successCallback) {
        var _this = this;
        this.laststep = true;
        this.isTestLinkReadOnly = true;
        if (!(!this.companyDetailsUpdateMode && !this.ClientOrBuUpdate) || (this.companyDetailsUpdateMode && !this.laststep) || (this.ClientOrBuUpdate && !this.laststep)) {
            this.dataLastLabel = 'Complete';
        }
        if (this.StorageService.get('companyDetails') != null && this.newlyCreatedCompanyId == null) {
            if (angular.isDefined(this.StorageService.get('companyDetails').companyId)) {
                this.newlyCreatedCompanyId = this.StorageService.get('companyDetails').companyId;
            }
            else {
                this.newlyCreatedCompanyId = this.StorageService.get('companyDetails');
            }
        }
        if (this.isCompanyAdmin && this.TypeOfCompany == 'Company') {
            this.newlyCreatedCompanyId = this.$rootScope.userDetails.company.companyId;
        }
        if (this.clientOrBuCreationInProgress) {
            //This condition is satisfied when client or bu creation is in progress.
            console.log('Get assessement flow details for client during client creation.');
            this.genericService.getObjects(this.COMPANYMANAGEMENTCONSTANTS.CONTROLLER.GET_ASSESSMENT_WORK_FLOW_FOR_CLIENT_BU + '' + this.$rootScope.userDetails.company.companyId + '/' + this.newlyCreatedCompanyId).subscribe(function (data) {
                //               console.log('GET_ASSESSMENT_WORK_FLOW received is : ' + angular.toJson(data.body));
                if (!_.isNull(data.body.jobBoardCredentialList)) {
                    data.body.jobBoardCredentialList = _this.massageJobBoardCredentials(data.body.jobBoardCredentialList);
                }
                _this.originalStepFive = angular.copy(data.body);
                _this.preferences = angular.copy(data.body);
                _this.massageWorkflowStepsOrder();
                _this.jobBoardCredentialListCopy = angular.copy(_this.preferences.jobBoardCredentialList);
                _this.stepFiveChanged = !(angular.equals(_this.originalStepFive, _this.preferences));
                _this.licensePreferencesFetched = true;
                if (!_this.errorInSavingPrefsCheck) {
                    _this.StorageService.set('wizardoperations', true);
                    _this.stepTrigger('nextbtnclick');
                }
                _this.accessTimeOptionsDisabled = !(_this.preferences.techAssessmentList.licensePrefDetailsList[0].selected || _this.preferences.valueAssessmentList.licensePrefDetailsList[0].selected);
                //_setAccessDisabledForWorkflowSteps();
                if (successCallback) {
                    successCallback();
                }
            }, function (error) {
                if (_this.$rootScope.isOnline) {
                    _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                }
            });
        }
        else if (this.companyDetailsUpdateMode) {
            //This condition is satisfied when company update is in progress.
            console.log('Get assessement flow details for company during company updation.');
            this.genericService.getObjects(this.COMPANYMANAGEMENTCONSTANTS.CONTROLLER.GET_ASSESSMENT_WORK_FLOW + '' + this.$rootScope.userDetails.company.companyType + '/' + this.$rootScope.userDetails.company.companyId).subscribe(function (data) {
                if (!_.isNull(data.body.jobBoardCredentialList)) {
                    data.body.jobBoardCredentialList = _this.massageJobBoardCredentials(data.body.jobBoardCredentialList);
                }
                _this.originalStepFive = angular.copy(data.body);
                _this.savedAssessmentWorkFlow = angular.copy(data.body);
                _this.preferences = angular.copy(_this.savedAssessmentWorkFlow);
                _this.massageWorkflowStepsOrder();
                _this.jobBoardCredentialListCopy = angular.copy(_this.preferences.jobBoardCredentialList);
                _this.licensePreferencesFetched = true;
                _this.accessTimeOptionsDisabled = !(_this.preferences.techAssessmentList.licensePrefDetailsList[0].selected || _this.preferences.valueAssessmentList.licensePrefDetailsList[0].selected);
                _this.stepFiveChanged = !(angular.equals(_this.originalStepFive, _this.preferences));
                if (!_this.errorInSavingPrefsCheck) {
                    _this.StorageService.set('wizardoperations', true);
                    _this.stepTrigger('nextbtnclick');
                }
                if (successCallback) {
                    successCallback();
                }
                //_setAccessDisabledForWorkflowSteps();
            }, function (error) {
                if (_this.$rootScope.isOnline) {
                    _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                }
            });
        }
        else if (!this.clientOrBuUpdateInProgress) {
            console.log('1: ' + this.$rootScope.userDetails.company.companyId); //Creation of company in progress
            if (this.newlyCreatedCompanyId == null) {
                this.newlyCreatedCompanyId == this.$rootScope.userDetails.company.companyId;
            }
            this.genericService.getObjects(this.COMPANYMANAGEMENTCONSTANTS.CONTROLLER.GET_ASSESSMENT_WORK_FLOW + '' + this.$rootScope.userDetails.company.companyType + '/' + this.$rootScope.userDetails.company.companyId).subscribe(function (data) {
                //               console.log('GET_ASSESSMENT_WORK_FLOW received is : ' + angular.toJson(data.body));
                if (!_.isNull(data.body.jobBoardCredentialList)) {
                    data.body.jobBoardCredentialList = _this.massageJobBoardCredentials(data.body.jobBoardCredentialList);
                }
                _this.originalStepFive = angular.copy(data.body);
                console.log('Assess: ' + _this.preferences);
                _this.savedAssessmentWorkFlow = angular.copy(data.body);
                _this.preferences = angular.copy(_this.savedAssessmentWorkFlow);
                _this.accessTimeOptionsDisabled = !(_this.preferences.techAssessmentList.licensePrefDetailsList[0].selected || _this.preferences.valueAssessmentList.licensePrefDetailsList[0].selected);
                _this.massageWorkflowStepsOrder();
                _this.jobBoardCredentialListCopy = angular.copy(_this.preferences.jobBoardCredentialList);
                _this.licensePreferencesFetched = true;
                _this.stepFiveChanged = !(angular.equals(_this.originalStepFive, _this.preferences));
                if (!_this.errorInSavingPrefsCheck) {
                    _this.StorageService.set('wizardoperations', true);
                    _this.stepTrigger('nextbtnclick');
                }
                //Company admin can edit only company workflow steps credentials
                if (_this.isCompanyAdmin && _this.TypeOfCompany == 'Company') {
                    _this.isStepReadOnlyForCompanyAdmin = false;
                }
                else {
                    _this.isStepReadOnlyForCompanyAdmin = true;
                }
                if (successCallback) {
                    successCallback();
                }
                //_setAccessDisabledForWorkflowSteps();
            }, function (error) {
                if (_this.$rootScope.isOnline) {
                    _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                }
            });
        }
        else {
            console.log('Getting assessement flow details for clientOrBu');
            if (this.clientOrBuUpdateInProgress) {
                //This is satisfied when client or bu update is in progress
                console.log('Getting assessement flow details for client Or Bu in update mode.');
                this.genericService.getObjects(this.COMPANYMANAGEMENTCONSTANTS.CONTROLLER.GET_ASSESSMENT_WORK_FLOW_FOR_CLIENT_BU + '' + this.$rootScope.userDetails.company.companyId + '/' + this.companyManagement.company.id).subscribe(function (data) {
                    //           console.log('GET_ASSESSMENT_WORK_FLOW received is : ' + angular.toJson(data.body));
                    if (!_.isNull(data.body.jobBoardCredentialList)) {
                        data.body.jobBoardCredentialList = _this.massageJobBoardCredentials(data.body.jobBoardCredentialList);
                    }
                    _this.originalStepFive = angular.copy(data.body);
                    _this.preferences = angular.copy(data.body);
                    _this.massageWorkflowStepsOrder();
                    _this.jobBoardCredentialListCopy = angular.copy(_this.preferences.jobBoardCredentialList);
                    console.log('this.preferences : ' + angular.toJson(_this.preferences));
                    _this.licensePreferencesFetched = true;
                    _this.stepFiveChanged = !(angular.equals(_this.originalStepFive, _this.preferences));
                    console.log('this.stepFiveChanged starting : ' + angular.toJson(_this.stepFiveChanged));
                    _this.accessTimeOptionsDisabled = !(_this.preferences.techAssessmentList.licensePrefDetailsList[0].selected || _this.preferences.valueAssessmentList.licensePrefDetailsList[0].selected);
                    _this.StorageService.set('wizardoperations', true);
                    _this.stepTrigger('nextbtnclick');
                    if (successCallback) {
                        successCallback();
                    }
                    //_setAccessDisabledForWorkflowSteps();
                }, function (error) {
                    if (_this.$rootScope.isOnline) {
                        _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                    }
                });
            }
            else {
                console.log('2');
                this.genericService.getObjects(this.COMPANYMANAGEMENTCONSTANTS.CONTROLLER.GET_ASSESSMENT_WORK_FLOW + '' + this.$rootScope.userDetails.company.companyType + '/' + companyId).subscribe(function (data) {
                    if (!_.isNull(data.body.jobBoardCredentialList)) {
                        data.body.jobBoardCredentialList = _this.massageJobBoardCredentials(data.body.jobBoardCredentialList);
                    }
                    _this.originalStepFive = angular.copy(data.body);
                    _this.preferences = angular.copy(data.body);
                    _this.massageWorkflowStepsOrder();
                    _this.jobBoardCredentialListCopy = angular.copy(_this.preferences.jobBoardCredentialList);
                    _this.licensePreferencesFetched = true;
                    _this.accessTimeOptionsDisabled = !(_this.preferences.techAssessmentList.licensePrefDetailsList[0].selected || _this.preferences.valueAssessmentList.licensePrefDetailsList[0].selected);
                    _this.stepFiveChanged = !(angular.equals(_this.originalStepFive, _this.preferences));
                    console.log(' this.companyManagement.licensePreferences ' + angular.toJson(_this.companyManagement.licensePreferences));
                    _this.StorageService.set('wizardoperations', true);
                    _this.stepTrigger('nextbtnclick');
                    if (successCallback) {
                        successCallback();
                    }
                    //_setAccessDisabledForWorkflowSteps();
                }, function (error) {
                    if (_this.$rootScope.isOnline) {
                        _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                    }
                });
            }
        }
        // Get all job source type
        this.genericService.getObjects('api/resume/resumesourcetypes').subscribe(function (data) {
            // do not show other and referral source types
            angular.forEach(data.body, function (val, key) {
                if (val.sourceType != 'Other' && val.sourceType != 'Referral') {
                    _this.jobSourceType.push(val);
                }
            });
        }, function (error) {
        });
        // function _setAccessDisabledForWorkflowSteps() {
        //     if(this.$rootScope.userDetails.roleScreenRef.role.name == 'CorporateAdmin' || this.$rootScope.userDetails.roleScreenRef.role.name == 'StaffingAdmin') {
        //         this.$timeout(() =>  {
        //             angular.element('.access').attr({ 'readonly': true, 'disabled': true });
        //         }, 300);
        //     }
        // }
    };
    /**
     * This method is called to get Current active plan details.
     */
    CompanyPageController.prototype.getCurrentPlanDetails = function (companyId, isMovetoNextStep) {
        var _this = this;
        console.log('Get current plan details for company during company updation.');
        this.planService.getCurrentPlan(companyId, function (data) {
            console.log(data);
            if (data !== "" && !_.isNull(data)) {
                _this.selectedPlan = data;
                // this.selectedPlan.planHeaderDto.planStartDateDisplay = this.$filter('fourdotfiveDateFormat')(this.selectedPlan.planHeaderDto.planStartDate);
                // this.selectedPlan.planHeaderDto.planEndDateDisplay = this.$filter('fourdotfiveDateFormat')(this.selectedPlan.planHeaderDto.planEndDate);
                _this.selectedPlan.planHeaderDto.unformattedStartDate = moment(_this.selectedPlan.planHeaderDto.planStartDate).toDate();
                _this.selectedPlan.planHeaderDto.unformattedEndDate = moment(_this.selectedPlan.planHeaderDto.planEndDate).toDate();
                _this.selectedPlan.planHeaderDto.planStartDateDisplay = moment(_this.selectedPlan.planHeaderDto.unformattedStartDate).tz(_this.selectedPlan.planHeaderDto.timeZoneName).format("MMM DD, YYYY");
                _this.selectedPlan.planHeaderDto.planEndDateDisplay = moment(_this.selectedPlan.planHeaderDto.unformattedEndDate).tz(_this.selectedPlan.planHeaderDto.timeZoneName).format("MMM DD, YYYY");
                _this.originalStepFour = angular.copy(_this.selectedPlan);
                _this.savedCurrentActivePlan = angular.copy(_this.selectedPlan);
                _this.planDetailsFetched = true;
                _this.setPlanPriorities('currentPlan');
                _this.isActivePlanExists = true;
                _this.isPlanChosen = true;
                _this.$rootScope.userDetails.plan.planName = _this.selectedPlan.planHeaderDto.planName;
                _this.$rootScope.userDetails.plan.planType = _this.selectedPlan.planHeaderDto.planType;
                _this.$rootScope.userDetails.plan.startDate = moment(_this.selectedPlan.planHeaderDto.planStartDate);
                _this.$rootScope.userDetails.plan.endDate = moment(_this.selectedPlan.planHeaderDto.planEndDate);
                _this.$rootScope.userDetails.plan.message = _this.planService.getPlanExpiryMessage(_this.$rootScope.userDetails.plan.planType, _this.$rootScope.userDetails.plan.endDate, true);
                _this.StorageService.set('userDetails', angular.copy(_this.$rootScope.userDetails), { 'expires': new Date(Date.now() + _this.$rootScope.tokenvalidity) });
                _this.isCompanyVendor = _this.companyService.isCompanyVendor();
            }
            else {
                _this.isActivePlanExists = false;
                _this.getExpiredPlanDetails(companyId, isMovetoNextStep);
            }
            _this.getFuturePlanDetails(companyId, isMovetoNextStep);
            if (isMovetoNextStep) {
                _this.StorageService.set('wizardoperations', true);
                _this.stepTrigger('nextbtnclick');
            }
        }, function (error) {
            _this.isActivePlanExists = false;
            if (isMovetoNextStep) {
                _this.StorageService.set('wizardoperations', true);
                _this.stepTrigger('nextbtnclick');
            }
        });
    };
    CompanyPageController.prototype.getExpiredPlanDetails = function (companyId, isMovetoNextStep) {
        var _this = this;
        console.log('Get expired plan details for company during company updation.');
        this.planService.getExpiredPlan(companyId, function (data) {
            console.log(data);
            if (data !== "" && !_.isNull(data)) {
                _this.expiredPlan = data;
                // this.expiredPlan.planHeaderDto.planStartDateDisplay = this.$filter('fourdotfiveDateFormat')(this.expiredPlan.planHeaderDto.planStartDate);
                // this.expiredPlan.planHeaderDto.planEndDateDisplay = this.$filter('fourdotfiveDateFormat')(this.expiredPlan.planHeaderDto.planEndDate);
                _this.expiredPlan.planHeaderDto.unformattedStartDate = moment(_this.expiredPlan.planHeaderDto.planStartDate).toDate();
                _this.expiredPlan.planHeaderDto.unformattedEndDate = moment(_this.expiredPlan.planHeaderDto.planEndDate).toDate();
                _this.expiredPlan.planHeaderDto.planStartDateDisplay = moment(_this.expiredPlan.planHeaderDto.unformattedStartDate).tz(_this.expiredPlan.planHeaderDto.timeZoneName).format("MMM DD, YYYY");
                _this.expiredPlan.planHeaderDto.planEndDateDisplay = moment(_this.expiredPlan.planHeaderDto.unformattedEndDate).tz(_this.expiredPlan.planHeaderDto.timeZoneName).format("MMM DD, YYYY");
                _this.planDetailsFetched = true;
                _this.isCompanyVendor = _this.companyService.isCompanyVendor();
            }
            _this.isActivePlanExists = false;
            _this.isPlanChosen = false;
        }, function (error) {
            _this.isActivePlanExists = false;
            _this.isPlanChosen = false;
            if (isMovetoNextStep) {
                _this.StorageService.set('wizardoperations', true);
                _this.stepTrigger('nextbtnclick');
            }
        });
    };
    CompanyPageController.prototype.getFuturePlanDetails = function (companyId, isMovetoNextStep) {
        var _this = this;
        console.log('Get future plan details for company during company updation.');
        this.planService.getFuturePlan(companyId, function (data) {
            console.log('future plan');
            console.log(data);
            _this.futurePlan = data;
            if (data !== "" && !_.isNull(data)) {
                // this.futurePlan.planHeaderDto.planStartDateDisplay = this.$filter('fourdotfiveDateFormat')(this.futurePlan.planHeaderDto.planStartDate);
                // this.futurePlan.planHeaderDto.planEndDateDisplay = this.$filter('fourdotfiveDateFormat')(this.futurePlan.planHeaderDto.planEndDate);
                _this.futurePlan.planHeaderDto.unformattedStartDate = moment(_this.futurePlan.planHeaderDto.planStartDate).toDate();
                _this.futurePlan.planHeaderDto.unformattedEndDate = moment(_this.futurePlan.planHeaderDto.planEndDate).toDate();
                _this.futurePlan.planHeaderDto.planStartDateDisplay = moment(_this.futurePlan.planHeaderDto.unformattedStartDate).tz(_this.futurePlan.planHeaderDto.timeZoneName).format("MMM DD, YYYY");
                _this.futurePlan.planHeaderDto.planEndDateDisplay = moment(_this.futurePlan.planHeaderDto.unformattedEndDate).tz(_this.futurePlan.planHeaderDto.timeZoneName).format("MMM DD, YYYY");
                _this.planDetailsFetched = true;
                _this.setPlanPriorities('futurePlan');
                _this.isFuturePlanExists = true;
                _this.setFuturePlanName();
            }
            else {
                _this.isFuturePlanExists = false;
            }
            _this.disableActionButtons = false;
        }, function (error) {
            _this.isFuturePlanExists = false;
            if (isMovetoNextStep) {
                _this.StorageService.set('wizardoperations', true);
                _this.disableActionButtons = false;
                _this.stepTrigger('nextbtnclick');
            }
        });
    };
    /**
     * This method is called to get list of Company Types.
     */
    CompanyPageController.prototype.getCompanyTypes = function () {
        var _this = this;
        var companyTypes = ['Corporation', 'StaffingCompany'];
        companyTypes.forEach(function (element) {
            //Puts in a space before an uppercase letter                    this.companyTypes.push(element.replace(/([A-Z])/g, ' $1').trim());
            _this.companyTypes.push(element);
        }, this);
        if (this.$rootScope.userDetails.company.companyId == null) {
            console.log('Getting 4dot5 admins');
            this.get4dot5admins();
            // this.getAllPlans();
        }
        else {
            // this.getAllPlans();
            console.log('Not Getting 4dot5 admins');
        }
    };
    CompanyPageController.prototype.editTestLink = function () {
        this.isTestLinkReadOnly = false;
    };
    CompanyPageController.prototype.massageJobBoardCredentials = function (jobBoardCredentialList) {
        angular.forEach(jobBoardCredentialList, function (jobBoardCredential, key) {
            jobBoardCredential.editable = true;
        });
        return jobBoardCredentialList;
    };
    /**
     * This function is called to the list on industry group list
     */
    /*   INDUSTRY CODE         function getIndustryGroups() {
                    var clientIdToGetIndustryList = 0;
                    if (this.ClientOrBuUpdate) {
                        clientIdToGetIndustryList = this.companyManagement.company.id;
                        this.industryListOfCompany = this.$rootScope.userDetails.company.companyId;
                    } else if (this.$rootScope.userDetails.company.companyId != null) {
                        console.log('Update staffing company');
                        this.industryListOfCompany = this.$rootScope.userDetails.company.companyId;
                    }
                    console.log('Get industries for company: ' + this.industryListOfCompany);
                    if (this.TypeOfCompany == 'BusinessUnit' || this.TypeOfCompany == 'Client' || this.ClientOrBuUpdate) {
                        this.genericService.getObjects(this.COMPANYMANAGEMENTCONSTANTS.CONTROLLER.GET_INDUSTRY_GROUPS + '/' + this.industryListOfCompany + '/' + clientIdToGetIndustryList).subscribe(function (data) {
                            console.log('GET_INDUSTRY_GROUPS Length of Data received is : ' + data.body.length);
                            this.IndustryGroupList = [];
                            industryMasterList = data.body;
                            data.body.forEach(function (element) {
                                this.IndustryGroupList.push(element.name);
                                console.log('Element: ' + element.name + ' status: ' + element.selected);
                                if (element.selected) {
                                    this.industryGroup = element.name;
                                    this.IndustrySubList = element.industryDtos;
                                }
                                element.industryDtos.forEach(function (elem) {
                                    if (elem.selected == true) {
                                        this.industriesInPanel.push(elem);
                                        elem.selected = false;
                                    }
                                }, this);
                            }, this);
                            this.originalIndustriesPanel = angular.copy(this.industriesInPanel);
                            console.log('Industries panel: ' + angular.toJson(this.industriesInPanel));
                        }, function (error) {
                        if (error.status === 500) {
                    this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                }
                            console.log('error : ' + angular.toJson(error));
                        });
                    } else {//Get industries during staffing company update and create.
                        console.log('Get industries during staffing company update and create.');
                        this.genericService.getObjects(this.COMPANYMANAGEMENTCONSTANTS.CONTROLLER.GET_INDUSTRY_GROUPS + '/' + this.industryListOfCompany).subscribe(function (data) {
                            console.log('GET_INDUSTRY_GROUPS Length of Data received is : ' + data.body.length);
                            this.IndustryGroupList = [];
                            industryMasterList = data.body;
                            this.companyManagement.company.industryList = [];
                            data.body.forEach(function (element) {
                                this.IndustryGroupList.push(element.name);
                                console.log('Element: ' + element.name + ' status: ' + element.selected);
                                if (element.selected) {
                                    this.industryGroup = element.name;
                                    this.IndustrySubList = element.industryDtos;
                                }
                                element.industryDtos.forEach(function (elem) {
                                    if (elem.selected == true) {
                                        this.industriesInPanel.push(elem);
                                        elem.selected = false;
                                    }
                                }, this);
                            }, this);
                            this.originalIndustriesPanel = angular.copy(this.industriesInPanel);
                            console.log('Industries panel: ' + angular.toJson(this.industriesInPanel));
                        }, function (error) {
                        if (error.status === 500) {
                    this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                }
                            console.log('error : ' + angular.toJson(error));
                        });
                    }
                }*/
    /**
     * Change as per selection,get sublist of industries belonging to the group.
     */
    /*   INDUSTRY CODE         this.getIndustrySublist = function (industrygroup) {
                    if (this.$rootScope.userDetails.company.companyId != null && !this.ClientOrBuCreate) {
                        if (this.originalStepOne.industryGroup == industrygroup) {
                            console.log('Setting api values');
                        }
                    }
                    console.log('Industry Group: ' + industrygroup);
                    if (!angular.equals(this.selectedIndustryGroup, industrygroup)) {
                        industryMasterList.forEach(function (element) {
                            if (element.name == industrygroup) {
                                element.selected = true;
                                this.IndustrySubList = element.industryDtos;
                                console.log('Inside for each');
                                this.selectedSubGroup = true;
                            } else {
                                if (angular.equals(element.name, this.selectedIndustryGroup)) {
                                    element.selected = false;
                                    element.industryDtos.forEach(function (industryDto) {
                                        if (industryDto.selected === true) {
                                            industryDto.selected = false;
                                        }
                                    }, this);
                                }
                            }
                        }, this);
                    }

                    if (this.ClientOrBuCreate) {
                        industryMasterList.forEach(function (element) {
                            console.log("5");
                            if (angular.equals(element.name, industrygroup)) {
                                console.log("6");
                                element.selected = true;
                                this.IndustrySubList = element.industryDtos;
                                this.IndustrySubList.forEach(function (elem) {
                                    //console.log('Element is: ' + angular.toJson(elem));
                                    elem.selected = false;
                                }, this);
                                this.selectedSubGroup = true;
                            }
                        }, this);
                    }

                    this.selectedIndustryGroup = angular.copy(industrygroup);
                }*/
    /**
     * This method works for triggerng
     * button clicks and resetting timeout
     * and remaining variables to normal
     * @access for create, view and update
     */
    CompanyPageController.prototype.stepTrigger = function (target) {
        var _this = this;
        if (target === 'nextbtnclick') {
            var nextbtnclick = this.$timeout(function () {
                console.log('in stepTrigger nextbtnclick');
                angular.element('.btn-next').triggerHandler('click');
            }, 0).then(function () {
                console.log('in stepTrigger nextbtnclick callback');
                _this.StorageService.remove('wizardoperations');
                _this.triggerCount = 0;
                _this.formsubmitted = false;
                _this.$timeout.cancel(nextbtnclick);
            });
        }
        else if (target === 'cancelflow') {
            var steponeclick = this.$timeout(function () {
                angular.element('#1').trigger('click');
            }, 500).then(function () {
                _this.triggerCount = 0;
                _this.formsubmitted = false;
                _this.StorageService.remove('wizardoperations');
                _this.$timeout.cancel(steponeclick);
            });
        }
    };
    /**
     * Function to save Step 1 Company Details.
     */
    CompanyPageController.prototype.saveCompanyDetails = function () {
        var _this = this;
        console.log('................' + this.companyManagement.company.companyType);
        if (this.StorageService.get('clientOrBuCreationInProgress') !== null) {
            if (this.$rootScope.userDetails.company.companyType == 'Corporation') {
                this.TypeOfCompany = 'BusinessUnit';
                this.companyManagement.company.companyType = 'BusinessUnit';
            }
            else if (this.$rootScope.userDetails.company.companyType == 'StaffingCompany') {
                this.TypeOfCompany = 'Client';
                this.companyManagement.company.companyType = 'Client';
            }
        }
        if (this.$stateParams.vendorId !== null) {
            if (this.$rootScope.userDetails.company.companyType == 'Corporation') {
                this.TypeOfCompany = 'Vendor';
            }
        }
        console.log(' @@In this.saveCompanyDetails function: ' + this.stepOneChanged);
        if ((this.StorageService.get('companyDetails') == null || this.companyDetailsUpdateMode || this.clientOrBuCreationInProgress || this.clientOrBuUpdateInProgress || this.vendorUpdateInProgress) && this.stepOneChanged) {
            //Building the SavedCompanyManagement object before saving.
            this.savedCompanyManagementCopy.company = angular.copy(this.savedCompanyManagement.company);
            console.log('Before Api CompanyManagement.company : ' + angular.toJson(this.companyManagement.company));
            this.savedCompanyManagement.company = angular.copy(this.companyManagement.company);
            this.limitCharactersInName();
            this.disableActionButtons = true;
            this.genericService.addObject(this.COMPANYMANAGEMENTCONSTANTS.CONTROLLER.SAVE_COMPANY + '/' + this.loggedInUserDetails.company.companyId, this.savedCompanyManagement).subscribe(function (data) {
                _this.disableActionButtons = false;
                _this.originalStepOne = angular.copy(data.body.company);
                console.log('this.originalStepOne  ' + angular.toJson(_this.originalStepOne));
                _this.nextButtonFlag++;
                _this.isCompanyDetailsSaveCalled = true;
                _this.savedCompanyManagement.company = angular.copy(data.body.company);
                console.log('Response: ' + angular.toJson('this.savedCompanyManagement: ' + angular.toJson(_this.savedCompanyManagement)));
                _this.companyManagement.company = data.body.company;
                // INDUSTRY CODE                      this.originalIndustriesPanel = angular.copy(this.originalStepOne.industryList);
                // INDUSTRY CODE                     delete this.originalStepOne['industryGroup'];
                // INDUSTRY CODE                   delete this.originalStepOne['industryList'];
                _this.companyManagement.company.name = data.body.company.name;
                _this.companyManagement.company.id = data.body.company.id;
                _this.companyManagement.companyState = data.body.companyState;
                _this.savedCompanyManagement.company.id = data.body.company.id;
                _this.savedCompanyManagement.companyState = data.body.companyState;
                _this.newlyCreatedCompanyId = data.body.company.id;
                _this.$rootScope.newlyCreatedCompanyId = _this.newlyCreatedCompanyId;
                if (_this.TypeOfCompany != 'Client' && _this.TypeOfCompany != 'BusinessUnit') {
                    _this.$rootScope.userDetails.company.companyId = _this.newlyCreatedCompanyId;
                    _this.$rootScope.userDetails.company.companyName = data.body.company.name;
                    _this.$rootScope.userDetails.company.companyType = data.body.company.companyType;
                    _this.$rootScope.userDetails.company.companyState = data.body.companyState;
                    _this.companyService.setCompanyStateLabel();
                    _this.$rootScope.userDetails.company.companySelected = true;
                    _this.StorageService.set('userDetails', angular.copy(_this.$rootScope.userDetails), { 'expires': new Date(Date.now() + _this.$rootScope.tokenvalidity) });
                    _this.disableActionButtons = false;
                }
                if (_this.TypeOfCompany == 'Client' || _this.TypeOfCompany == 'BusinessUnit') {
                    _this.getManagers(function () {
                        _this.disableActionButtons = false;
                    });
                    console.log('Client details saved, call this.assignClientToStaffingCompany function');
                    _this.assignClientToStaffingCompany('clickonclientnext');
                }
                if (_this.clientOrBuUpdateInProgress) {
                    console.log('Step 1 details changed, so api call made.Updated client details : ');
                    _this.editCompanyName = data.body.company.name.substring(0, 57);
                    _this.editCompanyNameOnHover = data.body.company.name;
                    if (data.body.company.name.length > 57) {
                        _this.editCompanyName = _this.editCompanyName + '...';
                    }
                }
                if (!(_this.TypeOfCompany == 'Client') && !(_this.TypeOfCompany == 'BusinessUnit')) {
                    console.log('Saved company Step 1 details successfully.');
                    _this.companyStepOneSaved = true;
                    _this.StorageService.set('wizardoperations', true);
                    _this.stepTrigger('nextbtnclick');
                }
            }, function (error) {
                _this.triggerCount = 0;
                _this.disableActionButtons = false;
                if (error.statusCode === "409") {
                    _this.errorOcurred = true;
                    if (angular.isDefined(_this.companyManagement.companyState)) {
                        if (error.developerMsg === "101") {
                            _this.companyManagement.company.companyShortName = _this.originalStepOne.companyShortName;
                        }
                        else if (error.developerMsg === "102") {
                            _this.companyManagement.company.name = _this.originalStepOne.name;
                        }
                        else if (error.developerMsg === "100") {
                            _this.companyManagement.company.companyShortName = _this.originalStepOne.companyShortName;
                            _this.companyManagement.company.name = _this.originalStepOne.name;
                        }
                        else {
                            _this.companyManagement.company.companyShortName = _this.originalStepOne.companyShortName;
                            _this.companyManagement.company.name = _this.originalStepOne.name;
                        }
                    }
                    else {
                        if (error.developerMsg === "101") {
                            _this.companyManagement.company.companyShortName = '';
                        }
                        else if (error.developerMsg === "102") {
                            _this.companyManagement.company.name = '';
                        }
                        else if (error.developerMsg === "100") {
                            _this.companyManagement.company.companyShortName = '';
                            _this.companyManagement.company.name = '';
                        }
                    }
                }
                if (_this.$rootScope.isOnline) {
                    _this.alertsAndNotificationsService.showBannerMessage(error.error.message, 'danger');
                }
                _this.savedCompanyManagement.company = angular.copy(_this.savedCompanyManagementCopy.company);
            });
        }
        else if (!this.stepOneChanged) {
            console.log('this.companyStepOneSaved');
            this.companyStepOneSaved = true;
            this.getManagers(function () {
                _this.disableActionButtons = false;
            });
            this.StorageService.set('wizardoperations', true);
            this.triggerCount = 0;
        }
    };
    /**
     * Function to save Step 2 details(Company Contact Person Details)
     */
    CompanyPageController.prototype.saveContactDetails = function () {
        var _this = this;
        if (this.newlyCreatedCompanyId == null && (this.clientOrBuUpdateInProgress || this.vendorUpdateInProgress)) {
            this.newlyCreatedCompanyId = this.companyManagement.company.id;
        }
        if ((this.StorageService.get('companyDetails') == null || this.companyDetailsUpdateMode || this.clientOrBuCreationInProgress || this.clientOrBuUpdateInProgress || this.vendorUpdateInProgress) && this.stepTwoChanged) {
            //Building the SavedCompanyManagement object before saving.
            this.savedCompanyManagementCopy.contactList = angular.copy(this.savedCompanyManagement.contactList);
            this.savedCompanyManagement.contactList = angular.copy(this.companyManagement.contactList);
            this.limitCharactersInName();
            if (!this.vendorUpdateInProgress && !this.isAssociatedClientUpdateInProgress) {
                if (this.clientOrBuCreationInProgress) {
                    angular.forEach(this.savedCompanyManagement.contactList, function (contact, key) {
                        if (contact.userId == undefined) {
                            contact.userId = null;
                        }
                    });
                }
                this.disableActionButtons = true;
                this.genericService.addObject(this.COMPANYMANAGEMENTCONSTANTS.CONTROLLER.SAVE_COMPANY + '/' + this.$rootScope.userDetails.company.companyId, this.savedCompanyManagement).subscribe(function (data) {
                    _this.nextButtonFlag++;
                    _this.originalStepTwo = angular.copy(data.body.contactList);
                    _this.savedCompanyManagement.contactList = angular.copy(data.body.contactList);
                    _this.companyManagement.contactList = angular.copy(data.body.contactList);
                    if (_this.vendorUpdateInProgress) {
                        console.log('Step 2 details changed, so api call made.Updated vendor contact details : ');
                        _this.laststep = true;
                        _this.alertsAndNotificationsService.showBannerMessage(_this.MESSAGECONSTANTS.NOTIFICATIONS.VENDOR.UPDATESUCCESS, 'success');
                        _this.$state.go('missioncontrol.vendors', null, { reload: true });
                    }
                    if (_this.clientOrBuUpdateInProgress) {
                        console.log('Step 2 details changed, so api call made.Updated client contact details : ');
                        _this.laststep = true;
                        // this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.CLIENT.UPDATESUCCESS, 'success');
                    }
                    if (_this.clientOrBuCreationInProgress) {
                        console.log('Step 2 details changed, so api call made.Saved client contact details : ');
                        _this.laststep = true;
                        // this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.CLIENT.CLIENT+" '<b><i class='wrap-word'>"+this.savedCompanyManagement.company.name+"</i></b>' "+this.MESSAGECONSTANTS.NOTIFICATIONS.CLIENT.CREATEDRAFTSUCCESS, 'success')
                    }
                    if (_this.$rootScope.userDetails.company.companyType == 'Host') {
                        _this.laststep = true;
                        _this.dataLastLabel = 'Complete';
                    }
                    if (_this.TypeOfCompany == 'Client' || _this.TypeOfCompany == 'BusinessUnit' || _this.clientOrBuUpdateInProgress || _this.clientOrBuCreationInProgress || _this.StorageService.get('SelectedHostCompany') != null) {
                        if (!_this.licensePreferencesFetched || _this.isCompanyDetailsSaveCalled) {
                            _this.getAssessmentWorkFlow(_this.$rootScope.userDetails.company.companyId, function () {
                                _this.disableActionButtons = false;
                            });
                        }
                        else {
                            _this.disableActionButtons = false;
                            _this.StorageService.set('wizardoperations', true);
                            _this.stepTrigger('nextbtnclick');
                        }
                    }
                    else {
                        if (data.body.userConfiguration == null) {
                            _this.getUserConfiguration(function () {
                                console.log('Saved Step 2 details successfully.');
                                _this.companyStepTwoSaved = true;
                                _this.StorageService.set('wizardoperations', true);
                                _this.disableActionButtons = false;
                                _this.stepTrigger('nextbtnclick');
                            });
                        }
                        else {
                            console.log('Saved Step 2 details successfully.');
                            _this.companyStepTwoSaved = true;
                            _this.StorageService.set('wizardoperations', true);
                            _this.disableActionButtons = false;
                            _this.stepTrigger('nextbtnclick');
                        }
                    }
                }, function (error) {
                    if (_this.$rootScope.isOnline) {
                        _this.alertsAndNotificationsService.showBannerMessage(error.error.message, 'danger');
                    }
                    _this.disableActionButtons = false;
                    console.log('now assigning original obj to transaction and saved objects');
                    _this.savedCompanyManagement.contactList = angular.copy(_this.savedCompanyManagementCopy.contactList);
                });
            }
            else if (this.isAssociatedClientUpdateInProgress) {
                var clientObject = {};
                clientObject.corporateCompanyId = this.newlyCreatedCompanyId;
                clientObject.vendorId = this.$rootScope.userDetails.company.companyId;
                clientObject.corporateCompanyContactList = angular.copy(this.getParsedContacts(this.savedCompanyManagement.contactList));
                this.companyService.updateClientCorporateContactDetails(clientObject, function (data) {
                    data.contactList = angular.copy(data.corporateCompanyContactList);
                    _this.nextButtonFlag++;
                    _this.originalStepTwo = angular.copy(data.contactList);
                    _this.savedCompanyManagement.contactList = angular.copy(data.contactList);
                    _this.companyManagement.contactList = angular.copy(data.contactList);
                    if (!_this.licensePreferencesFetched || _this.isCompanyDetailsSaveCalled) {
                        _this.getAssessmentWorkFlow(_this.$rootScope.userDetails.company.companyId);
                    }
                    else {
                        _this.StorageService.set('wizardoperations', true);
                        _this.stepTrigger('nextbtnclick');
                    }
                }, function (error) {
                    if (_this.$rootScope.isOnline) {
                        _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                    }
                    console.log('now assigning original obj to transaction and saved objects');
                    _this.savedCompanyManagement.contactList = angular.copy(_this.savedCompanyManagementCopy.contactList);
                });
            }
            else {
                var vendorObject = {};
                vendorObject.corporateCompanyId = this.$rootScope.userDetails.company.companyId;
                vendorObject.vendorId = this.newlyCreatedCompanyId;
                vendorObject.contactList = angular.copy(this.getParsedContacts(this.savedCompanyManagement.contactList));
                this.companyService.saveCorporateVendor(vendorObject, function (data) {
                    data.contactList = angular.copy(_this.getParsedCompanyContacts(data.contactList));
                    _this.nextButtonFlag++;
                    _this.originalStepTwo = angular.copy(data.contactList);
                    _this.savedCompanyManagement.contactList = angular.copy(data.contactList);
                    _this.companyManagement.contactList = angular.copy(data.contactList);
                    if (_this.vendorUpdateInProgress) {
                        console.log('Step 2 details changed, so api call made.Updated vendor contact details : ');
                        _this.laststep = true;
                        _this.alertsAndNotificationsService.showBannerMessage(_this.MESSAGECONSTANTS.NOTIFICATIONS.VENDOR.UPDATESUCCESS, 'success');
                        _this.$state.go('missioncontrol.vendors', null, { reload: true });
                    }
                }, function (error) {
                    if (_this.$rootScope.isOnline) {
                        _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                    }
                    console.log('now assigning original obj to transaction and saved objects');
                    _this.savedCompanyManagement.contactList = angular.copy(_this.savedCompanyManagementCopy.contactList);
                });
            }
        }
        else if (!this.stepTwoChanged) {
            console.log('Step 2 is not changed, so no api call made.');
            if (this.StorageService.get('SelectedHostCompany') != null) {
                this.laststep = true;
                this.dataLastLabel = 'Complete';
            }
            if (this.TypeOfCompany == 'Client' || this.TypeOfCompany == 'BusinessUnit' || this.$rootScope.userDetails.company.companyType == 'Host') {
                this.laststep = true;
                this.disableActionButtons = true;
                this.getAssessmentWorkFlow(this.$rootScope.userDetails.company.companyId, function () {
                    _this.disableActionButtons = false;
                });
            }
            else if (this.TypeOfCompany == 'Vendor') {
                this.alertsAndNotificationsService.showBannerMessage('Nothing to be updated!', 'info');
                this.$state.go('missioncontrol.vendors', null, { reload: true });
            }
            else {
                this.companyStepTwoSaved = true;
                this.triggerCount = 0;
                this.StorageService.set('wizardoperations', true);
            }
        }
    };
    /**
     * Function to save Step 3 details(Company 4Dot5 Admin Details)
     */
    CompanyPageController.prototype.saveFourDotFiveAdminDetails = function () {
        var _this = this;
        console.log('In function this.saveFourDotFiveAdminDetails: ');
        if ((this.StorageService.get('companyDetails') == null || this.companyDetailsUpdateMode) && this.stepThreeChanged) {
            //Building the SavedCompanyManagement object before saving.
            this.savedFourDotFiveAdminCopy = angular.copy(this.savedFourDotFiveAdmin);
            this.savedFourDotFiveAdmin = angular.copy(this.selectedFourDotFiveAdmin);
            console.log('before saving ' + angular.toJson(this.savedFourDotFiveAdmin));
            this.limitCharactersInName();
            this.disableActionButtons = true;
            this.genericService.addObject(this.COMPANYMANAGEMENTCONSTANTS.CONTROLLER.UPDATE_COMPANY_FOR_FOURDOTFIVE_ADMIN + '/' + this.savedFourDotFiveAdmin[0].userId + '/' + this.$rootScope.userDetails.company.companyId + '?oldfourdotfiveadmin=' + this.oldFourDotFiveAdminId, this.savedFourDotFiveAdmin).subscribe(function (data) {
                //               console.log('Success: ' + angular.toJson(data));
                _this.originalStepThree = angular.copy(data.body.fourDotFiveAdmin);
                _this.savedFourDotFiveAdmin = angular.copy(data.body.fourDotFiveAdmin);
                if (_this.companyDetailsUpdateMode == true) {
                    _this.companyManagement.fourDotFiveAdmin = angular.copy(data.body.fourDotFiveAdmin);
                    _this.CompanyManagementReset.fourDotFiveAdmin = angular.copy(data.body.fourDotFiveAdmin);
                    console.log('Step 3 is changed, so api call made.Four dot five admin updated.' + angular.toJson(_this.companyManagement.fourDotFiveAdmin));
                    // this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.COMPANY.UPDATESUCCESS, 'success')
                }
                else {
                    console.log('Step 3 is changed, so api call made.Four dot five admin saved successfully.');
                    //this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.COMPANY.CREATEDRAFTSUCCESS, 'success');
                }
                _this.userConfigurationCopy = angular.copy(_this.companyManagement.userConfiguration);
                _this._saveUserConfiguration(function (data) {
                    _this.nextButtonFlag++;
                    _this.companyManagement.userConfiguration = angular.copy(data);
                    _this.CompanyManagementReset.userConfiguration = angular.copy(data);
                    _this.companyStepThreeSaved = true;
                    _this.getCurrentPlanDetails(_this.loggedInUserDetails.company.companyId, true);
                    _this.laststep = true;
                }, function (error) {
                    if (_this.$rootScope.isOnline) {
                        _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                    }
                    _this.disableActionButtons = false;
                });
            }, function (error) {
                if (_this.$rootScope.isOnline) {
                    _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                }
                _this.disableActionButtons = false;
                console.log('now assigning original obj to transaction and saved objects');
                _this.savedFourDotFiveAdmin = angular.copy(_this.savedFourDotFiveAdminCopy);
            });
        }
        else if (!this.stepThreeChanged) {
            console.log('Step 3 is not changed, so no api call made.');
            this.laststep = true;
            if (!this.licensePreferencesFetched || this.isCompanyDetailsSaveCalled) {
                console.log('Fetching company plan details:');
                this.getCurrentPlanDetails(this.loggedInUserDetails.company.companyId, true);
            }
            else {
                this.StorageService.set('wizardoperations', true);
                this.triggerCount = 0;
            }
        }
    };
    CompanyPageController.prototype._saveUserConfiguration = function (successCallback, errorCallback) {
        this.companyService.saveUserConfiguration(this.companyManagement.userConfiguration, this.$rootScope.userDetails.company.companyId, function (data) {
            if (successCallback) {
                successCallback(data);
            }
        }, function (error) {
            if (errorCallback) {
                errorCallback(error);
            }
        });
    };
    /**
     * Function to save Step 4 details(Company Plan)
     */
    CompanyPageController.prototype.savePlanDetails = function () {
        var _this = this;
        console.log('In function save Plan Details: ');
        if ((this.StorageService.get('companyDetails') == null || this.companyDetailsUpdateMode) && this.stepFourChanged) {
            this.savedCurrentActivePlanCopy = angular.copy(this.selectedPlan);
            this.savedCurrentActivePlan = angular.copy(this.selectedPlan);
            this.disableActionButtons = true;
            this.planService.savePlan(this.selectedPlan, function (data) {
                _this.nextButtonFlag++;
                // data.planHeaderDto.planStartDateDisplay = this.$filter('fourdotfiveDateFormat')(data.planHeaderDto.planStartDate);
                // data.planHeaderDto.planEndDateDisplay = this.$filter('fourdotfiveDateFormat')(data.planHeaderDto.planEndDate);
                data.planHeaderDto.unformattedStartDate = moment(data.planHeaderDto.planStartDate).toDate();
                data.planHeaderDto.unformattedEndDate = moment(data.planHeaderDto.planEndDate).toDate();
                data.planHeaderDto.planStartDateDisplay = moment(data.planHeaderDto.unformattedStartDate).tz(data.planHeaderDto.timeZoneName).format("MMM DD, YYYY");
                data.planHeaderDto.planEndDateDisplay = moment(data.planHeaderDto.unformattedEndDate).tz(data.planHeaderDto.timeZoneName).format("MMM DD, YYYY");
                _this.originalStepFour = angular.copy(data);
                _this.savedCurrentActivePlan = angular.copy(data);
                _this.selectedPlan = angular.copy(data);
                _this.isActivePlanExists = true;
                _this.companyStepFourSaved = true;
                _this.getAssessmentWorkFlow(_this.loggedInUserDetails.company.companyId, function () {
                    _this.disableActionButtons = false;
                });
                _this.laststep = true;
            }, function (error) {
                if (_this.$rootScope.isOnline) {
                    _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                }
                _this.disableActionButtons = false;
                // console.log('now assigning original obj to transaction and saved objects');
                // this.savedFourDotFiveAdmin = angular.copy(this.savedFourDotFiveAdminCopy);
            });
        }
        else if (!this.stepFourChanged) {
            console.log('Step 4 is not changed, so no api call made.');
            this.laststep = true;
            if (!this.licensePreferencesFetched || this.isCompanyDetailsSaveCalled) {
                console.log('Fetching licence prefs:');
                this.disableActionButtons = true;
                this.getAssessmentWorkFlow(this.loggedInUserDetails.company.companyId, function () {
                    _this.disableActionButtons = false;
                });
            }
            else {
                this.StorageService.set('wizardoperations', true);
                this.stepTrigger('nextbtnclick');
                //Company admin can edit only company workflow steps credentials
                if (this.isCompanyAdmin && this.TypeOfCompany == 'Company') {
                    this.isStepReadOnlyForCompanyAdmin = false;
                }
                else {
                    this.isStepReadOnlyForCompanyAdmin = true;
                }
            }
        }
    };
    /**
     * Function to limit characters in name.
     */
    CompanyPageController.prototype.limitCharactersInName = function () {
        this.delimitedCompanyOrClientName = this.savedCompanyManagement.company.name;
        //                if (this.savedCompanyManagement.company.name.length > 15) {
        //                    this.delimitedCompanyOrClientName = this.delimitedCompanyOrClientName + '....';
        //                }
    };
    CompanyPageController.prototype.getParsedCompanyContacts = function (contactList) {
        var parsedContactList = [];
        angular.forEach(contactList, function (contact, key) {
            var parsedContact = {};
            parsedContact.email = contact.email;
            parsedContact.firstName = contact.firstname;
            parsedContact.lastName = contact.lastname;
            parsedContact.im = contact.im;
            parsedContact.isPrimary = contact.isPrimary;
            parsedContact.mobilePhone = contact.mobilephone;
            parsedContact.workPhone = contact.workphone;
            parsedContactList.push(parsedContact);
        });
        return parsedContactList;
    };
    CompanyPageController.prototype.getParsedContacts = function (contactList) {
        var parsedContactList = [];
        angular.forEach(contactList, function (contact, key) {
            var parsedContact = {};
            parsedContact.email = contact.email;
            parsedContact.firstname = contact.firstName;
            parsedContact.lastname = contact.lastName;
            parsedContact.im = contact.im;
            parsedContact.isPrimary = contact.isPrimary;
            parsedContact.mobilephone = contact.mobilePhone;
            parsedContact.workphone = contact.workPhone;
            parsedContactList.push(parsedContact);
        });
        return parsedContactList;
    };
    CompanyPageController.prototype.getManagers = function (successCallback) {
        var _this = this;
        this.userService.getPossibleManagersForHr(this.$rootScope.userDetails.company.companyId, function (data) {
            _this.managers = data;
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            //do nothing
        });
    };
    /**
     *
     */
    CompanyPageController.prototype.assignClientToStaffingCompany = function (clickfromclientsaveornext) {
        var _this = this;
        //This condition satisfy when a company from popup is selected and user tries to edit a client/bu for selected company
        console.log('this.assignClientToStaffingCompany function called.');
        if (this.clientOrBuUpdateInProgress) {
            this.newlyCreatedCompanyId = this.companyManagement.company.id;
            console.log('Taking updated client id');
        }
        if (this.StorageService.get('companyDetails') != null) {
            if (angular.isDefined(this.StorageService.get('companyDetails').companyId)) {
                this.assignClient2StaffingCompany = this.StorageService.get('companyDetails').companyId;
            }
            else {
                this.assignClient2StaffingCompany = this.StorageService.get('companyDetails');
            }
            console.log('this.StorageService.get != null: ' + this.assignClient2StaffingCompany);
        }
        else {
            this.assignClient2StaffingCompany = this.loggedInUserDetails.company.companyId;
            console.log('this.StorageService.get != null: ' + this.assignClient2StaffingCompany);
        }
        this.genericService.addObject(this.COMPANYMANAGEMENTCONSTANTS.CONTROLLER.ASSIGN_CLIENT_TO_STAFFING_COMPANY + '/' + this.assignClient2StaffingCompany + '/' + this.newlyCreatedCompanyId).subscribe(function (data) {
            console.log('Client assigned to staffing company.');
            _this.nextButtonFlag++;
            if (_this.clientOrBuUpdateInProgress) {
                //  this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.CLIENT.UPDATESUCCESS, 'success')
            }
            else if (_this.clientOrBuCreationInProgress && clickfromclientsaveornext == 'clickonclientsave') {
                _this.alertsAndNotificationsService.showBannerMessage(_this.MESSAGECONSTANTS.NOTIFICATIONS.CLIENT.CLIENT + " '<b><i class='wrap-word'>" + _this.delimitedCompanyOrClientName + "</i></b>' " + _this.MESSAGECONSTANTS.NOTIFICATIONS.CLIENT.CREATEDRAFTSUCCESS, 'success');
            }
            _this.companyStepOneSaved = true;
            if (!(clickfromclientsaveornext == 'clickonclientsave')) {
                _this.StorageService.set('wizardoperations', true);
                _this.stepTrigger('nextbtnclick');
            }
        }, function (error) {
            console.log('this.assignClientToStaffingCompany error with trigger this.count : ' + _this.triggerCount);
            if ((error.status === 500) && _this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
            else {
                if (_this.clientOrBuUpdateInProgress) {
                    // this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.CLIENT.UPDATESUCCESS, 'success')
                }
                else if (_this.clientOrBuCreationInProgress && clickfromclientsaveornext == 'clickonclientsave') {
                    _this.alertsAndNotificationsService.showBannerMessage(_this.MESSAGECONSTANTS.NOTIFICATIONS.CLIENT.CLIENT + " '<b><i class='wrap-word'>" + _this.delimitedCompanyOrClientName + "</i></b>' " + _this.MESSAGECONSTANTS.NOTIFICATIONS.CLIENT.CREATEDRAFTSUCCESS, 'success');
                }
                _this.companyStepOneSaved = true;
                if (!(clickfromclientsaveornext == 'clickonclientsave')) {
                    _this.StorageService.set('wizardoperations', true);
                    _this.stepTrigger('nextbtnclick');
                }
            }
        });
    };
    /**
     * Change state of Staffing company to 'Active'.
     */
    CompanyPageController.prototype.changeCompanyState = function () {
        var _this = this;
        console.log('this.changeCompanyState function called.');
        this.genericService.addObject(this.COMPANYMANAGEMENTCONSTANTS.CONTROLLER.CHANGE_COMPANYSTATE + '/' + this.newlyCreatedCompanyId, this.companyManagement).subscribe(function (data) {
            _this.nextButtonFlag++;
            console.log('Selected Company ClientOrBus Data received is : ' + angular.toJson(data.body));
            _this.$rootScope.userDetails.company.companyState = data.body.companyState;
            _this.companyService.setCompanyStateLabel();
            _this.StorageService.set('userDetails', angular.copy(_this.$rootScope.userDetails), { 'expires': new Date(Date.now() + _this.$rootScope.tokenvalidity) });
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    /**
     * Function to save Step 5 details(Company assessement Flow Details)
     */
    CompanyPageController.prototype.saveAssessmentFlowDetails = function () {
        var _this = this;
        var clientOrCompanyLicensePrefsUrl;
        console.log('this.saveAssessmentFlowDetails function called.');
        //This condition satisfy when a company from popup is selected and user tries to create a client/bu for selected company
        if (this.StorageService.get('companyDetails') != null && this.newlyCreatedCompanyId == null && !this.clientOrBuUpdateInProgress) {
            if (angular.isDefined(this.StorageService.get('companyDetails').companyId)) {
                this.newlyCreatedCompanyId = this.StorageService.get('companyDetails').companyId;
            }
            else {
                this.newlyCreatedCompanyId = this.StorageService.get('companyDetails');
            }
        }
        if (this.isCompanyAdmin && this.TypeOfCompany == 'Company') {
            this.newlyCreatedCompanyId = this.$rootScope.userDetails.company.companyId;
        }
        //This condition satisfy when a company from popup is selected and user tries to edit a client/bu for selected company
        if (this.StorageService.get('companyDetails') == null && this.newlyCreatedCompanyId == null && this.companyManagement.company.companyType != 'Host') {
            if (this.StorageService.get('companyToBeUpdated') == null) {
                this.newlyCreatedCompanyId = this.$rootScope.userDetails.company.companyId;
            }
            else {
                this.newlyCreatedCompanyId = this.StorageService.get('companyToBeUpdated').company.id;
            }
            // console.log('Update Client set licence preferences');
        }
        //This condition will satisfy if editing host company
        if (this.companyManagement.company.companyType == 'Host') {
            this.newlyCreatedCompanyId = this.$rootScope.userDetails.company.companyId;
            console.log('Host: ' + this.newlyCreatedCompanyId);
        }
        //This condition will satisfy if editing a client/bu
        if (this.clientOrBuUpdateInProgress) {
            this.newlyCreatedCompanyId = this.companyManagement.company.id;
            console.log('Update Client set licence preferences: ' + this.newlyCreatedCompanyId);
        }
        console.log('Save for companyid: ' + this.newlyCreatedCompanyId);
        if ((this.StorageService.get('companyDetails') == null && !this.clientOrBuCreationInProgress && !this.clientOrBuUpdateInProgress)) {
            this.newCompanyCreation = true;
        }
        if ((this.StorageService.get('companyDetails') == null || this.companyDetailsUpdateMode || this.companyDetailsUpdateModeByCompanyAdmin || this.clientOrBuCreationInProgress || this.clientOrBuUpdateInProgress || this.assessmentOrJobBoardCredentialsUpdated) && this.stepFiveChanged) {
            if (this.clientOrBuCreationInProgress || this.clientOrBuUpdateInProgress) {
                clientOrCompanyLicensePrefsUrl = this.COMPANYMANAGEMENTCONSTANTS.CONTROLLER.SET_LICENCE_PREFERENCES_FOR_CLIENT_BU + '/' + this.$rootScope.userDetails.company.companyId + '/' + this.newlyCreatedCompanyId;
            }
            else {
                clientOrCompanyLicensePrefsUrl = this.COMPANYMANAGEMENTCONSTANTS.CONTROLLER.SET_LICENCE_PREFERENCES + '/' + this.companyManagement.company.companyType + '/' + this.newlyCreatedCompanyId;
            }
            //Building the SavedCompanyManagement object before saving.
            this.savedAssessmentWorkFlowCopy = angular.copy(this.savedAssessmentWorkFlow);
            this.savedAssessmentWorkFlow = angular.copy(this.preferences);
            this.tempObj = angular.copy(this.originalStepFive);
            this.limitCharactersInName();
            // this.disableActionButtons = true;
            this.genericService.addObject(clientOrCompanyLicensePrefsUrl, this.savedAssessmentWorkFlow).subscribe(function (data) {
                //              console.log('Success: ' + angular.toJson(data));
                //                        this.nextButtonFlag++;
                if (!_.isNull(data.body.jobBoardCredentialList)) {
                    data.body.jobBoardCredentialList = _this.massageJobBoardCredentials(data.body.licensePreferences.jobBoardCredentialList);
                }
                _this.companyManagement.licensePreferences = angular.copy(data.body.licensePreferences);
                _this.originalStepFive = angular.copy(data.body.licensePreferences);
                _this.savedAssessmentWorkFlow = angular.copy(data.body.licensePreferences);
                _this.massageWorkflowStepsOrder();
                _this.isTestLinkReadOnly = true;
                if ((_this.companyDetailsUpdateMode || _this.companyDetailsUpdateModeByCompanyAdmin) == true && _this.stepFiveChanged) {
                    console.log('Updated step 5 Company Licence Preferences details successfully.');
                    // if(this.$rootScope.userDetails.roleScreenRef.role.name != 'CorporateAdmin' && this.$rootScope.userDetails.roleScreenRef.role.name != 'StaffingAdmin') {
                    console.log('1');
                    if (!angular.equals(_this.tempObj, _this.savedAssessmentWorkFlow) || (_this.nextButtonFlag > 0) || (_this.saveButtonFlag > 0)) {
                        _this.alertsAndNotificationsService.showBannerMessage(_this.MESSAGECONSTANTS.NOTIFICATIONS.COMPANY.COMPANY + " '<b><i class='wrap-word'>" + _this.delimitedCompanyOrClientName + "</i></b>' " + _this.MESSAGECONSTANTS.NOTIFICATIONS.COMPANY.UPDATESUCCESS, 'success');
                    }
                    else {
                        _this.alertsAndNotificationsService.showBannerMessage(_this.MESSAGECONSTANTS.NOTIFICATIONS.CLIENT.NOTHING_TO_UPDATED, 'success');
                    }
                    // }
                }
                else if (!_this.clientOrBuUpdateInProgress && _this.TypeOfCompany == 'Client') {
                    console.log('2');
                    console.log('Saved step 3 Client/BU Licence Preferences details successfully.');
                    _this.alertsAndNotificationsService.showBannerMessage(_this.MESSAGECONSTANTS.NOTIFICATIONS.CLIENT.CLIENT + " '<b><i class='wrap-word'>" + _this.delimitedCompanyOrClientName + "</i></b>' " + _this.MESSAGECONSTANTS.NOTIFICATIONS.CLIENT.CREATESUCCESS, 'success');
                }
                else if (_this.TypeOfCompany == 'BusinessUnit') {
                    console.log('Saved step 3 Client/BU Licence Preferences details successfully.');
                    _this.disableActionButtons = true;
                    _this.companyService.getAllBuVendors(_this.$rootScope.userDetails.company.companyId, _this.newlyCreatedCompanyId, function (data) {
                        _this.originalStepSix = angular.copy(data);
                        _this.savedVendors = angular.copy(data);
                        _this.vendors = angular.copy(data);
                        _this.disableActionButtons = false;
                        _this.stepTrigger('nextbtnclick');
                    }, function (error) {
                        _this.disableActionButtons = false;
                    });
                    // this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.BU.BU + " '<b><i class='wrap-word'>" + this.delimitedCompanyOrClientName + "</i></b>' " + this.MESSAGECONSTANTS.NOTIFICATIONS.BU.CREATESUCCESS, 'success')
                }
                else if (_this.TypeOfCompany == 'Client' && _this.isAssociatedClientUpdateInProgress) {
                    _this.disableActionButtons = true;
                    _this.companyService.getAllBusOfClient(_this.$rootScope.userDetails.company.companyId, _this.newlyCreatedCompanyId, _this.$rootScope.userDetails.id, function (data) {
                        _this.originalStepSeven = angular.copy(data);
                        _this.saveBusOfClient = angular.copy(data);
                        _this.busOfClient = angular.copy(data);
                        _this.disableActionButtons = false;
                        _this.stepTrigger('nextbtnclick');
                    }, function (error) {
                        _this.disableActionButtons = false;
                    });
                }
                else if (angular.equals(_this.$rootScope.userDetails.roleScreenRef.role.name, 'CorporateAdmin') || angular.equals(_this.$rootScope.userDetails.roleScreenRef.role.name, 'StaffingAdmin') && _this.assessmentOrJobBoardCredentialsUpdated) {
                    console.log('Company updated successfully');
                    _this.alertsAndNotificationsService.showBannerMessage(_this.MESSAGECONSTANTS.NOTIFICATIONS.COMPANY.COMPANY + " '<b><i class='wrap-word'>" + _this.delimitedCompanyOrClientName + "</i></b>' " + _this.MESSAGECONSTANTS.NOTIFICATIONS.COMPANY.UPDATESUCCESS, 'success');
                }
                else if (_this.StorageService.get('companyDetails') == null && !_this.companyDetailsUpdateMode) {
                    console.log('3');
                    console.log('Saved step 5 Company Licence Preferences details successfully.');
                    _this.alertsAndNotificationsService.showBannerMessage(_this.MESSAGECONSTANTS.NOTIFICATIONS.COMPANY.COMPANY + " '<b><i class='wrap-word'>" + _this.delimitedCompanyOrClientName + "</i></b>' " + _this.MESSAGECONSTANTS.NOTIFICATIONS.COMPANY.CREATESUCCESS, 'success');
                }
                if (_this.clientOrBuUpdateInProgress && _this.stepFiveChanged) {
                    console.log('4');
                    console.log('Updated step 3 Client/BU Licence Preferences details successfully.');
                    if (!angular.equals(_this.tempObj, _this.savedAssessmentWorkFlow) || (_this.nextButtonFlag > 0) || (_this.saveButtonFlag > 0)) {
                        if (_this.TypeOfCompany == 'Client') {
                            _this.alertsAndNotificationsService.showBannerMessage(_this.MESSAGECONSTANTS.NOTIFICATIONS.CLIENT.CLIENT + " '<b><i class='wrap-word'>" + _this.delimitedCompanyOrClientName + "</i></b>' " + _this.MESSAGECONSTANTS.NOTIFICATIONS.CLIENT.UPDATESUCCESS, 'success');
                        }
                    }
                    else {
                        if (_this.TypeOfCompany == 'Client' && !_this.isAssociatedClientUpdateInProgress) {
                            _this.alertsAndNotificationsService.showBannerMessage(_this.MESSAGECONSTANTS.NOTIFICATIONS.CLIENT.NOTHING_TO_UPDATED, 'success');
                        }
                    }
                }
                _this.companyStepFiveSaved = true;
                _this.laststep = true;
                _this.StorageService.set('wizardoperations', true);
                //Bu has addition step 'Associate Vendor'
                if (_this.TypeOfCompany !== 'BusinessUnit' && !_this.isAssociatedClientUpdateInProgress) {
                    _this.stepTrigger('nextbtnclick');
                }
                if (_this.companyManagement.companyState == 'Draft' || _this.companyManagement.companyState == null) {
                    console.log('Saved Company Object: ' + angular.toJson(_this.savedCompanyManagement));
                    _this.changeCompanyState();
                }
                if (_this.TypeOfCompany == 'Client' && !_this.isAssociatedClientUpdateInProgress) {
                    _this.lastStepCompleted = true;
                    console.log('Moving out to clientmanagement(List of clients): ' + _this.lastStepCompleted);
                    _this.$timeout(function () {
                        _this.$state.go('missioncontrol.clientsOrBus', null, { reload: false });
                    }, 300);
                }
                else if (_this.companyManagement.company.companyType == 'Host') {
                    _this.StorageService.set('companyDetails', _this.newlyCreatedCompanyId);
                    _this.lastStepCompleted = true;
                    // this.$timeout(() => {
                    //     this.$state.go('missioncontrol.dashboardsuperusermodule', { companyObject: 'companyObject' }, { reload: false });
                    // }, 300);
                }
                else if (_this.TypeOfCompany == 'BusinessUnit' || _this.isAssociatedClientUpdateInProgress) {
                    //do nothing
                }
                else {
                    _this.StorageService.set('companyDetails', _this.newlyCreatedCompanyId);
                    _this.lastStepCompleted = true;
                    _this.$timeout(function () {
                        if (!_this.isCompanyVendor) {
                            _this.$state.go('missioncontrol.dashboard', { companyObject: 'companyObject' }, { reload: false });
                        }
                        else {
                            _this.$state.go('missioncontrol.requisitions', { companyObject: 'companyObject' }, { reload: false });
                        }
                    }, 300);
                    // this.$state.go('missioncontrol.dashboard', { companyObject: 'companyObject' }, { reload: false });
                }
            }, function (error) {
                if (_this.$rootScope.isOnline) {
                    if (error.error && error.error.message) {
                        var updatedMessage = error.error.message;
                        if (updatedMessage.includes('<br>')) {
                            updatedMessage = error.error.message.split('<br>')[0];
                        }
                        _this.alertsAndNotificationsService.showBannerMessage(updatedMessage, 'danger');
                    }
                    else {
                        _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                    }
                }
                if (error.statusCode == "409") {
                    _this.getAssessmentWorkFlow(_this.$rootScope.userDetails.company.companyId);
                }
                else {
                    _this.savedAssessmentWorkFlow = angular.copy(_this.savedAssessmentWorkFlowCopy);
                }
                _this.$timeout(function () {
                    if (!_this.isCompanyVendor) {
                        _this.$state.go('missioncontrol.dashboard', { companyObject: 'companyObject' }, { reload: false });
                    }
                    else {
                        _this.$state.go('missioncontrol.requisitions', { companyObject: 'companyObject' }, { reload: false });
                    }
                }, 300);
            });
        }
        else if (!this.stepFiveChanged) {
            console.log('Step 5 is not changed, so no api call made.');
            if (this.companyManagement.companyState == 'Draft' || this.companyManagement.companyState == null) {
                console.log('Saved Company Object: ' + angular.toJson(this.savedCompanyManagement));
                this.changeCompanyState();
            }
            this.companyStepFiveSaved = true;
            this.laststep = true;
            this.StorageService.set('wizardoperations', true);
            if (this.TypeOfCompany == 'Client') {
                this.lastStepCompleted = true;
                console.log('Moving out to clientmanagement: ' + this.lastStepCompleted);
                console.log('client before redirecting...' + this.ClientOrBuUpdate);
                if (!this.ClientOrBuUpdate) {
                    if (this.TypeOfCompany == 'Client') {
                        this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.CLIENT.CLIENT + " '<b><i class='wrap-word'>" + this.savedCompanyManagement.company.name + "</i></b>' " + this.MESSAGECONSTANTS.NOTIFICATIONS.CLIENT.CREATESUCCESS, 'success');
                    }
                    else {
                        this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.BU.BU + " '<b><i class='wrap-word'>" + this.savedCompanyManagement.company.name + "</i></b>' " + this.MESSAGECONSTANTS.NOTIFICATIONS.BU.CREATESUCCESS, 'success');
                    }
                    this.$timeout(function () {
                        _this.$state.go('missioncontrol.clientsOrBus', null, { reload: false });
                    }, 300);
                }
                else {
                    console.log("Update else");
                    if (this.isAssociatedClientUpdateInProgress) {
                        this.disableActionButtons = true;
                        this.companyService.getAllBusOfClient(this.$rootScope.userDetails.company.companyId, this.newlyCreatedCompanyId, this.$rootScope.userDetails.id, function (data) {
                            _this.originalStepSeven = angular.copy(data);
                            _this.saveBusOfClient = angular.copy(data);
                            _this.busOfClient = angular.copy(data);
                            _this.disableActionButtons = false;
                            _this.stepTrigger('nextbtnclick');
                        }, function (error) {
                            _this.disableActionButtons = false;
                        });
                    }
                    else {
                        this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.CLIENT.NOTHING_TO_UPDATED, 'success');
                        this.$timeout(function () {
                            _this.$state.go('missioncontrol.clientsOrBus', null, { reload: false });
                        }, 300);
                    }
                }
            }
            else if (this.TypeOfCompany == 'BusinessUnit') {
                this.companyService.getAllBuVendors(this.$rootScope.userDetails.company.companyId, this.newlyCreatedCompanyId, function (data) {
                    _this.originalStepSix = angular.copy(data);
                    _this.savedVendors = angular.copy(data);
                    _this.vendors = angular.copy(data);
                    _this.stepTrigger('nextbtnclick');
                }, function (error) {
                    //do nothing
                });
            }
            else if (this.companyManagement.company.companyType == 'Host') {
                console.log('for host company on complete when nothing changed showing message');
                console.log('this.nextButtonFlag : ' + this.nextButtonFlag);
                console.log('this.saveButtonFlag : ' + this.saveButtonFlag);
                if ((this.nextButtonFlag > 0) || (this.saveButtonFlag > 0)) {
                    this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.COMPANY.COMPANY + " '<b><i class='wrap-word'>" + this.delimitedCompanyOrClientName + "</i></b>' " + this.MESSAGECONSTANTS.NOTIFICATIONS.COMPANY.UPDATESUCCESS, 'success');
                }
                else {
                    this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.CLIENT.NOTHING_TO_UPDATED, 'success');
                }
                this.StorageService.set('companyDetails', this.newlyCreatedCompanyId);
                this.lastStepCompleted = true;
                this.$timeout(function () {
                    _this.$state.go('missioncontrol.dashboardsuperusermodule', { companyObject: 'companyObject' }, { reload: false });
                }, 300);
            }
            else {
                this.StorageService.set('companyDetails', this.newlyCreatedCompanyId);
                this.lastStepCompleted = true;
                console.log('company before redirecting...' + this.companyDetailsUpdateMode);
                if (this.companyDetailsUpdateMode) {
                    //this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.COMPANY.COMPANY + " '<b><i class='wrap-word'>" + this.delimitedCompanyOrClientName + "</i></b>' " + this.MESSAGECONSTANTS.NOTIFICATIONS.COMPANY.UPDATESUCCESS, 'success')
                    this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.CLIENT.NOTHING_TO_UPDATED, 'success');
                    this.$timeout(function () {
                        if (!_this.isCompanyVendor) {
                            _this.$state.go('missioncontrol.dashboard', { companyObject: 'companyObject' }, { reload: false });
                        }
                        else {
                            _this.$state.go('missioncontrol.requisitions', { companyObject: 'companyObject' }, { reload: false });
                        }
                    }, 300);
                }
                else if (!angular.isDefined(this.companyDetailsUpdateMode)) {
                    console.log('Creation of company(Staffing/Corporate)');
                    this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.COMPANY.COMPANY + " '<b><i class='wrap-word'>" + this.delimitedCompanyOrClientName + "</i></b>' " + this.MESSAGECONSTANTS.NOTIFICATIONS.COMPANY.CREATESUCCESS, 'success');
                    this.$timeout(function () {
                        if (!_this.isCompanyVendor) {
                            _this.$state.go('missioncontrol.dashboard', { companyObject: 'companyObject' }, { reload: false });
                        }
                        else {
                            _this.$state.go('missioncontrol.requisitions', { companyObject: 'companyObject' }, { reload: false });
                        }
                    }, 300);
                }
            }
        }
        else {
            this.companyStepFiveSaved = true;
            this.laststep = true;
            this.StorageService.set('wizardoperations', true);
            console.log('in else');
            if (!this.isCompanyVendor) {
                this.$state.go('missioncontrol.dashboard', { companyObject: 'companyObject' }, { reload: false });
            }
            else {
                this.$state.go('missioncontrol.requisitions', { companyObject: 'companyObject' }, { reload: false });
            }
        }
    };
    /**
     * Function to save Step 6 details(BU Vendors)
     */
    CompanyPageController.prototype.saveVendors = function () {
        var _this = this;
        console.log('this.saveVendors function called.');
        //This condition satisfy when a company from popup is selected and user tries to create a client/bu for selected company
        if (this.StorageService.get('companyDetails') != null && this.newlyCreatedCompanyId == null && !this.clientOrBuUpdateInProgress) {
            if (angular.isDefined(this.StorageService.get('companyDetails').companyId)) {
                this.newlyCreatedCompanyId = this.StorageService.get('companyDetails').companyId;
            }
            else {
                this.newlyCreatedCompanyId = this.StorageService.get('companyDetails');
            }
        }
        //This condition satisfy when a company from popup is selected and user tries to edit a client/bu for selected company
        if (this.StorageService.get('companyDetails') == null && this.newlyCreatedCompanyId == null && this.companyManagement.company.companyType != 'Host') {
            if (this.StorageService.get('companyToBeUpdated') == null) {
                this.newlyCreatedCompanyId = this.$rootScope.userDetails.company.companyId;
            }
            else {
                this.newlyCreatedCompanyId = this.StorageService.get('companyToBeUpdated').company.id;
            }
        }
        //This condition will satisfy if editing a client/bu
        if (this.clientOrBuUpdateInProgress) {
            this.newlyCreatedCompanyId = this.companyManagement.company.id;
            console.log('Update Client set licence preferences: ' + this.newlyCreatedCompanyId);
        }
        console.log('Save for companyid: ' + this.newlyCreatedCompanyId);
        if ((this.StorageService.get('companyDetails') == null && !this.clientOrBuCreationInProgress && !this.clientOrBuUpdateInProgress)) {
            this.newCompanyCreation = true;
        }
        if (this.stepSixChanged) {
            this.tempObj = angular.copy(this.originalStepSix);
            this.limitCharactersInName();
            this.modifiedVendors = this.getModifiedVendors();
            this.saveVendorsSaveClicked = false;
            if (this.modifiedVendors.disassociatedVendors.length > 0) {
                this.getBuVendorsRequisitionsCountAndLaunchDisassoicateModal();
            }
            else {
                this.saveVendorsOnComplete();
            }
        }
        else if (!this.stepSixChanged) {
            console.log('Step 6 is not changed, so no api call made.');
            if (this.companyManagement.companyState == 'Draft' || this.companyManagement.companyState == null) {
                console.log('Saved Company Object: ' + angular.toJson(this.savedCompanyManagement));
                this.changeCompanyState();
            }
            this.companyStepSixSaved = true;
            this.laststep = true;
            this.StorageService.set('wizardoperations', true);
            this.lastStepCompleted = true;
            if (!this.ClientOrBuUpdate) {
                this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.BU.BU + " '<b><i class='wrap-word'>" + this.savedCompanyManagement.company.name + "</i></b>' " + this.MESSAGECONSTANTS.NOTIFICATIONS.BU.CREATESUCCESS, 'success');
                this.$timeout(function () {
                    _this.$state.go('missioncontrol.clientsOrBus', null, { reload: true });
                }, 300);
            }
            else {
                this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.CLIENT.NOTHING_TO_UPDATED, 'success');
                this.$timeout(function () {
                    _this.$state.go('missioncontrol.clientsOrBus', null, { reload: true });
                }, 300);
            }
        }
        else {
            this.companyStepSixSaved = true;
            this.laststep = true;
            this.StorageService.set('wizardoperations', true);
            if (!this.isCompanyVendor) {
                this.$state.go('missioncontrol.dashboard', { companyObject: 'companyObject' }, { reload: false });
            }
            else {
                this.$state.go('missioncontrol.requisitions', { companyObject: 'companyObject' }, { reload: false });
            }
        }
    };
    CompanyPageController.prototype.saveVendorsOnComplete = function () {
        var _this = this;
        this.companyService.saveBuVendors(this.vendors, function (data) {
            _this.vendors = angular.copy(data);
            _this.originalStepSix = angular.copy(data);
            _this.savedVendors = angular.copy(data);
            if (!_this.clientOrBuUpdateInProgress) {
                _this.alertsAndNotificationsService.showBannerMessage(_this.MESSAGECONSTANTS.NOTIFICATIONS.BU.BU + " '<b><i class='wrap-word'>" + _this.delimitedCompanyOrClientName + "</i></b>' " + _this.MESSAGECONSTANTS.NOTIFICATIONS.BU.CREATESUCCESS, 'success');
            }
            if (_this.clientOrBuUpdateInProgress && _this.stepSixChanged) {
                if (!angular.equals(_this.tempObj, _this.savedVendors) || (_this.nextButtonFlag > 0) || (_this.saveButtonFlag > 0)) {
                    _this.alertsAndNotificationsService.showBannerMessage(_this.MESSAGECONSTANTS.NOTIFICATIONS.BU.BU + " '<b><i class='wrap-word'>" + _this.delimitedCompanyOrClientName + "</i></b>' " + _this.MESSAGECONSTANTS.NOTIFICATIONS.BU.UPDATESUCCESS, 'success');
                }
                else {
                    _this.alertsAndNotificationsService.showBannerMessage(_this.MESSAGECONSTANTS.NOTIFICATIONS.CLIENT.NOTHING_TO_UPDATED, 'success');
                }
            }
            _this.companyStepSixSaved = true;
            _this.laststep = true;
            _this.StorageService.set('wizardoperations', true);
            _this.stepTrigger('nextbtnclick');
            if (_this.companyManagement.companyState == 'Draft' || _this.companyManagement.companyState == null) {
                console.log('Saved Company Object: ' + angular.toJson(_this.savedCompanyManagement));
                _this.changeCompanyState();
            }
            _this.lastStepCompleted = true;
            console.log('Moving out to vendor management: ' + _this.lastStepCompleted);
            _this.$timeout(function () {
                _this.$state.go('missioncontrol.clientsOrBus', null, { reload: true });
            }, 300);
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    CompanyPageController.prototype._accessTimeOptionErrorExists = function () {
        var accessTimeErrorExistsFlag = false;
        if ((this.preferences.techAssessmentList.licensePrefDetailsList[0].enabled && this.preferences.techAssessmentList.licensePrefDetailsList[0].selected) || (this.preferences.valueAssessmentList.licensePrefDetailsList[0].enabled && this.preferences.valueAssessmentList.licensePrefDetailsList[0].selected)) {
            // if tech assessment or value assessment is enabled and selected
            var accessTimeHasBeenChosenFlag = false;
            angular.forEach(this.preferences.licenseAssessmentPreferences.accessTimes, function (val, key) {
                if (val.accessTimeValue) {
                    // if any accessTime option is chosen
                    accessTimeHasBeenChosenFlag = true;
                }
            });
            accessTimeErrorExistsFlag = !accessTimeHasBeenChosenFlag;
        }
        return accessTimeErrorExistsFlag;
    };
    CompanyPageController.prototype.saveStepsDataAfterTimeout = function (Company, ContactList, FourDotFiveAdmin) {
        var _this = this;
        console.log('this.$timeout 1000');
        this.$timeout(function () {
            _this.saveStepsData(Company, ContactList, FourDotFiveAdmin);
        }, 1000);
    };
    CompanyPageController.prototype.saveStepsData = function (Company, ContactList, FourDotFiveAdmin) {
        var _this = this;
        console.log('this.savedCompanyManagement ' + angular.toJson(this.savedCompanyManagement));
        this.nextButtonClicked = false;
        this.saveButtonClicked = true;
        // INDUSTRY CODE console.log('save value: ' + this.industriesInPanel.length);
        var currentStep = this.getCurrentStep();
        if (currentStep == 3 && (this.TypeOfCompany == 'Client' || this.TypeOfCompany == 'BusinessUnit' || this.StorageService.get('SelectedHostCompany') != null)) {
            currentStep = 5;
        }
        if (currentStep == 4 && this.TypeOfCompany == 'BusinessUnit') {
            currentStep = 6;
        }
        if (currentStep == 4 && this.TypeOfCompany == 'Client' && this.isAssociatedClientUpdateInProgress) {
            currentStep = 7;
        }
        this.valid = false;
        switch (currentStep) {
            case 1:
                this.stepOneChanged = !(angular.equals(this.originalStepOne, this.companyManagement.company)); //Checks if any changes.
                console.log(' originalStepOne ' + angular.toJson(this.originalStepOne));
                console.log(' CompanyManagement.company ' + angular.toJson(this.companyManagement.company));
                if (this.companyManagement.company.address2 != null) {
                    this.isAddressValid = !angular.equals(this.companyManagement.company.address1.toUpperCase(), this.companyManagement.company.address2.toUpperCase()) && (this.companyManagement.company.address1 != this.companyManagement.company.address2);
                    console.log('if  ' + this.isAddressValid);
                }
                else {
                    console.log('else');
                    this.isAddressValid = this.companyManagement.company.address1 != this.companyManagement.company.address2;
                }
                this.valid = this.form.companyDetailsForm.$valid && this.isAddressValid && this.validzipcode && angular.isDefined(this.validzipcode) && (!this.zipCodeCalling || (this.zipCodeCalling && this.zipCodeCallCompleted)); //Checks validations.;
                console.log('validations are proper: ' + this.valid + '  ' + this.form.companyDetailsForm.$valid + ' ' + this.form.companyDetailsForm.zipcode.$valid);
                console.log('Step 1 is changed: ' + this.stepOneChanged + ' ' + this.validzipcode + ' ' + this.companyManagement.company.zipcode + '  ' + angular.equals(this.originalStepOne, this.companyManagement.company));
                if (this.stepOneChanged && this.valid) {
                    if (!angular.isDefined(this.companyManagement.company.companyType)) {
                        if (this.$rootScope.userDetails.company.companyType == 'Corporation') {
                            this.companyManagement.company.companyType = 'BusinessUnit';
                        }
                        else if (this.$rootScope.userDetails.company.companyType == 'StaffingCompany') {
                            this.companyManagement.company.companyType = 'Client';
                        }
                    }
                    console.log('Creating: ' + this.companyManagement.company.companyType);
                    //Building the SavedCompanyManagement object before saving.
                    this.savedCompanyManagementCopy.company = angular.copy(this.savedCompanyManagement.company);
                    this.savedCompanyManagement.company = angular.copy(this.companyManagement.company);
                    console.log('Saving: ' + angular.toJson(this.savedCompanyManagement));
                    if (this.isAssociatedClientUpdateInProgress) {
                        this._setSharedClientDescription(function () {
                            _this.originalStepOne = angular.copy(_this.companyManagement.company);
                            _this.saveButtonFlag++;
                            _this.isCompanyDetailsSaveCalled = true;
                            console.log('this.originalStepOne  ' + angular.toJson(_this.originalStepOne));
                            //Updating the SavedCompanyManagement object after saving.
                            _this.savedCompanyManagement.company = angular.copy(_this.companyManagement.company);
                            _this.limitCharactersInName();
                            _this.saveButtonClicked = false;
                            console.log('Response: ' + angular.toJson(_this.savedCompanyManagement));
                            _this.companyStepOneSaved = true;
                            _this.alertsAndNotificationsService.showBannerMessage(_this.MESSAGECONSTANTS.NOTIFICATIONS.COMPANY.COMPANY + " '<b><i class='wrap-word'>" + _this.delimitedCompanyOrClientName + "</i></b>' " + " Description updated successfully", 'success');
                        });
                    }
                    else {
                        this.genericService.addObject(this.COMPANYMANAGEMENTCONSTANTS.CONTROLLER.SAVE_COMPANY + '/' + this.loggedInUserDetails.company.companyId, this.savedCompanyManagement).subscribe(function (data) {
                            _this.originalStepOne = angular.copy(data.body.company);
                            _this.saveButtonFlag++;
                            _this.isCompanyDetailsSaveCalled = true;
                            console.log('this.originalStepOne  ' + angular.toJson(_this.originalStepOne));
                            //Updating the SavedCompanyManagement object after saving.
                            _this.savedCompanyManagement.company = angular.copy(data.body.company);
                            _this.limitCharactersInName();
                            _this.saveButtonClicked = false;
                            console.log('Response: ' + angular.toJson(_this.savedCompanyManagement));
                            _this.companyManagement.company = data.body.company;
                            _this.companyManagement.company.name = data.body.company.name;
                            _this.companyManagement.companyState = data.body.companyState;
                            _this.companyManagement.companyState = data.body.companyState;
                            _this.savedCompanyManagement.company.id = data.body.company.id;
                            _this.savedCompanyManagement.companyState = data.body.companyState;
                            _this.newlyCreatedCompanyId = data.body.company.id;
                            if (_this.TypeOfCompany != 'Client' && _this.TypeOfCompany != 'BusinessUnit' && _this.TypeOfCompany != 'Vendor') {
                                _this.$rootScope.userDetails.company.companyId = data.body.company.id;
                                _this.$rootScope.userDetails.company.companyName = data.body.company.name;
                                _this.$rootScope.userDetails.company.companyType = data.body.company.companyType;
                                _this.$rootScope.userDetails.company.companyState = data.body.companyState;
                                _this.companyService.setCompanyStateLabel();
                                _this.$rootScope.userDetails.company.companySelected = true;
                                _this.StorageService.set('userDetails', angular.copy(_this.$rootScope.userDetails), { 'expires': new Date(Date.now() + _this.$rootScope.tokenvalidity) });
                            }
                            _this.companyStepOneSaved = true;
                            if (((_this.TypeOfCompany == 'Client' || _this.TypeOfCompany == 'BusinessUnit') && _this.clientOrBuUpdateInProgress) || ((_this.TypeOfCompany == 'Vendor') && _this.vendorUpdateInProgress)) {
                                console.log('Updated client details');
                                _this.editCompanyName = data.body.company.name.substring(0, 57);
                                _this.editCompanyNameOnHover = data.body.company.name;
                                if (data.body.company.name.length > 57) {
                                    _this.editCompanyName = _this.editCompanyName + '...';
                                }
                                if (_this.TypeOfCompany == 'BusinessUnit') {
                                    _this.alertsAndNotificationsService.showBannerMessage(_this.MESSAGECONSTANTS.NOTIFICATIONS.BU.BU + " '<b><i class='wrap-word'>" + _this.delimitedCompanyOrClientName + "</i></b>' " + _this.MESSAGECONSTANTS.NOTIFICATIONS.CLIENT.UPDATESUCCESS, 'success');
                                }
                                else if (_this.TypeOfCompany == 'Client') {
                                    _this.alertsAndNotificationsService.showBannerMessage(_this.MESSAGECONSTANTS.NOTIFICATIONS.CLIENT.CLIENT + " '<b><i class='wrap-word'>" + _this.delimitedCompanyOrClientName + "</i></b>' " + _this.MESSAGECONSTANTS.NOTIFICATIONS.CLIENT.UPDATESUCCESS, 'success');
                                }
                                else {
                                    _this.alertsAndNotificationsService.showBannerMessage(_this.MESSAGECONSTANTS.NOTIFICATIONS.VENDOR.VENDOR + " '<b><i class='wrap-word'>" + _this.delimitedCompanyOrClientName + "</i></b>' " + _this.MESSAGECONSTANTS.NOTIFICATIONS.VENDOR.UPDATESUCCESS, 'success');
                                }
                            }
                            if ((_this.TypeOfCompany == 'Client' || _this.TypeOfCompany == 'BusinessUnit') && _this.clientOrBuCreationInProgress) {
                                console.log('Assigning client to StaffingCompany function call.');
                                _this.assignClientToStaffingCompany('clickonclientsave');
                                //this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.CLIENT.CREATESUCCESS, 'success')
                            }
                            if (!(_this.companyDetailsUpdateMode) && _this.TypeOfCompany == 'Company') {
                                _this.alertsAndNotificationsService.showBannerMessage(_this.MESSAGECONSTANTS.NOTIFICATIONS.COMPANY.COMPANY + " '<b><i class='wrap-word'>" + _this.delimitedCompanyOrClientName + "</i></b>' " + _this.MESSAGECONSTANTS.NOTIFICATIONS.COMPANY.COMPANYDRAFTSUCCESS, 'success');
                            }
                            if (_this.companyDetailsUpdateMode) {
                                _this.alertsAndNotificationsService.showBannerMessage(_this.MESSAGECONSTANTS.NOTIFICATIONS.COMPANY.COMPANY + " '<b><i class='wrap-word'>" + _this.delimitedCompanyOrClientName + "</i></b>' " + _this.MESSAGECONSTANTS.NOTIFICATIONS.COMPANY.UPDATESUCCESS, 'success');
                            }
                        }, function (error) {
                            if (error.statusCode === "409") {
                                _this.errorOcurred = true;
                                if (angular.isDefined(_this.companyManagement.companyState)) {
                                    if (error.developerMsg === "101") {
                                        _this.companyManagement.company.companyShortName = _this.originalStepOne.companyShortName;
                                    }
                                    else if (error.developerMsg === "102") {
                                        _this.companyManagement.company.name = _this.originalStepOne.name;
                                    }
                                    else if (error.developerMsg === "100") {
                                        _this.companyManagement.company.companyShortName = _this.originalStepOne.companyShortName;
                                        _this.companyManagement.company.name = _this.originalStepOne.name;
                                    }
                                    else {
                                        _this.companyManagement.company.companyShortName = _this.originalStepOne.companyShortName;
                                        _this.companyManagement.company.name = _this.originalStepOne.name;
                                    }
                                }
                                else {
                                    if (error.developerMsg === "101") {
                                        _this.companyManagement.company.companyShortName = '';
                                    }
                                    else if (error.developerMsg === "102") {
                                        _this.companyManagement.company.name = '';
                                    }
                                    else if (error.developerMsg === "100") {
                                        _this.companyManagement.company.companyShortName = '';
                                        _this.companyManagement.company.name = '';
                                    }
                                }
                            }
                            if (_this.$rootScope.isOnline) {
                                _this.alertsAndNotificationsService.showBannerMessage(error.error.message, 'danger');
                            }
                            _this.savedCompanyManagement.company = angular.copy(_this.savedCompanyManagementCopy.company);
                        });
                    }
                }
                else if (!this.valid) {
                    console.log('else if .....');
                    this.step1FormSubmitted = true;
                    this.triggerCount = 0;
                }
                else if (this.valid && (!this.stepOneChanged)) {
                    console.log('else if ..');
                    this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.NOTHING_TO_SAVE, 'success');
                    this.saveButtonClicked = false;
                }
                break;
            case 2:
                console.log('Save clicked in step 2 : ');
                this.errorOcurred = false;
                this.cleanContactList();
                this.stepTwoChanged = !(angular.equals(this.originalStepTwo, this.companyManagement.contactList));
                console.log('Step 2 is changed: ' + this.stepTwoChanged);
                if (this.showRemoveButton) {
                    this.validateSecondaryDetails = true;
                    this.valid = this.form.companyDetailsForm.$valid && this.form.companyContactPersonDetailsForm.$valid && this.form.companySecondaryContactPersonDetailsForm.$valid
                        && this.isValidPrimaryMobileEntered && this.isValidPrimaryWorkPhoneEntered && this.isValidSecondaryMobileEntered && this.isValidSecondaryWorkPhoneEntered && this.isValidPhoneNumbersEntered();
                }
                else {
                    this.valid = this.form.companyDetailsForm.$valid && this.form.companyContactPersonDetailsForm.$valid && this.isValidPrimaryMobileEntered && this.isValidPrimaryWorkPhoneEntered;
                }
                console.log('validations are proper: ' + this.valid);
                console.log('1: ' + this.form.companyDetailsForm.$valid + ' 2: ' + this.form.companyContactPersonDetailsForm.$valid + ' 3: ' + this.isValidPrimaryMobileEntered + ' 4: ' + this.isValidPrimaryWorkPhoneEntered);
                if (this.stepTwoChanged && this.valid) {
                    if (this.companyManagement.contactList.length == 1) {
                        this.companyManagement.contactList[0].primary = false;
                    }
                    if (this.companyManagement.contactList.length > 1) {
                        angular.forEach(this.companyManagement.contactList, function (contact, key) {
                            contact.primary = false;
                        });
                    }
                    if (this.newlyCreatedCompanyId == null && (this.clientOrBuUpdateInProgress || this.vendorUpdateInProgress)) {
                        this.newlyCreatedCompanyId = this.companyManagement.company.id;
                    }
                    console.log('Save for companyid: ' + this.newlyCreatedCompanyId);
                    //Building the SavedCompanyManagement object before saving.
                    this.savedCompanyManagementCopy.contactList = angular.copy(this.savedCompanyManagement.contactList);
                    this.savedCompanyManagement.contactList = angular.copy(this.companyManagement.contactList);
                    this.limitCharactersInName();
                    console.log('Saving: ' + angular.toJson(this.savedCompanyManagement.contactList));
                    if (!this.vendorUpdateInProgress && !this.isAssociatedClientUpdateInProgress) {
                        if (this.clientOrBuCreationInProgress) {
                            angular.forEach(this.savedCompanyManagement.contactList, function (contact, key) {
                                if (contact.userId == undefined) {
                                    contact.userId = null;
                                }
                            });
                        }
                        this.genericService.addObject(this.COMPANYMANAGEMENTCONSTANTS.CONTROLLER.SAVE_COMPANY + '/' + this.$rootScope.userDetails.company.companyId, this.savedCompanyManagement).subscribe(function (data) {
                            console.log('Success: ' + angular.toJson(data.body.contactList));
                            _this.saveButtonFlag++;
                            _this.originalStepTwo = angular.copy(data.body.contactList);
                            _this.saveButtonClicked = false;
                            //Updating the SavedCompanyManagement object after saving.
                            _this.savedCompanyManagement.contactList = angular.copy(data.body.contactList);
                            _this.companyManagement.contactList = angular.copy(data.body.contactList);
                            console.log('Success: ' + angular.toJson(_this.originalStepTwo));
                            if (_this.TypeOfCompany == 'Client' || _this.TypeOfCompany == 'BusinessUnit') {
                                //this.getAssessmentWorkFlow(this.loggedInUserDetails.company.companyId);
                            }
                            if (_this.TypeOfCompany == 'BusinessUnit' && _this.clientOrBuUpdateInProgress) {
                                _this.alertsAndNotificationsService.showBannerMessage(_this.MESSAGECONSTANTS.NOTIFICATIONS.BU.BU + " '<b><i class='wrap-word'>" + _this.savedCompanyManagement.company.name + "</i></b>' " + _this.MESSAGECONSTANTS.NOTIFICATIONS.BU.UPDATESUCCESS, 'success');
                            }
                            if (_this.companyManagement.company.companyType == 'Client' && _this.clientOrBuUpdateInProgress) {
                                _this.alertsAndNotificationsService.showBannerMessage(_this.MESSAGECONSTANTS.NOTIFICATIONS.CLIENT.CLIENT + " '<b><i class='wrap-word'>" + _this.delimitedCompanyOrClientName + "</i></b>' " + _this.MESSAGECONSTANTS.NOTIFICATIONS.CLIENT.UPDATESUCCESS, 'success');
                            }
                            else if (!_this.clientOrBuCreationInProgress && _this.companyDetailsUpdateMode) {
                                _this.alertsAndNotificationsService.showBannerMessage(_this.MESSAGECONSTANTS.NOTIFICATIONS.COMPANY.COMPANY + " '<b><i class='wrap-word'>" + _this.delimitedCompanyOrClientName + "</i></b>' " + _this.MESSAGECONSTANTS.NOTIFICATIONS.COMPANY.UPDATESUCCESS, 'success');
                            }
                            if ((_this.TypeOfCompany == 'Client' || _this.TypeOfCompany == 'BusinessUnit') && _this.clientOrBuCreationInProgress) {
                                if (_this.TypeOfCompany == 'Client') {
                                    console.log('Assigning client to StaffingCompany');
                                    _this.alertsAndNotificationsService.showBannerMessage(_this.MESSAGECONSTANTS.NOTIFICATIONS.CLIENT.CLIENT + " '<b><i class='wrap-word'>" + _this.delimitedCompanyOrClientName + "</i></b>' " + _this.MESSAGECONSTANTS.NOTIFICATIONS.CLIENT.CREATEDRAFTSUCCESS, 'success');
                                }
                                else {
                                    _this.alertsAndNotificationsService.showBannerMessage(_this.MESSAGECONSTANTS.NOTIFICATIONS.BU.BU + " '<b><i class='wrap-word'>" + _this.delimitedCompanyOrClientName + "</i></b>' " + _this.MESSAGECONSTANTS.NOTIFICATIONS.BU.CREATEDRAFTSUCCESS, 'success');
                                }
                            }
                            if (!(_this.companyDetailsUpdateMode) && _this.TypeOfCompany == 'Company') {
                                _this.alertsAndNotificationsService.showBannerMessage(_this.MESSAGECONSTANTS.NOTIFICATIONS.COMPANY.COMPANY + " '<b><i class='wrap-word'>" + _this.delimitedCompanyOrClientName + "</i></b>' " + _this.MESSAGECONSTANTS.NOTIFICATIONS.COMPANY.COMPANYDRAFTSUCCESS, 'success');
                            }
                            _this.companyStepTwoSaved = true;
                        }, function (error) {
                            if (_this.$rootScope.isOnline) {
                                _this.alertsAndNotificationsService.showBannerMessage(error.error.message, 'danger');
                            }
                            console.log('now assigning original obj to transaction and saved objects');
                            _this.savedCompanyManagement.contactList = angular.copy(_this.savedCompanyManagementCopy.contactList);
                        });
                    }
                    else if (this.isAssociatedClientUpdateInProgress) {
                        var clientObject = {};
                        clientObject.corporateCompanyId = this.newlyCreatedCompanyId;
                        clientObject.vendorId = this.$rootScope.userDetails.company.companyId;
                        clientObject.corporateCompanyContactList = angular.copy(this.getParsedContacts(this.savedCompanyManagement.contactList));
                        this.companyService.updateClientCorporateContactDetails(clientObject, function (data) {
                            data.contactList = angular.copy(data.corporateCompanyContactList);
                            console.log('Success: ' + angular.toJson(data.contactList));
                            _this.saveButtonFlag++;
                            _this.originalStepTwo = angular.copy(data.contactList);
                            _this.saveButtonClicked = false;
                            //Updating the SavedCompanyManagement object after saving.
                            _this.savedCompanyManagement.contactList = angular.copy(data.contactList);
                            _this.companyManagement.contactList = angular.copy(data.contactList);
                            console.log('Success: ' + angular.toJson(_this.originalStepTwo));
                            _this.alertsAndNotificationsService.showBannerMessage(_this.MESSAGECONSTANTS.NOTIFICATIONS.CLIENT.CLIENT + " '<b><i class='wrap-word'>" + _this.delimitedCompanyOrClientName + "</i></b>' " + _this.MESSAGECONSTANTS.NOTIFICATIONS.CLIENT.UPDATESUCCESS, 'success');
                            _this.companyStepTwoSaved = true;
                        }, function (error) {
                            if (_this.$rootScope.isOnline) {
                                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                            }
                            console.log('now assigning original obj to transaction and saved objects');
                            _this.savedCompanyManagement.contactList = angular.copy(_this.savedCompanyManagementCopy.contactList);
                        });
                    }
                    else {
                        var vendorObject = {};
                        vendorObject.corporateCompanyId = this.$rootScope.userDetails.company.companyId;
                        vendorObject.vendorId = this.newlyCreatedCompanyId;
                        vendorObject.contactList = angular.copy(this.getParsedContacts(this.savedCompanyManagement.contactList));
                        this.companyService.saveCorporateVendor(vendorObject, function (data) {
                            data.contactList = angular.copy(_this.getParsedCompanyContacts(data.contactList));
                            console.log('Success: ' + angular.toJson(data.contactList));
                            _this.saveButtonFlag++;
                            _this.originalStepTwo = angular.copy(data.contactList);
                            _this.saveButtonClicked = false;
                            //Updating the SavedCompanyManagement object after saving.
                            _this.savedCompanyManagement.contactList = angular.copy(data.contactList);
                            _this.companyManagement.contactList = angular.copy(data.contactList);
                            console.log('Success: ' + angular.toJson(_this.originalStepTwo));
                            _this.alertsAndNotificationsService.showBannerMessage(_this.MESSAGECONSTANTS.NOTIFICATIONS.VENDOR.VENDOR + " '<b><i class='wrap-word'>" + _this.delimitedCompanyOrClientName + "</i></b>' " + _this.MESSAGECONSTANTS.NOTIFICATIONS.VENDOR.UPDATESUCCESS, 'success');
                            _this.companyStepTwoSaved = true;
                        }, function (error) {
                            if (_this.$rootScope.isOnline) {
                                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                            }
                            console.log('now assigning original obj to transaction and saved objects');
                            _this.savedCompanyManagement.contactList = angular.copy(_this.savedCompanyManagementCopy.contactList);
                        });
                    }
                }
                else if (!this.valid) {
                    this.step2FormSubmitted = true;
                    this.triggerCount = 0;
                }
                else if (this.valid && (!this.stepTwoChanged)) {
                    this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.NOTHING_TO_SAVE, 'success');
                    this.saveButtonClicked = false;
                }
                break;
            case 3:
                console.log('Step 3 clicked on save : ');
                // this.oldCheckedAdmin = null;
                if (angular.isDefined(this.originalStepThree) && this.originalStepThree != null && this.selectedFourDotFiveAdmin.length > 0) {
                    console.log('Equals of: this.originalStepThree.userId' + this.originalStepThree.userId + ' and: ' + this.selectedFourDotFiveAdmin[0].userId);
                    this.stepThreeChanged = !(angular.equals(this.originalStepThree.userId, this.selectedFourDotFiveAdmin[0].userId)) || !angular.equals(this.companyManagement.userConfiguration, this.CompanyManagementReset.userConfiguration);
                    this.oldFourDotFiveAdminId = this.originalStepThree.userId;
                }
                else if (!angular.isDefined(this.originalStepThree) || (this.originalStepThree === null)) {
                    /**
                     * First condition is satisfied in create company.
                     * Second condition is satisfied when creating a company in
                     * Draft state( without selecting 4dot5admin) and coming to update for the next time later
                     */
                    this.stepThreeChanged = true;
                }
                console.log('Step 3 is changed: ' + this.stepThreeChanged);
                if (this.showRemoveButton) {
                    console.log('Secondary contact present');
                    this.valid = this.form.companyDetailsForm.$valid && this.form.companyContactPersonDetailsForm.$valid && this.form.companySecondaryContactPersonDetailsForm.$valid && this.selectedFourDotFiveAdmin.length > 0;
                }
                else {
                    this.valid = this.form.companyDetailsForm.$valid && this.form.companyContactPersonDetailsForm.$valid && this.selectedFourDotFiveAdmin.length > 0;
                    console.log('Secondary contact absent: ' + this.valid);
                }
                if (this.valid) {
                    this.valid = this.isPasswordRestrictionsValid();
                    if (!this.valid) {
                        this.complexityRestrictionChange('user');
                        this.complexityRestrictionChange('administrator');
                    }
                }
                console.log('validations are proper: ' + this.valid);
                if (this.stepThreeChanged && this.valid) {
                    if (!angular.isDefined(this.fourDotFiveCompanyAdmin)) {
                        this.fourDotFiveCompanyAdmin = this.selectedFourDotFiveAdmin;
                    }
                    console.log('Save for companyid: ' + this.newlyCreatedCompanyId);
                    //Building the SavedCompanyManagement object before saving.
                    this.savedFourDotFiveAdminCopy = angular.copy(this.savedFourDotFiveAdmin);
                    this.savedFourDotFiveAdmin = angular.copy(this.selectedFourDotFiveAdmin);
                    console.log('$$$$$$$$$$$$$$' + angular.toJson(this.savedFourDotFiveAdmin));
                    this.limitCharactersInName();
                    console.log('Saving :' + angular.toJson(this.savedFourDotFiveAdmin));
                    this.genericService.addObject(this.COMPANYMANAGEMENTCONSTANTS.CONTROLLER.UPDATE_COMPANY_FOR_FOURDOTFIVE_ADMIN + '/' + this.savedFourDotFiveAdmin[0].userId + '/' + this.$rootScope.userDetails.company.companyId + '?oldfourdotfiveadmin=' + this.oldFourDotFiveAdminId, this.savedFourDotFiveAdmin).subscribe(function (data) {
                        //                        console.log('Success: ' + angular.toJson(data.body));
                        _this.originalStepThree = angular.copy(data.body.fourDotFiveAdmin);
                        //Updating the SavedCompanyManagement object after saving.
                        _this.savedFourDotFiveAdmin = angular.copy(data.body.fourDotFiveAdmin);
                        _this.companyManagement.fourDotFiveAdmin = angular.copy(data.body.fourDotFiveAdmin);
                        _this.CompanyManagementReset.fourDotFiveAdmin = angular.copy(data.body.fourDotFiveAdmin);
                        console.log(' this.CompanyManagementReset.fourDotFiveAdmin  ' + angular.toJson(_this.CompanyManagementReset.fourDotFiveAdmin));
                        //this.getAssessmentWorkFlow(this.loggedInUserDetails.company.companyId);
                        _this._saveUserConfiguration(function (data) {
                            _this.saveButtonFlag++;
                            _this.saveButtonClicked = false;
                            _this.companyManagement.userConfiguration = angular.copy(data);
                            _this.CompanyManagementReset.userConfiguration = angular.copy(data);
                            // if((this.StorageService.get('companyDetails') != null || this.companyDetailsUpdateMode)) {
                            _this.alertsAndNotificationsService.showBannerMessage(_this.MESSAGECONSTANTS.NOTIFICATIONS.COMPANY.COMPANY + " '<b><i class='wrap-word'>" + _this.delimitedCompanyOrClientName + "</i></b>' " + _this.MESSAGECONSTANTS.NOTIFICATIONS.COMPANY.UPDATESUCCESS, 'success');
                            // } else if(!(this.companyDetailsUpdateMode)) {
                            //     this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.COMPANY.COMPANY + " '<b><i class='wrap-word'>" + this.delimitedCompanyOrClientName + "</i></b>' " + this.MESSAGECONSTANTS.NOTIFICATIONS.COMPANY.COMPANYDRAFTSUCCESS, 'success')
                            // }
                            _this.companyStepThreeSaved = true;
                        }, function (error) {
                            if (_this.$rootScope.isOnline) {
                                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                            }
                            _this.disableActionButtons = false;
                        });
                    }, function (error) {
                        if (_this.$rootScope.isOnline) {
                            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                        }
                        console.log('now assigning original obj to transaction and saved objects');
                        _this.savedFourDotFiveAdmin = angular.copy(_this.savedFourDotFiveAdminCopy);
                    });
                }
                else if (!this.valid) {
                    console.log('Step 3 mandatory fileds not filled.');
                    this.step3FormSubmitted = true;
                    this.triggerCount = 0;
                }
                else if (this.valid && (!this.stepThreeChanged)) {
                    this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.NOTHING_TO_SAVE, 'success');
                    this.saveButtonClicked = false;
                }
                break;
            case 4:
                console.log('Step 4 clicked on save :');
                console.log('this.companyManagement.licensePreferences: ' + angular.toJson(this.companyManagement.licensePreferences));
                console.log('angular.equals(this.companyManagement.licensePreferences, this.preferences: ' + angular.equals(this.companyManagement.licensePreferences, this.preferences));
                // this.stepFiveChanged = angular.equals(this.originalStepFive, this.companyManagement.licensePreferences);
                if (this.isPlanChosen && this.isActivePlanExists) {
                    this.stepFourChanged = !(angular.equals(this.originalStepFour, this.selectedPlan));
                    console.log('Step 4 is changed: ' + this.stepFourChanged);
                    console.log('Save for companyid: ' + this.newlyCreatedCompanyId);
                }
                if (this.isPlanChosen && this.stepFourChanged) {
                    this.planService.savePlan(this.selectedPlan, function (data) {
                        _this.saveButtonFlag++;
                        // data.planHeaderDto.planStartDateDisplay = this.$filter('fourdotfiveDateFormat')(data.planHeaderDto.planStartDate);
                        // data.planHeaderDto.planEndDateDisplay = this.$filter('fourdotfiveDateFormat')(data.planHeaderDto.planEndDate);
                        data.planHeaderDto.unformattedStartDate = moment(data.planHeaderDto.planStartDate).toDate();
                        data.planHeaderDto.unformattedEndDate = moment(data.planHeaderDto.planEndDate).toDate();
                        data.planHeaderDto.planStartDateDisplay = moment(data.planHeaderDto.unformattedStartDate).tz(data.planHeaderDto.timeZoneName).format("MMM DD, YYYY");
                        data.planHeaderDto.planEndDateDisplay = moment(data.planHeaderDto.unformattedEndDate).tz(data.planHeaderDto.timeZoneName).format("MMM DD, YYYY");
                        _this.originalStepFour = angular.copy(data);
                        _this.savedCurrentActivePlan = angular.copy(data);
                        _this.selectedPlan = angular.copy(data);
                        _this.isActivePlanExists = true;
                        _this.alertsAndNotificationsService.showBannerMessage('Company plan details saved successfully', 'success');
                        _this.companyStepFourSaved = true;
                        _this.saveButtonClicked = false;
                    }, function (error) {
                        if (_this.$rootScope.isOnline) {
                            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                        }
                    });
                }
                else if (!this.stepFourChanged) {
                    this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.NOTHING_TO_SAVE, 'success');
                    this.saveButtonClicked = false;
                }
                else if (!this.isPlanChosen) {
                    this.step4formsubmitted = true;
                    this.triggerCount = 0;
                }
                break;
            case 5:
                this._setHasUnsavedAssessmentCredentials();
                this._setHasUnsavedJobBoardCredentials();
                console.log('Step 5 clicked on save :');
                console.log('this.companyManagement.licensePreferences: ' + angular.toJson(this.companyManagement.licensePreferences));
                console.log('angular.equals(this.companyManagement.licensePreferences, this.preferences: ' + angular.equals(this.companyManagement.licensePreferences, this.preferences));
                // this.stepFiveChanged = angular.equals(this.originalStepFive, this.companyManagement.licensePreferences);
                this.parseWorkflowStepsOrderBeforeSave();
                this.stepFiveChanged = !(angular.equals(this.preferences, this.originalStepFive));
                console.log('Step 5 is changed: ' + this.stepFiveChanged);
                console.log('Save for companyid: ' + this.newlyCreatedCompanyId);
                if (this.TypeOfCompany == 'Client' || this.StorageService.get('SelectedHostCompany') != null || this.TypeOfCompany == 'BusinessUnit') {
                    if (this.showRemoveButton) {
                        this.valid = this.form.companyDetailsForm.$valid && this.form.companyContactPersonDetailsForm.$valid && this.form.companySecondaryContactPersonDetailsForm.$valid && this.form.companyAssessmentFlowDetailsForm.$valid;
                    }
                    else {
                        this.valid = this.form.companyDetailsForm.$valid && this.form.companyContactPersonDetailsForm.$valid && this.form.companyAssessmentFlowDetailsForm.$valid;
                    }
                }
                else {
                    if (this.showRemoveButton) {
                        this.valid = this.form.companyDetailsForm.$valid && this.form.companyContactPersonDetailsForm.$valid && this.form.companySecondaryContactPersonDetailsForm.$valid && this.selectedFourDotFiveAdmin.length > 0 && this.form.companyAssessmentFlowDetailsForm.$valid;
                    }
                    else {
                        this.valid = this.form.companyDetailsForm.$valid && this.form.companyContactPersonDetailsForm.$valid && this.selectedFourDotFiveAdmin.length > 0 && this.form.companyAssessmentFlowDetailsForm.$valid;
                    }
                }
                var techOrValueAssessmentAccessTimesNotChosenFlag = this._accessTimeOptionErrorExists();
                if (this.StorageService.get('SelectedHostCompany') != null) {
                    this.newlyCreatedCompanyId = this.$rootScope.userDetails.company.companyId;
                }
                //This condition will satisfy if editing a client/bu
                if (this.clientOrBuUpdateInProgress) {
                    this.newlyCreatedCompanyId = this.companyManagement.company.id;
                    console.log('Update Client set licence preferences: ' + this.newlyCreatedCompanyId);
                }
                console.log('validations are proper: ' + this.valid);
                if (this.valid && this.stepFiveChanged && !techOrValueAssessmentAccessTimesNotChosenFlag && !this.hasUnsavedAssessmentCredentials && !this.hasUnsavedJobBoardCredentials) {
                    //Building the SavedCompanyManagement object before saving.
                    this.savedAssessmentWorkFlowCopy = angular.copy(this.savedAssessmentWorkFlow);
                    this.savedAssessmentWorkFlow = angular.copy(this.preferences);
                    this.limitCharactersInName();
                    console.log('Saving :' + angular.toJson(this.savedAssessmentWorkFlow));
                    var clientOrCompany;
                    if (this.TypeOfCompany == 'Client' || this.TypeOfCompany == 'BusinessUnit') {
                        clientOrCompany = this.COMPANYMANAGEMENTCONSTANTS.CONTROLLER.SET_LICENCE_PREFERENCES_FOR_CLIENT_BU + '/' + this.$rootScope.userDetails.company.companyId + '/' + this.newlyCreatedCompanyId;
                    }
                    else {
                        clientOrCompany = this.COMPANYMANAGEMENTCONSTANTS.CONTROLLER.SET_LICENCE_PREFERENCES + '/' + this.$rootScope.userDetails.company.companyType + '/' + this.newlyCreatedCompanyId;
                    }
                    console.log('Url is: ' + clientOrCompany);
                    this.genericService.addObject(clientOrCompany, this.savedAssessmentWorkFlow).subscribe(function (data) {
                        //                     console.log('Success: ' + angular.toJson(data.body));
                        _this.saveButtonFlag++;
                        if (!_.isNull(data.body.jobBoardCredentialList)) {
                            data.body.jobBoardCredentialList = _this.massageJobBoardCredentials(data.body.licensePreferences.jobBoardCredentialList);
                        }
                        _this.companyManagement.licensePreferences = angular.copy(data.body.licensePreferences);
                        _this.originalStepFive = angular.copy(data.body.licensePreferences);
                        // update existing job credentials list
                        _this.preferences.jobBoardCredentialList = data.body.licensePreferences.jobBoardCredentialList;
                        _this.massageWorkflowStepsOrder();
                        // Updating SavedCompanyManagement object after saving.
                        _this.savedAssessmentWorkFlow = angular.copy(data.body.licensePreferences);
                        if (_this.clientOrBuUpdateInProgress && !(angular.equals(_this.originalStepFive, _this.AssessmentWorkFlow))) {
                            console.log('Working now no msg');
                            if (_this.TypeOfCompany == 'Client') {
                                _this.alertsAndNotificationsService.showBannerMessage(_this.MESSAGECONSTANTS.NOTIFICATIONS.CLIENT.CLIENT + " '<b><i class='wrap-word'>" + _this.delimitedCompanyOrClientName + "</i></b>' " + _this.MESSAGECONSTANTS.NOTIFICATIONS.CLIENT.UPDATESUCCESS, 'success');
                            }
                            else {
                                _this.alertsAndNotificationsService.showBannerMessage(_this.MESSAGECONSTANTS.NOTIFICATIONS.BU.BU + " '<b><i class='wrap-word'>" + _this.delimitedCompanyOrClientName + "</i></b>' " + _this.MESSAGECONSTANTS.NOTIFICATIONS.BU.UPDATESUCCESS, 'success');
                            }
                            // this.$state.go('missioncontrol.clientsOrBus', null, { reload: false });
                        }
                        else if ((_this.StorageService.get('companyDetails') != null || _this.StorageService.get('SelectedHostCompany') != null) && _this.companyDetailsUpdateMode) {
                            if (_this.$rootScope.userDetails.roleScreenRef.role.name != 'CorporateAdmin' && _this.$rootScope.userDetails.roleScreenRef.role.name != 'StaffingAdmin') {
                                _this.alertsAndNotificationsService.showBannerMessage(_this.MESSAGECONSTANTS.NOTIFICATIONS.COMPANY.COMPANY + " '<b><i class='wrap-word'>" + _this.delimitedCompanyOrClientName + "</i></b>' " + _this.MESSAGECONSTANTS.NOTIFICATIONS.COMPANY.UPDATESUCCESS, 'success');
                            }
                        }
                        else if (_this.clientOrBuCreationInProgress) {
                            if (_this.TypeOfCompany == 'Client') {
                                _this.alertsAndNotificationsService.showBannerMessage(_this.MESSAGECONSTANTS.NOTIFICATIONS.CLIENT.CLIENT + " '<b><i class='wrap-word'>" + _this.delimitedCompanyOrClientName + "</i></b>' " + _this.MESSAGECONSTANTS.NOTIFICATIONS.CLIENT.CREATEDRAFTSUCCESS, 'success');
                            }
                            else {
                                _this.alertsAndNotificationsService.showBannerMessage(_this.MESSAGECONSTANTS.NOTIFICATIONS.BU.BU + " '<b><i class='wrap-word'>" + _this.delimitedCompanyOrClientName + "</i></b>' " + _this.MESSAGECONSTANTS.NOTIFICATIONS.BU.CREATEDRAFTSUCCESS, 'success');
                            }
                        }
                        else if (_this.isCompanyAdmin) {
                            _this.alertsAndNotificationsService.showBannerMessage(_this.MESSAGECONSTANTS.NOTIFICATIONS.COMPANY.COMPANY + " '<b><i class='wrap-word'>" + _this.delimitedCompanyOrClientName + "</i></b>' " + _this.MESSAGECONSTANTS.NOTIFICATIONS.COMPANY.UPDATESUCCESS, 'success');
                        }
                        else if (!_this.companyDetailsUpdateMode) {
                            _this.alertsAndNotificationsService.showBannerMessage(_this.MESSAGECONSTANTS.NOTIFICATIONS.COMPANY.COMPANY + " '<b><i class='wrap-word'>" + _this.delimitedCompanyOrClientName + "</i></b>' " + _this.MESSAGECONSTANTS.NOTIFICATIONS.COMPANY.COMPANYDRAFTSUCCESS, 'success');
                        }
                        _this.companyStepFiveSaved = true;
                        _this.saveButtonClicked = false;
                        //No update of company to active state from draft state on click of save.
                        /*if (this.companyManagement.company.companyType != 'Host') {
                            this.genericService.addObject(this.COMPANYMANAGEMENTCONSTANTS.CONTROLLER.CHANGE_COMPANYSTATE + '/' + this.newlyCreatedCompanyId, this.companyManagement).subscribe(function (data) {
                                console.log('Selected Company ClientOrBus Data received is : ' + angular.toJson(data.body));
                            }, function (error) {
                                console.log('Selected Company ClientOrBus Data error : ' + angular.toJson(error));
                            });
                        }*/
                    }, function (error) {
                        if (_this.$rootScope.isOnline) {
                            if (error.error && error.error.message) {
                                var updatedMessage = error.error.message;
                                if (updatedMessage.includes('<br>')) {
                                    updatedMessage = error.error.message.split('<br>')[0];
                                }
                                _this.alertsAndNotificationsService.showBannerMessage(updatedMessage, 'danger');
                            }
                            else {
                                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                            }
                        }
                        if (error.statusCode == "409") {
                            _this.errorInSavingPrefsCheck = true;
                            _this.getAssessmentWorkFlow(_this.$rootScope.userDetails.company.companyId);
                        }
                        else {
                            _this.savedAssessmentWorkFlow = angular.copy(_this.savedAssessmentWorkFlowCopy);
                        }
                    });
                }
                else if (this.valid && techOrValueAssessmentAccessTimesNotChosenFlag) {
                    this.alertsAndNotificationsService.showBannerMessage("Please enable Access Time option(s) to continue.", 'danger');
                    this.step5formsubmitted = true;
                }
                else if (this.valid && this.hasUnsavedAssessmentCredentials && this.hasUnsavedJobBoardCredentials) {
                    this.showUnsavedCredentialsWarning("Unsaved data will be lost. Assessments and Job Boards Credentials data have not been saved.");
                }
                else if (this.valid && this.hasUnsavedAssessmentCredentials) {
                    this.showUnsavedCredentialsWarning("Unsaved data will be lost. Assessments Credentials data has not been saved.");
                }
                else if (this.valid && this.hasUnsavedJobBoardCredentials) {
                    this.showUnsavedCredentialsWarning("Unsaved data will be lost. Job Boards Credentials data has not been saved.");
                }
                else if (this.valid && !this.stepFiveChanged) {
                    console.log("clientOrBuUpdateInProgress");
                    this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.NOTHING_TO_SAVE, 'success');
                    this.saveButtonClicked = false;
                    //this.$state.go('missioncontrol.clientsOrBus', null, { reload: false });
                }
                else if (!this.valid) {
                    this.step5formsubmitted = true;
                }
                this.isTestLinkReadOnly = true;
                break;
            case 6:
                this.stepSixChanged = !(angular.equals(this.vendors, this.originalStepSix));
                console.log('Step 6 is changed: ' + this.stepSixChanged);
                console.log('Save for companyid: ' + this.newlyCreatedCompanyId);
                if (this.showRemoveButton == 'Remove') {
                    this.valid = this.form.companyDetailsForm.$valid && this.form.companyContactPersonDetailsForm.$valid && this.form.companySecondaryContactPersonDetailsForm.$valid;
                }
                else {
                    this.valid = this.form.companyDetailsForm.$valid && this.form.companyContactPersonDetailsForm.$valid;
                }
                //This condition will satisfy if editing a client/bu
                if (this.clientOrBuUpdateInProgress) {
                    this.newlyCreatedCompanyId = this.companyManagement.company.id;
                    console.log('Update Client set licence preferences: ' + this.newlyCreatedCompanyId);
                }
                console.log('validations are proper: ' + this.valid);
                if (this.valid && this.stepSixChanged) {
                    this.savedVendorsCopy = angular.copy(this.savedVendors);
                    this.savedVendors = angular.copy(this.vendors);
                    this.limitCharactersInName();
                    this.modifiedVendors = this.getModifiedVendors();
                    this.saveVendorsSaveClicked = true;
                    if (this.modifiedVendors.disassociatedVendors.length > 0) {
                        this.getBuVendorsRequisitionsCountAndLaunchDisassoicateModal();
                    }
                    else {
                        this.saveVendorsOnSave();
                    }
                }
                else if (this.valid && !this.stepSixChanged) {
                    this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.NOTHING_TO_SAVE, 'success');
                    this.saveButtonClicked = false;
                }
                else if (!this.valid) {
                    this.step6formsubmitted = true;
                }
                break;
            case 7:
                this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.NOTHING_TO_SAVE, 'success');
                break;
        }
    };
    CompanyPageController.prototype.onEnableBrandingChange = function () {
        if (this.preferences.enableCompanyBranding) {
            this.preferences.frontPageLogoS3Url = this.savedAssessmentWorkFlow.frontPageLogoS3Url;
            this.preferences.addSmallHeaderToReport = this.savedAssessmentWorkFlow.addSmallHeaderToReport;
            this.onEnableSmallLogo();
        }
        else {
            this.preferences.frontPageLogoS3Url = null;
            this.preferences.addSmallHeaderToReport = false;
            this.onEnableSmallLogo();
        }
    };
    CompanyPageController.prototype.onEnableSmallLogo = function () {
        if (this.preferences.addSmallHeaderToReport) {
            this.preferences.smallHeaderLogoS3Url = this.savedAssessmentWorkFlow.smallHeaderLogoS3Url;
        }
        else {
            this.preferences.smallHeaderLogoS3Url = null;
        }
    };
    CompanyPageController.prototype.saveVendorsOnSave = function () {
        var _this = this;
        this.companyService.saveBuVendors(this.vendors, function (data) {
            _this.saveButtonFlag++;
            _this.vendors = angular.copy(data);
            _this.originalStepSix = angular.copy(data);
            _this.savedVendors = angular.copy(data);
            if (_this.clientOrBuUpdateInProgress && !(angular.equals(_this.originalStepSix, _this.savedVendorsCopy))) {
                _this.alertsAndNotificationsService.showBannerMessage(_this.MESSAGECONSTANTS.NOTIFICATIONS.BU.BU + " '<b><i class='wrap-word'>" + _this.delimitedCompanyOrClientName + "</i></b>' " + _this.MESSAGECONSTANTS.NOTIFICATIONS.BU.UPDATESUCCESS, 'success');
            }
            else if (_this.clientOrBuCreationInProgress) {
                _this.alertsAndNotificationsService.showBannerMessage(_this.MESSAGECONSTANTS.NOTIFICATIONS.BU.BU + " '<b><i class='wrap-word'>" + _this.delimitedCompanyOrClientName + "</i></b>' " + _this.MESSAGECONSTANTS.NOTIFICATIONS.BU.CREATEDRAFTSUCCESS, 'success');
            }
            _this.companyStepSixSaved = true;
            _this.saveButtonClicked = false;
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    CompanyPageController.prototype.getModifiedVendors = function () {
        var _this = this;
        var modifiedVendors = {
            disassociatedVendors: [],
            associatedVendors: []
        };
        angular.forEach(this.vendors.vendorDtoList, function (vendor, key) {
            angular.forEach(_this.originalStepSix.vendorDtoList, function (savedVendor, savedVendorKey) {
                if (vendor.vendorId == savedVendor.vendorId && !vendor.isSelected && savedVendor.isSelected) {
                    modifiedVendors.disassociatedVendors.push(vendor);
                }
                else if (vendor.vendorId == savedVendor.vendorId && vendor.isSelected && !savedVendor.isSelected) {
                    modifiedVendors.associatedVendors.push(vendor);
                }
            });
        });
        for (var i = 0; i < modifiedVendors.disassociatedVendors.length; i++) {
            modifiedVendors.disassociatedVendors[i].buId = this.vendors.buId;
            modifiedVendors.disassociatedVendors[i].corporateCompanyId = this.vendors.corporateCompanyId;
        }
        return modifiedVendors;
    };
    CompanyPageController.prototype.getBuVendorsRequisitionsCountAndLaunchDisassoicateModal = function () {
        this.getBuVendorsDetails(0);
    };
    CompanyPageController.prototype.getBuVendorsDetails = function (index) {
        var _this = this;
        this.companyService.getSharedReqAndBuCount(this.modifiedVendors.disassociatedVendors[index], function (data) {
            _this.modifiedVendors.disassociatedVendors[index].requisitionCount = data.requisitionCount;
            if (index == _this.modifiedVendors.disassociatedVendors.length - 1) {
                _this.launchDisassociateVendorsModal(_this.modifiedVendors);
            }
            else if (index < _this.modifiedVendors.disassociatedVendors.length - 1) {
                _this.getBuVendorsDetails(index + 1);
            }
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    CompanyPageController.prototype.launchDisassociateVendorsModal = function (modifiedVendors) {
        var _this = this;
        var disassociateVendorsModal = this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            windowClass: 'four-dot-five-modal-small',
            component: 'disassociateVendorsModal',
            resolve: {
                buVendorsInfo: function () {
                    return modifiedVendors;
                },
                note: function () {
                    return "";
                }
            }
        });
        disassociateVendorsModal.result.then(function (callbackObject) {
            if (callbackObject.callbackType == 'cancel') {
                _this.vendors = angular.copy(_this.originalStepSix);
            }
            else if (callbackObject.callbackType == 'disassociate') {
                _this.vendors.note = callbackObject.entity.note;
                if (_this.saveVendorsSaveClicked) {
                    _this.saveVendorsOnSave();
                }
                else {
                    _this.saveVendorsOnComplete();
                }
            }
        }, function (dismiss) {
            //do nothing
        });
    };
    /**
     this.triggerCount = 0;
     * Toggle company address to user checkbox.
     */
    CompanyPageController.prototype.toggleCopyCompanyAddress = function () {
        var _this = this;
        this.copyCompanyAddress = document.getElementById("copyCompanyAddress").checked;
        var companyAddressZipcode;
        console.log(this.$rootScope.userDetails.company.companyId);
        if (this.copyCompanyAddress) {
            this.genericService.getObjects(this.COMPANYMANAGEMENTCONSTANTS.CONTROLLER.GET_COMPANY + '/' + this.$rootScope.userDetails.company.companyId).subscribe(function (data) {
                companyAddressZipcode = data.body.company.zipcode;
                _this.companyManagement.company.address1 = data.body.company.address1;
                _this.companyManagement.company.address2 = data.body.company.address2;
                _this.companyManagement.company.zipcode = companyAddressZipcode;
                _this.cancelClicked = false;
                _this.getAddressDetails(companyAddressZipcode, 'copycomanyaddress', function (response) {
                    angular.element('.companyaddresscopyenabled').attr({ 'readonly': true, 'disabled': true });
                });
            }, function (error) {
                if (_this.$rootScope.isOnline) {
                    _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                }
            });
        }
        else {
            this.copyCompanyAddress = false;
            angular.element('.companyaddresscopyenabled').attr({ 'readonly': false, 'disabled': false });
            if (this.accessMode == this.MESSAGECONSTANTS.ACCESS_MODES.EDIT) {
                this.companyManagement.company.address1 = this.savedCompanyManagement.company.address1;
                this.companyManagement.company.address2 = this.savedCompanyManagement.company.address2;
                this.companyManagement.company.zipcode = this.savedCompanyManagement.company.zipcode;
                this.getAddressDetails(this.companyManagement.company.zipcode, 'zipchanged', function (response) {
                    if (angular.isDefined(_this.savedCompanyManagement.company.county) && (_this.savedCompanyManagement.company.county !== null)
                        && (_this.companyManagement.company.zipcode === _this.savedCompanyManagement.company.zipcode)) {
                        _this.companyManagement.company.county = _this.savedCompanyManagement.company.county;
                        // this.$scope.safeApply();
                    }
                });
            }
            else {
                this.companyManagement.company.address1 = this.savedCompanyManagement.company.address1;
                this.companyManagement.company.address2 = this.savedCompanyManagement.company.address2;
                this.companyManagement.company.zipcode = this.savedCompanyManagement.company.zipcode;
                this.getAddressDetails(this.companyManagement.company.zipcode, 'zipchanged', function (response) {
                    if (angular.isDefined(_this.savedCompanyManagement.company.county) && (_this.savedCompanyManagement.company.county !== null)
                        && (_this.companyManagement.company.zipcode === _this.savedCompanyManagement.company.zipcode)) {
                        _this.companyManagement.company.county = _this.savedCompanyManagement.company.county;
                        // this.$scope.safeApply();
                    }
                });
            }
        }
    };
    CompanyPageController.prototype.updatedLicensePrefsOnSave = function () {
        var _this = this;
        this.genericService.getObjects(this.COMPANYMANAGEMENTCONSTANTS.CONTROLLER.GET_ASSESSMENT_WORK_FLOW + '' + this.$rootScope.userDetails.company.companyType + '/' + this.$rootScope.userDetails.company.companyId).subscribe(function (data) {
            //this.originalStepFive = angular.copy(data.body);
            if (!_.isNull(data.body.jobBoardCredentialList)) {
                data.body.jobBoardCredentialList = _this.massageJobBoardCredentials(data.body.jobBoardCredentialList);
            }
            _this.savedAssessmentWorkFlow = angular.copy(data.body);
            _this.preferences = angular.copy(_this.savedAssessmentWorkFlow);
            _this.massageWorkflowStepsOrder();
            _this.licensePreferencesFetched = true;
            _this.accessTimeOptionsDisabled = !(_this.preferences.techAssessmentList.licensePrefDetailsList[0].selected || _this.preferences.valueAssessmentList.licensePrefDetailsList[0].selected);
            _this.stepFiveChanged = !(angular.equals(_this.originalStepFive, _this.preferences));
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    CompanyPageController.prototype.manageStepDataAfterTimeout = function (Company, ContactList, FourDotFiveAdmin) {
        var _this = this;
        console.log('this.$timeout 1000');
        this.$timeout(function () {
            _this.manageStepData(Company, ContactList, FourDotFiveAdmin);
        }, 1000);
    };
    /** Function to control wizard flow with validations
     *
     */
    CompanyPageController.prototype.manageStepData = function (Company, ContactList, FourDotFiveAdmin) {
        var _this = this;
        console.log('clicked on next with this.triggerCount : ' + this.triggerCount);
        //         console.log('Company Management Details: ' + angular.toJson(this.companyManagement) + 'Contact Person: ' + angular.toJson(ContactList) + 'FourDotFiveAdmin: ' + angular.toJson(FourDotFiveAdmin));
        //alert(this.triggerCount);
        if (this.triggerCount === 0) {
            this.triggerCount = angular.copy(this.triggerCount + 1);
            this.formsubmitted = true;
            this.nextButtonClicked = true;
            this.saveButtonClicked = false;
            this.StorageService.remove('wizardoperations');
            this.valid = false;
            var currentStep = this.getCurrentStep();
            //alert(currentStep);
            console.log('In manageStepData function : saving details of step: ' + currentStep);
            if (currentStep == 3 && ((this.TypeOfCompany == 'Client') || this.StorageService.get('SelectedHostCompany') != null || this.TypeOfCompany == 'BusinessUnit')) {
                currentStep = 5;
            }
            if (currentStep == 4 && this.TypeOfCompany == 'BusinessUnit') {
                currentStep = 6;
            }
            if (currentStep == 4 && this.TypeOfCompany == 'Client' && this.isAssociatedClientUpdateInProgress) {
                currentStep = 7;
            }
            switch (currentStep) {
                case 1:
                    this.stepOneChanged = !(angular.equals(this.originalStepOne, this.companyManagement.company)); //Checks if any changes.
                    console.log('Step 1 is changed: ' + this.stepOneChanged);
                    if (this.companyManagement.company.address1 !== null && this.companyManagement.company.address1 !== undefined) {
                        if (this.companyManagement.company.address2 != null) {
                            this.isAddressValid = !angular.equals(this.companyManagement.company.address1.toUpperCase(), this.companyManagement.company.address2.toUpperCase()) && (this.companyManagement.company.address1 != this.companyManagement.company.address2);
                            console.log('if  ' + this.isAddressValid);
                        }
                        else {
                            console.log('else');
                            this.isAddressValid = this.companyManagement.company.address1 != this.companyManagement.company.address2;
                        }
                    }
                    this.valid = this.form.companyDetailsForm.$valid && this.isAddressValid && this.validzipcode && angular.isDefined(this.validzipcode) && (!this.zipCodeCalling || (this.zipCodeCalling && this.zipCodeCallCompleted)); //Checks validations.
                    console.log('validations are proper  ' + this.valid + ' ' + this.validzipcode + ' ' + this.form.companyDetailsForm.$valid);
                    if (this.valid) {
                        console.log('Step 1 validations are proper, call this.saveCompanyDetails function');
                        if (this.isAssociatedClientUpdateInProgress) {
                            this.nextButtonClicked = false;
                            this.disableActionButtons = true;
                            if (this.stepOneChanged) {
                                this._setSharedClientDescription(function () {
                                    _this.disableActionButtons = false;
                                    _this.nextButtonFlag++;
                                    _this.isCompanyDetailsSaveCalled = true;
                                    // this.triggerCount = 0;
                                    _this.originalStepOne = angular.copy(_this.companyManagement.company);
                                    //Building the SavedCompanyManagement object before saving.
                                    _this.savedCompanyManagementCopy.company = angular.copy(_this.savedCompanyManagement.company);
                                    _this.savedCompanyManagement.company = angular.copy(_this.companyManagement.company);
                                    // this.stepTrigger('nextbtnclick');
                                    _this.disableActionButtons = false;
                                    _this.StorageService.set('wizardoperations', true);
                                    _this.stepTrigger('nextbtnclick');
                                }, function (error) {
                                    _this.triggerCount = 0;
                                    _this.disableActionButtons = false;
                                    _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                                    _this.savedCompanyManagement.company = angular.copy(_this.savedCompanyManagementCopy.company);
                                });
                            }
                            else if (!this.stepOneChanged) {
                                console.log('Just move no api call');
                                this.step1FormSubmitted = true;
                                this.triggerCount = 0;
                                this.StorageService.set('wizardoperations', true);
                                this.disableActionButtons = false;
                            }
                        }
                        else {
                            if (!angular.isDefined(this.companyManagement.company.companyType)) {
                                if (this.$rootScope.userDetails.company.companyType == 'Corporation') {
                                    this.companyManagement.company.companyType = 'BusinessUnit';
                                }
                                else if (this.$rootScope.userDetails.company.companyType == 'StaffingCompany') {
                                    this.companyManagement.company.companyType = 'Client';
                                }
                            }
                            this.nextButtonClicked = false;
                            this.disableActionButtons = true;
                            this.saveCompanyDetails();
                        }
                    }
                    else {
                        console.log('Just move no api call');
                        this.step1FormSubmitted = true;
                        this.triggerCount = 0;
                        this.disableActionButtons = false;
                    }
                    if (this.savedCompanyManagement.company.companyType === "Host") {
                        this.isValidPrimaryWorkPhoneEntered = true;
                        this.isValidPrimaryMobileEntered = true;
                        this.isValidSecondaryWorkPhoneEntered = true;
                        this.isValidSecondaryMobileEntered = true;
                        angular.forEach(this.phoneValidationStatuses, function (status, key) {
                            status.isValidWorkNumber = true;
                            status.isValidMobileNumber = true;
                        });
                    }
                    break;
                case 2:
                    console.log('Next clicked from step 2 moving to step 3 : ');
                    if (this.TypeOfCompany == 'Company') {
                        this.getAllPlans();
                    }
                    this.cleanContactList();
                    console.log("this.originalStepTwo" + angular.toJson(this.originalStepTwo));
                    console.log("this.companyManagement.contactList" + this.companyManagement.contactList);
                    this.errorOcurred = false;
                    this.stepTwoChanged = !(angular.equals(this.originalStepTwo, this.companyManagement.contactList));
                    console.log('Step 2 is changed: ' + this.stepTwoChanged);
                    if (this.companyManagement.contactList.length == 1) {
                        this.companyManagement.contactList[0].primary = false;
                    }
                    if (this.showRemoveButton) {
                        angular.forEach(this.companyManagement.contactList, function (contact, key) {
                            contact.primary = false;
                        });
                        this.validateSecondaryDetails = true;
                        this.valid = this.form.companyDetailsForm.$valid && this.form.companyContactPersonDetailsForm.$valid && this.form.companySecondaryContactPersonDetailsForm.$valid
                            && this.isValidPrimaryMobileEntered && this.isValidPrimaryWorkPhoneEntered && this.isValidSecondaryMobileEntered && this.isValidSecondaryWorkPhoneEntered && this.isValidPhoneNumbersEntered();
                    }
                    else {
                        console.log('this.form.companyDetailsForm.$valid : ' + this.form.companyDetailsForm.$valid);
                        console.log('this.form.companyContactPersonDetailsForm.$valid : ' + this.form.companyContactPersonDetailsForm.$valid);
                        this.valid = this.form.companyDetailsForm.$valid && this.form.companyContactPersonDetailsForm.$valid;
                    }
                    if (this.valid) {
                        console.log('Step 2 validations are proper, call this.saveContactDetails function');
                        this.nextButtonClicked = false;
                        this.saveContactDetails();
                    }
                    else if (this.StorageService.get('companyDetails') != null && !(this.companyDetailsUpdateMode) && !this.clientOrBuCreationInProgress && !this.clientOrBuUpdateInProgress && !this.vendorUpdateInProgress) {
                        console.log('No api call');
                        this.StorageService.set('wizardoperations', true);
                        if (this.clientOrBuUpdateInProgress) {
                            this.laststep = true;
                        }
                        this.nextButtonClicked = false;
                        this.triggerCount = 0;
                        this.disableActionButtons = false;
                    }
                    else {
                        console.log('validations not proper');
                        this.step2FormSubmitted = true;
                        this.triggerCount = 0;
                        this.disableActionButtons = false;
                    }
                    break;
                case 3:
                    console.log('Next clicked from step 3 moving to step 4 : ');
                    this.oldCheckedAdmin = null;
                    console.log('this.originalStepThree: ' + angular.toJson(this.originalStepThree));
                    console.log('angular.isDefined(this.originalStepThree): ' + angular.isDefined(this.originalStepThree));
                    console.log('this.selectedFourDotFiveAdmin.length: ' + this.selectedFourDotFiveAdmin.length);
                    if (angular.isDefined(this.originalStepThree) && this.originalStepThree != null && this.selectedFourDotFiveAdmin.length > 0) {
                        console.log('Equals of: this.originalStepThree.userId' + this.originalStepThree.userId + ' and: ' + this.selectedFourDotFiveAdmin[0].userId);
                        this.stepThreeChanged = !angular.equals(this.originalStepThree.userId, this.selectedFourDotFiveAdmin[0].userId) || !angular.equals(this.companyManagement.userConfiguration, this.CompanyManagementReset.userConfiguration);
                        this.oldFourDotFiveAdminId = this.originalStepThree.userId;
                    }
                    else if (!angular.isDefined(this.originalStepThree) || (this.originalStepThree === null)) {
                        /**
                         * First condition is satisfied in create company.
                         * Second condition is satisfied when creating a company in
                         * Draft state( without selecting 4dot5admin) and coming to update for the next time later
                         */
                        this.stepThreeChanged = true;
                    }
                    console.log('Four dot five admin selected: ' + this.selectedFourDotFiveAdmin.length == 1);
                    console.log('Step 3 is changed : ' + this.stepThreeChanged);
                    if (this.showRemoveButton) {
                        this.valid = this.form.companyDetailsForm.$valid && this.form.companyContactPersonDetailsForm.$valid && this.form.companySecondaryContactPersonDetailsForm.$valid && this.selectedFourDotFiveAdmin.length > 0;
                    }
                    else {
                        this.valid = this.form.companyDetailsForm.$valid && this.form.companyContactPersonDetailsForm.$valid && this.selectedFourDotFiveAdmin.length > 0;
                    }
                    if (this.valid) {
                        this.valid = this.isPasswordRestrictionsValid();
                        if (!this.valid) {
                            this.complexityRestrictionChange('user');
                            this.complexityRestrictionChange('administrator');
                        }
                    }
                    if (this.valid) {
                        console.log('Step 3 validations are proper, call this.saveFourDotFiveAdminDetails function');
                        this.nextButtonClicked = false;
                        this.saveFourDotFiveAdminDetails();
                    }
                    else if (this.StorageService.get('companyDetails') != null && !(this.companyDetailsUpdateMode)) {
                        console.log('No api call');
                        if (!this.licensePreferencesFetched || this.isCompanyDetailsSaveCalled) {
                            this.disableActionButtons = true;
                            this.getAssessmentWorkFlow(this.StorageService.get('companyDetails').companyId, function () {
                                _this.disableActionButtons = false;
                            });
                        }
                        else {
                            this.StorageService.set('wizardoperations', true);
                            this.stepTrigger('nextbtnclick');
                        }
                        this.laststep = true;
                        this.nextButtonClicked = false;
                        this.StorageService.set('wizardoperations', true);
                        this.triggerCount = 0;
                    }
                    else {
                        console.log('Step 3 mandatory fileds not filled.');
                        this.step3FormSubmitted = true;
                        this.triggerCount = 0;
                    }
                    break;
                case 4:
                    this.stepFourNextClicked = true;
                    console.log('Next clicked from step 4 moving to dashboard : ');
                    console.log('this.selectedPlan : ' + angular.toJson(this.selectedPlan));
                    // if (this.isPlanChosen && this.isActivePlanExists) {
                    //     this.stepFourChanged = !(angular.equals(this.originalStepFour, this.selectedPlan));
                    // console.log('Step 4 is changed: ' + this.stepFourChanged);
                    // console.log('Save for companyid: ' + this.newlyCreatedCompanyId);
                    // }
                    // else if(this.isPlanChosen && !this.isActivePlanExists) {
                    //     this.stepFourChanged = true;
                    //     console.log('Plan chosen for first time');
                    // }
                    console.log('Step 4 is changed : ' + this.stepFourChanged);
                    if (this.isPlanChosen && this.isActivePlanExists) {
                        console.log('Step 4 validations are proper, call save plan function');
                        this.nextButtonClicked = false;
                        this.savePlanDetails();
                    }
                    else if (this.StorageService.get('companyDetails') != null && !(this.companyDetailsUpdateMode)) {
                        console.log('No api call');
                        this.laststep = true;
                        this.StorageService.remove('wizardoperations');
                        this.triggerCount = 0;
                        this.nextButtonClicked = false;
                        this.laststep = true;
                    }
                    else {
                        this.step4formsubmitted = true;
                        this.triggerCount = 0;
                    }
                    break;
                case 5:
                    console.log('Next clicked from step 5 moving to dashboard : ');
                    this._setHasUnsavedAssessmentCredentials();
                    this._setHasUnsavedJobBoardCredentials();
                    console.log('this.companyManagement.licensePreferences : ' + angular.toJson(this.companyManagement.licensePreferences));
                    console.log('this.preferences : ' + angular.toJson(this.preferences));
                    this.parseWorkflowStepsOrderBeforeSave();
                    this.stepFiveChanged = !(angular.equals(this.companyManagement.licensePreferences, this.preferences));
                    // this.stepFiveChanged = !(angular.equals(this.originalStepFive, this.preferences));
                    console.log('Step 5 is changed : ' + this.stepFiveChanged);
                    if (this.TypeOfCompany == 'Client' || this.TypeOfCompany == 'BusinessUnit' || this.companyManagement.company.companyType == 'Host') {
                        console.log('Host or client or bu');
                        if (this.showRemoveButton) {
                            this.valid = this.form.companyDetailsForm.$valid && this.form.companyContactPersonDetailsForm.$valid && this.form.companySecondaryContactPersonDetailsForm.$valid && this.form.companyAssessmentFlowDetailsForm.$valid;
                        }
                        else {
                            this.valid = this.form.companyDetailsForm.$valid && this.form.companyContactPersonDetailsForm.$valid && this.form.companyAssessmentFlowDetailsForm.$valid;
                        }
                    }
                    else {
                        console.log('Staffing or corporate');
                        if (this.showRemoveButton) {
                            this.valid = this.form.companyDetailsForm.$valid && this.form.companyContactPersonDetailsForm.$valid && this.form.companySecondaryContactPersonDetailsForm.$valid && this.selectedFourDotFiveAdmin.length > 0 && this.form.companyAssessmentFlowDetailsForm.$valid;
                        }
                        else {
                            this.valid = this.form.companyDetailsForm.$valid && this.form.companyContactPersonDetailsForm.$valid && this.selectedFourDotFiveAdmin.length > 0 && this.form.companyAssessmentFlowDetailsForm.$valid;
                        }
                    }
                    var techOrValueAssessmentAccessTimesNotChosenFlag = this._accessTimeOptionErrorExists();
                    if (this.valid && !techOrValueAssessmentAccessTimesNotChosenFlag && !this.hasUnsavedAssessmentCredentials && !this.hasUnsavedJobBoardCredentials) {
                        console.log('Step 5 validations are proper, call this.saveAssessmentFlowDetails function');
                        this.nextButtonClicked = false;
                        this.saveAssessmentFlowDetails();
                    }
                    else if (this.valid && techOrValueAssessmentAccessTimesNotChosenFlag) {
                        this.alertsAndNotificationsService.showBannerMessage("Please enable Access Time option(s) to continue.", 'danger');
                        this.triggerCount = 0;
                    }
                    else if (this.valid && this.hasUnsavedAssessmentCredentials && this.hasUnsavedJobBoardCredentials) {
                        this.showUnsavedCredentialsWarning("Unsaved data will be lost. Assessments and Job Boards Credentials data have not been saved.");
                        this.triggerCount = 0;
                    }
                    else if (this.valid && this.hasUnsavedAssessmentCredentials) {
                        this.showUnsavedCredentialsWarning("Unsaved data will be lost. Assessments Credentials data has not been saved.");
                        this.triggerCount = 0;
                    }
                    else if (this.valid && (this.hasUnsavedJobBoardCredentials)) {
                        this.showUnsavedCredentialsWarning("Unsaved data will be lost. Job Boards Credentials data has not been saved.");
                        this.triggerCount = 0;
                    }
                    else if (this.StorageService.get('companyDetails') != null && !(this.companyDetailsUpdateMode) && !this.clientOrBuCreationInProgress && !this.clientOrBuUpdateInProgress) {
                        console.log('No api call');
                        this.laststep = true;
                        this.StorageService.remove('wizardoperations');
                        this.triggerCount = 0;
                        this.nextButtonClicked = false;
                        /*  this.$timeout(function () {
                              this.$state.go('missioncontrol.dashboard', { companyObject: 'companyObject' }, { reload: false });
                          }, 4000);*/
                    }
                    else {
                        this.step5formsubmitted = true;
                        this.triggerCount = 0;
                    }
                    break;
                case 6:
                    this.stepSixChanged = !(angular.equals(this.vendors, this.originalStepSix));
                    console.log('Step 6 is changed : ' + this.stepSixChanged);
                    if (this.TypeOfCompany == 'Client' || this.TypeOfCompany == 'BusinessUnit' || this.companyManagement.company.companyType == 'Host') {
                        console.log('Host or client or bu');
                        if (this.showRemoveButton) {
                            this.valid = this.form.companyDetailsForm.$valid && this.form.companyContactPersonDetailsForm.$valid && this.form.companySecondaryContactPersonDetailsForm.$valid;
                        }
                        else {
                            this.valid = this.form.companyDetailsForm.$valid && this.form.companyContactPersonDetailsForm.$valid;
                        }
                    }
                    if (this.valid) {
                        this.nextButtonClicked = false;
                        this.saveVendors();
                    }
                    else if (this.StorageService.get('companyDetails') != null && !(this.companyDetailsUpdateMode) && !this.clientOrBuCreationInProgress && !this.clientOrBuUpdateInProgress) {
                        this.laststep = true;
                        this.StorageService.remove('wizardoperations');
                        this.triggerCount = 0;
                        this.nextButtonClicked = false;
                    }
                    else {
                        this.step6formsubmitted = true;
                        this.triggerCount = 0;
                    }
                    break;
                case 7:
                    if (this.companyManagement.companyState == 'Draft' || this.companyManagement.companyState == null) {
                        console.log('Saved Company Object: ' + angular.toJson(this.savedCompanyManagement));
                        this.changeCompanyState();
                    }
                    this.laststep = true;
                    this.StorageService.set('wizardoperations', true);
                    this.lastStepCompleted = true;
                    this.alertsAndNotificationsService.showBannerMessage(this.MESSAGECONSTANTS.NOTIFICATIONS.CLIENT.NOTHING_TO_UPDATED, 'success');
                    this.$timeout(function () {
                        _this.$state.go('missioncontrol.clientsOrBus', null, { reload: true });
                    }, 300);
                    break;
                default:
                    console.log('Default');
            }
        }
        else {
            this.triggerCount = 0;
        }
    };
    CompanyPageController.prototype.toggleAssessmentWorkFlowValues = function (index, workflow) {
        var showWarningFlag = false;
        if (!workflow.selected) {
            if (workflow.name == 'Auto Match') {
                this.preferences.matchCount = null;
            }
            if (workflow.candidatesPresentOnStep) {
                switch (workflow.name) {
                    case "Recruiter Screening":
                        showWarningFlag = true;
                        break;
                    case "Tech Assessment":
                        showWarningFlag = true;
                        break;
                    case "Value Assessment":
                        showWarningFlag = true;
                        break;
                    case "Phone Screen":
                        showWarningFlag = true;
                        break;
                    case "Interview":
                        showWarningFlag = true;
                        break;
                    case "Education Verification":
                        showWarningFlag = true;
                        break;
                    case "Experience Verification":
                        showWarningFlag = true;
                        break;
                }
                if (showWarningFlag) {
                    workflow.selected = true;
                    this.showCandidatesAvailableOnStepWarning(workflow.messageForCandidatePresent, workflow.name);
                }
            }
        }
        else {
            if (workflow.name == 'Auto Match') {
                this.preferences.matchCount = 2;
            }
        }
        this.massageWorkflowStepsOrder();
        this.accessTimeOptionsDisabled = !(this.preferences.techAssessmentList.licensePrefDetailsList[0].selected || this.preferences.valueAssessmentList.licensePrefDetailsList[0].selected);
        this.stepFiveChanged = !(angular.equals(this.originalStepFive, this.preferences));
    };
    CompanyPageController.prototype.showCandidatesAvailableOnStepWarning = function (message, stepName) {
        var _this = this;
        var context = "";
        if (this.TypeOfCompany == "BusinessUnit" || this.TypeOfCompany == "Client") {
            context = "clientOrBu";
        }
        else if (this.$rootScope.userDetails.company.companyType == 'Corporation') {
            context = "corporation";
        }
        else {
            context = "staffingCompany";
        }
        var workflowStepWarningModal = this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            windowTopClass: 'four-dot-five-modal-medium',
            component: 'workflowStepWarningModal',
            resolve: {
                companyId: function () {
                    return _this.$rootScope.userDetails.company.companyId;
                },
                clientOrBuId: function () {
                    return _this.newlyCreatedCompanyId;
                },
                context: function () {
                    return context;
                },
                stepName: function () {
                    return stepName;
                },
                message: function () {
                    return message;
                }
            }
        });
    };
    CompanyPageController.prototype.massageWorkflowStepsOrder = function () {
        var _this = this;
        this.workflowStepsOrder = angular.copy(this.preferences.workflowStepsOrder);
        this.isAnyWorkflowStepsEnabled = false;
        //setting id for dnd list to work
        angular.forEach(this.workflowStepsOrder, function (steps, jobType) {
            var stepsDetails = [];
            angular.forEach(steps, function (step, index) {
                var isStepEnabled = true;
                if (step == "Recruiter Screening") {
                    isStepEnabled = _this.preferences.recruiterScreening.licensePrefDetailsList[0].selected && _this.preferences.recruiterScreening.licensePrefDetailsList[0].enabled;
                }
                else if (step == "Tech Assessment") {
                    isStepEnabled = _this.preferences.techAssessmentList.licensePrefDetailsList[0].selected && _this.preferences.techAssessmentList.licensePrefDetailsList[0].enabled;
                }
                else if (step == "Value Assessment") {
                    isStepEnabled = _this.preferences.valueAssessmentList.licensePrefDetailsList[0].selected && _this.preferences.valueAssessmentList.licensePrefDetailsList[0].enabled;
                }
                else if (step == "Phone Screen") {
                    isStepEnabled = _this.preferences.phoneScreenList.licensePrefDetailsList[0].selected && _this.preferences.phoneScreenList.licensePrefDetailsList[0].enabled;
                }
                else if (step == "Interview") {
                    isStepEnabled = _this.preferences.interviewList.licensePrefDetailsList[0].selected && _this.preferences.interviewList.licensePrefDetailsList[0].enabled;
                }
                if (isStepEnabled) {
                    _this.isAnyWorkflowStepsEnabled = true;
                }
                stepsDetails.push({ id: index, stepName: step, enabled: isStepEnabled, jobType: jobType });
            });
            _this.workflowStepsOrder[jobType] = angular.copy(stepsDetails);
        });
        this.workflowStepsOrderToRender = angular.copy(this.workflowStepsOrder);
        angular.forEach(this.workflowStepsOrderToRender, function (steps, jobType) {
            steps.splice(0, 1);
            steps.splice(steps.length - 1, 1);
        });
    };
    CompanyPageController.prototype.parseWorkflowStepsOrderBeforeSave = function () {
        var _this = this;
        angular.forEach(this.workflowStepsOrder, function (steps, jobType) {
            var stepDetails = [];
            angular.forEach(steps, function (step, index) {
                if (index !== 0 && index !== steps.length - 1) {
                    stepDetails.push(_this.workflowStepsOrderToRender[jobType][index - 1]);
                }
                else {
                    stepDetails.push(step);
                }
            });
            _this.workflowStepsOrder[jobType] = angular.copy(stepDetails);
        });
        var workflowStepsOrderCopy = angular.copy(this.workflowStepsOrder);
        angular.forEach(this.workflowStepsOrder, function (steps, jobType) {
            var stepsDetails = [];
            angular.forEach(steps, function (step, index) {
                stepsDetails.push(step.stepName);
            });
            workflowStepsOrderCopy[jobType] = angular.copy(stepsDetails);
        });
        this.preferences.workflowStepsOrder = angular.copy(workflowStepsOrderCopy);
    };
    /**
     * This function is called on click of 'Add Secondary Contact' button.
     * It allows the user to add secondary contact person for the company/client.
     */
    CompanyPageController.prototype.isSecondaryContactSelected = function (action) {
        var _this = this;
        if (action == 'add') {
            console.log('Validate secondary details');
            var validationStatus = {
                emptyWorkNumber: false,
                invalidWorkNumber: false,
                isValidWorkNumber: false,
                emptyMobileNumber: false,
                invalidMobileNumber: false,
                isValidMobileNumber: false
            };
            this.phoneValidationStatuses.push(validationStatus);
            this.showRemoveButton = true;
        }
        else {
            if (this.companyManagement.contactList && this.companyManagement.contactList[1] && this.companyManagement.contactList[1].userId) {
                this.userService.getDeleteUserInfo(this.companyManagement.contactList[1].userId, function (data) {
                    if (data.requisitionDetails && data.requisitionDetails.length > 0) {
                        _this.deleteContactUserInfoModal(_this.companyManagement.contactList[1], data, function (data) { });
                    }
                    else {
                        _this._removeSecondaryContact();
                    }
                }, function (error) {
                    _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                });
            }
            else {
                this._removeSecondaryContact();
            }
        }
    };
    CompanyPageController.prototype._removeSecondaryContact = function () {
        if (this.companyManagement.contactList.length > 1) {
            this.companyManagement.contactList.splice(1, 1);
            this.phoneValidationStatuses.splice(0, 1);
        }
        if (this.companyManagement.contactList.length > 1) {
            this.showRemoveButton = true;
        }
        else {
            this.showRemoveButton = false;
        }
        this.validateSecondaryDetails = false;
        console.log('Dont check secondary details');
        this.form.companySecondaryContactPersonDetailsForm.$setPristine();
    };
    CompanyPageController.prototype.deleteContactUserInfoModal = function (userDetails, deleteUserInfo, successCallback) {
        var openClienContactModal = this.$uibModal.open({
            animation: true,
            backdrop: 'static',
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            windowTopClass: 'four-dot-five-modal-small',
            component: 'deleteCompanyContactModal',
            resolve: {
                userDetails: function () {
                    return userDetails;
                },
                deleteContactUserInfo: function () {
                    return deleteUserInfo;
                }
            }
        });
        openClienContactModal.result.then(function (callbackObject) {
            if (successCallback) {
                successCallback(callbackObject);
            }
        }, function (dismiss) {
            //do nothing
        });
    };
    //add contacts 
    CompanyPageController.prototype.addContact = function () {
        var contact = {
            email: null,
            firstName: null,
            im: null,
            isHiringManager: true,
            isPrimary: false,
            lastName: null,
            mobilePhone: null,
            userId: null,
            workPhone: null
        };
        this.companyManagement.contactList.push(contact);
        var validationStatus = {
            emptyWorkNumber: false,
            invalidWorkNumber: false,
            isValidWorkNumber: false,
            emptyMobileNumber: false,
            invalidMobileNumber: false,
            isValidMobileNumber: false
        };
        this.phoneValidationStatuses.push(validationStatus);
    };
    CompanyPageController.prototype.removeContact = function (index) {
        var _this = this;
        if (this.companyManagement.contactList && this.companyManagement.contactList[index] && this.companyManagement.contactList[index].userId) {
            this.userService.getDeleteUserInfo(this.companyManagement.contactList[index].userId, function (data) {
                if (data.requisitionDetails && data.requisitionDetails.length > 0) {
                    _this.deleteContactUserInfoModal(_this.companyManagement.contactList[index], data, function (data) { });
                }
                else {
                    _this._removeContact(index);
                }
            }, function (error) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        }
        else {
            this._removeContact(index);
        }
    };
    CompanyPageController.prototype._removeContact = function (index) {
        this.companyManagement.contactList.splice(index, 1);
        this.phoneValidationStatuses.splice(index - 1, 1);
        if (this.companyManagement.contactList.length > 1) {
            this.showRemoveButton = true;
        }
    };
    CompanyPageController.prototype.isValidPhoneNumbersEntered = function () {
        if (this.phoneValidationStatuses.length < 2) {
            return true;
        }
        for (var i = 1; i < this.phoneValidationStatuses.length; i++) {
            if (!this.phoneValidationStatuses[i].isValidMobileNumber || !this.phoneValidationStatuses[i].isValidWorkNumber) {
                return false;
            }
        }
        return true;
    };
    CompanyPageController.prototype.switchToContactOrHiringManager = function (type, contact) {
        var _this = this;
        if (type == 'contact') {
            this.userService.getDeleteUserInfo(contact.userId, function (data) {
                if (data.requisitionDetails && data.requisitionDetails.length > 0) {
                    contact.isHiringManager = true;
                    _this.deleteContactUserInfoModal(contact, data, function (data) { });
                }
                else {
                    contact.isHiringManager = false;
                }
            }, function (error) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        }
    };
    CompanyPageController.prototype._setFIlteredContacts = function (isCompany, primaryContact) {
        var _this = this;
        var filteredContacts = [];
        this.companyManagement.contactList.map(function (contact) {
            if (isCompany) {
                var savedContactsEmailList = _this.savedCompanyManagement.contactList.map(function (contact) { return contact.email; });
                if (savedContactsEmailList.includes(contact.email) && (contact.email != primaryContact.email)) {
                    filteredContacts.push(contact);
                }
            }
            else {
                if (contact.userId && contact.userId != primaryContact.userId) {
                    filteredContacts.push(contact);
                }
            }
        });
        return filteredContacts;
    };
    CompanyPageController.prototype.removePrimaryContact = function (primaryContact) {
        var _this = this;
        var filteredContacts = [];
        filteredContacts = this._setFIlteredContacts(this.TypeOfCompany == 'Company', primaryContact);
        var deleteContactInfo = {
            activityType: 'removePrimaryContact',
            activityTitle: 'Remove Primary Contact',
            activityMessage: '',
            contactsList: filteredContacts
        };
        if (filteredContacts.length > 0) {
            deleteContactInfo.activityMessage = "Choose a contact to replace current primary contact.";
            // Check if primary contact is associated with requistions
            if (this.TypeOfCompany == 'Company') {
                this._deletePrimaryContact(primaryContact, deleteContactInfo, this.TypeOfCompany == 'Company');
            }
            else {
                this.userService.getDeleteUserInfo(primaryContact.userId, function (data) {
                    if (data.requisitionDetails && data.requisitionDetails.length > 0) {
                        _this.deleteContactUserInfoModal(primaryContact, data, function (data) { });
                    }
                    else {
                        _this._deletePrimaryContact(primaryContact, deleteContactInfo, _this.TypeOfCompany == 'Company');
                    }
                }, function (error) {
                    _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                });
            }
        }
        else {
            deleteContactInfo.activityMessage = "Please add a contact before deleting the primary contact";
            this.deleteContactUserInfoModal(primaryContact, deleteContactInfo, function (data) {
                // Do Nothing
            });
        }
    };
    CompanyPageController.prototype._deletePrimaryContact = function (primaryContact, deleteContactInfo, isCompany) {
        var _this = this;
        this.deleteContactUserInfoModal(primaryContact, deleteContactInfo, function (primaryContactObject) {
            // Replace Primary contact with selected contact
            if (primaryContactObject && primaryContactObject.entity && primaryContactObject.entity.primaryContact) {
                var newPrimaryContact_1 = primaryContactObject.entity.primaryContact;
                var index = 0;
                if (isCompany) {
                    _this.companyManagement.contactList = _this.companyManagement.contactList.filter(function (contact) { return contact.email != primaryContact.email; });
                    index = _this.companyManagement.contactList.findIndex(function (contact) { return contact.email === newPrimaryContact_1.email; });
                }
                else {
                    _this.companyManagement.contactList = _this.companyManagement.contactList.filter(function (contact) { return contact.userId != primaryContact.userId; });
                    index = _this.companyManagement.contactList.findIndex(function (contact) { return contact.userId === newPrimaryContact_1.userId; });
                }
                if (index > 0 && index < _this.companyManagement.contactList.length) {
                    var _a = tslib_1.__read(_this.companyManagement.contactList.splice(index, 1), 1), objectToMove = _a[0];
                    _this.companyManagement.contactList.unshift(objectToMove);
                }
                // Remove if secondary contact form appear
                if (_this.companyManagement.contactList.length == 1 && _this.showRemoveButton) {
                    _this._removeSecondaryContact();
                }
            }
        });
    };
    /**
     * This method will be called when user clicks on 'Prev' button of wizard
     */
    CompanyPageController.prototype.previousButtonClicked = function () {
        var _this = this;
        this.form.companyContactPersonDetailsForm.$setPristine();
        console.log('previousButtonClicked: ');
        // this.disableActionButtons = false;
        this.step2FormSubmitted = false;
        this.saveButtonClicked = false;
        this.nextButtonClicked = false;
        console.log('Count: ' + this.count);
        console.log('comp details: ' + this.StorageService.get('companyDetails'));
        //Company admin can edit only company workflow steps credentials
        if (this.isCompanyAdmin && this.TypeOfCompany == 'Company') {
            this.isStepReadOnlyForCompanyAdmin = true;
        }
        this.laststep = false;
        if (this.count === 0 && this.StorageService.get('companyDetails') == null && this.StorageService.get('SelectedHostCompany') == null && this.companyManagement.companyState != 'Draft') {
            console.log('In if previousButtonClicked');
            this.count = this.count + 1;
            var action = this.$timeout(function () {
                _this.StorageService.set('wizardoperations', true);
                angular.element('.btn-prev').triggerHandler('click');
            }, 0).then(function () {
                console.log('Then previousButtonClicked');
                _this.StorageService.remove('wizardoperations');
                _this.count = 0;
                _this.$timeout.cancel(action);
            });
        }
        else {
            console.log('Else previousButtonClicked: ' + angular.toJson(this.$rootScope.userDetails.roleScreenRef.role));
            if (this.StorageService.get('SelectedHostCompany') == null) {
                this.AssessmentWorkFlow = [];
            }
            if (this.companyDetailsUpdateMode || this.ClientOrBuCreate || this.ClientOrBuUpdate || this.StorageService.get('SelectedHostCompany') != null || this.companyManagement.companyState == 'Draft') {
                console.log('company update mode');
                this.StorageService.set('wizardoperations', true);
                this.triggerCount = 0;
            }
            else if (angular.equals(this.$rootScope.userDetails.roleScreenRef.role.name, 'StaffingAdmin') || angular.equals(this.$rootScope.userDetails.roleScreenRef.role.name, 'CorporateAdmin')) {
                console.log('company view mode for Staffing Admin or Corporate Admin');
                this.StorageService.set('wizardoperations', true);
                this.triggerCount = 0;
            }
        }
    };
    /**
     * Clear data on the form
     */
    CompanyPageController.prototype.cancel = function () {
        var _this = this;
        this.showConfirmationPopup = this.hasDataChanged();
        if (this.showConfirmationPopup) {
            bootbox.confirm({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Warning!</strong></div>",
                message: "Unsaved data on the page will be lost. Do you still want to continue?",
                buttons: {
                    confirm: {
                        label: 'Yes',
                        className: 'btn-success'
                    },
                    cancel: {
                        label: 'Cancel',
                        className: 'btn-danger'
                    }
                },
                callback: function (result) {
                    console.log('This was logged in the callback: ' + result);
                    if (result) {
                        _this.clearData();
                        _this.goToListingOrDashboardPage();
                    }
                    else {
                        _this.showConfirmationPopup = false;
                        console.log("Stay in same page");
                    }
                }
            });
        }
        else {
            this.goToListingOrDashboardPage();
        }
    };
    CompanyPageController.prototype.goToListingOrDashboardPage = function () {
        if (this.TypeOfCompany == 'Client' || this.TypeOfCompany == 'BusinessUnit') {
            this.$state.go('missioncontrol.clientsOrBus', null, { reload: false });
        }
        else if (this.TypeOfCompany == 'Vendor') {
            this.$state.go('missioncontrol.vendors', null, { reload: false });
        }
        else if (this.companyManagement.company.companyType == 'Host') {
            // this.$state.go('missioncontrol.dashboardsuperusermodule', { companyObject: 'companyObject' }, { reload: false });
        }
        else if (this.$rootScope.userDetails.company.companyState !== 'Draft') {
            if (!this.isCompanyVendor) {
                this.$state.go('missioncontrol.dashboard', { companyObject: 'companyObject' }, { reload: false });
            }
            else {
                this.$state.go('missioncontrol.requisitions', { companyObject: 'companyObject' }, { reload: false });
            }
        }
    };
    CompanyPageController.prototype.cancelSteps = function () {
        this.cancel();
    };
    CompanyPageController.prototype.clearData = function () {
        var _this = this;
        this.cancelNotClicked = false;
        console.log('@@In cancel function from step: ' + this.getCurrentStep() + 'this.geoLocations ' + angular.toJson(this.geoLocations));
        this.cancelClicked = false;
        console.log('this.companyManagement.fourDotFiveAdmin  ' + angular.toJson(this.companyManagement.fourDotFiveAdmin));
        this.copyOfGeoLocations = angular.copy(this.geoLocations);
        console.log('@@@this.copyOfGeoLocations  ' + angular.toJson(this.copyOfGeoLocations));
        this.copyOfGeoLocationsCopy = angular.copy(this.geoLocationsCopy);
        var cancelCurrentStep = this.getCurrentStep();
        if (cancelCurrentStep == 3 && (this.TypeOfCompany == 'Client' || this.StorageService.get('SelectedHostCompany') != null || this.TypeOfCompany == 'BusinessUnit')) {
            cancelCurrentStep = 4;
        }
        console.log('this.companyManagement.fourDotFiveAdmin  ' + angular.toJson(this.companyManagement.fourDotFiveAdmin));
        // this.CompanyManagementReset.fourDotFiveAdmin = angular.copy(this.companyManagement.fourDotFiveAdmin);
        this.showConfirmationPopup = false;
        switch (cancelCurrentStep) {
            case 1:
                console.log('Step one: ' + angular.toJson(this.originalStepOne));
                console.log('Step one this.companyManagement.company.zipcode: ' + this.companyManagement.company.zipcode);
                if (angular.isDefined(this.companyManagement.companyState)) {
                    console.log('inside company state defined');
                    this.cancelClicked = true;
                    if (!angular.equals(this.companyManagement.company.zipcode, this.originalStepOne.zipcode)) {
                        console.log('both are equal');
                        this.getAddressDetails(this.originalStepOne.zipcode, 'zipchanged');
                    }
                    else {
                        console.log('both are not equal');
                        this.getAddressDetails(this.originalStepOne.zipcode, 'updateaddress');
                    }
                    this.step1FormSubmitted = false;
                    this.companyManagement.company = angular.copy(this.originalStepOne);
                    this.savedCompanyManagement.company = angular.copy(this.originalStepOne);
                    this.form.companyDetailsForm.$setPristine();
                }
                else {
                    console.log('inside company state un defined');
                    this.form.companyDetailsForm.$setPristine();
                    console.log("Step one create state click on cancel: " + this.companyManagement.company.zipcode);
                    this.geoLocations = [];
                    this.companyManagement.company = {};
                    console.log('Object: ' + angular.toJson(this.companyManagement.company));
                    this.cancelClicked = true;
                    this.getAddressDetails(this.companyManagement.company.zipcode, 'zipchanged');
                    this.step1FormSubmitted = false;
                }
                break;
            case 2:
                console.log('Step two: ' + angular.toJson(this.originalStepTwo));
                if (this.originalStepTwo != undefined && this.originalStepTwo.length != 0) {
                    console.log('in if');
                    this.companyManagement.contactList = angular.copy(this.originalStepTwo);
                    this.isValidPrimaryMobileEntered = true;
                    this.isValidPrimaryWorkPhoneEntered = true;
                    this.form.companyContactPersonDetailsForm.maskedWorkPhone.$setValidity('ng-intl-tel-input', true);
                    this.form.companyContactPersonDetailsForm.maskedWorkPhone1.$setValidity('ng-intl-tel-input', true);
                    if (this.originalStepTwo.length > 1) {
                        console.log('Secondary contact present.');
                        this.showRemoveButton = true;
                        this.isValidSecondaryMobileEntered = true;
                        this.isValidSecondaryWorkPhoneEntered = true;
                        this.form.companySecondaryContactPersonDetailsForm.maskedWorkPhoneSecondary.$setValidity('ng-intl-tel-input', true);
                        this.form.companySecondaryContactPersonDetailsForm.maskedMobilePhoneSecondary.$setValidity('ng-intl-tel-input', true);
                        angular.forEach(this.phoneValidationStatuses, function (status, key) {
                            status.isValidWorkNumber = true;
                            status.isValidMobileNumber = true;
                        });
                        this.$timeout(function () {
                            _this.form.companySecondaryContactPersonDetailsForm.$setPristine();
                        }, 1000);
                    }
                    else {
                        console.log('in else');
                        this.invalidCompanySecondaryWorkNumber = false;
                        this.invalidCompanySecondaryMobilePhone = false;
                    }
                    this.$timeout(function () {
                        if (_this.form && _this.form.companyContactPersonDetailsForm) {
                            _this.form.companyContactPersonDetailsForm.$setPristine();
                        }
                    }, 1000);
                    this.step2FormSubmitted = false;
                }
                else {
                    console.log("Step Two create state click on cancel: ");
                    this.companyManagement.contactList = [];
                    document.getElementById('maskedWorkPhone').value = '';
                    document.getElementById('maskedWorkPhone1').value = '';
                    if (this.showRemoveButton) {
                        this.invalidCompanySecondaryMobilePhone = false;
                        this.invalidCompanySecondaryWorkNumber = false;
                        document.getElementById('maskedWorkPhoneSecondary').value = '';
                        document.getElementById('maskedMobilePhoneSecondary').value = '';
                    }
                    this.step2FormSubmitted = false;
                    this.form.companyContactPersonDetailsForm.$setPristine();
                }
                break;
            case 3:
                console.log('Step three: ' + angular.toJson(this.originalStepThree) + ' Role: ' + this.$rootScope.userDetails.roleScreenRef.role.name);
                if (this.originalStepThree != undefined) {
                    if (!(this.$rootScope.userDetails.roleScreenRef.role.name == '4dot5Admin')) {
                        this.fourDotFiveAdminsList.forEach(function (element) {
                            if (element.userId != _this.originalStepThree.userId) {
                                element.ticked = false;
                            }
                            else {
                                element.ticked = true;
                            }
                        }, this);
                        if (this.oldCheckedAdmin != null) {
                            this.oldCheckedAdmin[0].ticked = false;
                        }
                        this.companyManagement = angular.copy(this.CompanyManagementReset);
                        console.log('this.companyManagement.fourDotFiveAdmin  ' + angular.toJson(this.companyManagement.fourDotFiveAdmin));
                    }
                }
                else {
                    console.log('this.selectedFourDotFiveAdmin[0].userId ' + this.companyManagement.fourDotFiveAdmin);
                    this.companyManagement.fourDotFiveAdmin = {};
                    console.log("Step Three create state click on cancel");
                    this.fourDotFiveAdminsList.forEach(function (element) {
                        if (element.ticked) {
                            element.ticked = false;
                        }
                    }, this);
                    this.step3FormSubmitted = false;
                }
                this.form.company4dot5AdminDetailsForm.$setPristine();
                console.log('this.selectedFourDotFiveAdmin[0].userId ' + this.selectedFourDotFiveAdmin);
                break;
            case 4:
                console.log("Step Four create state click on cancel");
                if (!this.ClientOrBuUpdate && !this.ClientOrBuCreate) {
                    console.log('Its company create or update: ');
                    if (this.$rootScope.userDetails.company.companyType != 'Host') {
                        console.log('Original: ' + angular.toJson(this.originalStepFour));
                        this.selectedPlan = angular.copy(this.originalStepFour);
                        console.log('Current plan: ' + angular.toJson(this.originalStepFour));
                    }
                }
                this.step4formsubmitted = false;
                break;
            case 5:
                if (this.ClientOrBuCreate || this.ClientOrBuUpdate) {
                    this.$timeout(function () {
                        _this.AssessmentWorkFlow = [];
                        _this.preferences = angular.copy(_this.originalStepFive);
                    }, 100);
                }
                else {
                    this.$timeout(function () {
                        _this.preferences = angular.copy(_this.originalStepFive);
                    }, 100);
                }
                this.step5formsubmitted = false;
                break;
        }
    };
    /**
     * Deselect industry subgroup on cancel
     */
    /*      INDUSTRY CODE        this.deselectIndustrySubGroup = function () {
                    //   var matching = false;
                    industryMasterList.forEach(function (element) {
                        if (element.selected == true) {
                            element.industryDtos.forEach(function (elem) {
                                for (var key in elem) {
                                    if (angular.isNumber(elem[key])) {
                                        delete elem[key];
                                    }
                                }
                                if (elem.selected == true) {
                                    elem.selected = false;
                                }
                            }, this);
                        }
                    }, this);
                }*/
    /**
     * Remove from panel
     */
    /*  INDUSTRY CODE         this.removeFromSelectedList = function (index, subList) {
                   console.log('Clicked on: ' + angular.toJson(subList));
                   this.industriesInPanel.splice(index, 1);
                   this.IndustrySubList.forEach(function (element) {
                       console.log('Element name: ' + element.name + ' subList name: ' + subList.name);
                       if (subList.name == element.name) {
                           element.selected = false;
                       }
                   }, this);
               }*/
    /**
     * Delete extra characters
     */
    CompanyPageController.prototype.deleteExtraCharacters = function (element) {
        for (var key in element) {
            if (angular.isNumber(element[key])) {
                console.log('Key is: ' + key);
                delete element[key];
            }
        }
    };
    /**
     * Industry chosen
     */
    /*   INDUSTRY CODE         this.industrySubGroupChosen = function (selectedValues) {
                    var newElementToPanel = true;
                    console.log('Selected here: ' + angular.toJson(selectedValues));
                    selectedValues.forEach(function (element) {
                        //this.deleteExtraCharacters(element);
                        if (element.selected == true) {
                            for (var index = 0; index < this.industriesInPanel.length; index++) {
                                if (element.name == this.industriesInPanel[index].name) {
                                    newElementToPanel = false;
                                    break;
                                } else {
                                    newElementToPanel = true;
                                }
                            }
                            if (newElementToPanel) {
                                this.industriesInPanel.push(element);
                            }
                        }
                    }, this);
                    console.log('Industries panel: ' + angular.toJson(this.industriesInPanel));
                    //this.companyManagement.company.industryList = this.SelectedIndustrySubList;
                    //console.log('Last value: ' + angular.toJson(this.companyManagement.company.industryList));
                }*/
    CompanyPageController.prototype.hasDataChanged = function () {
        this.confirmationAtStep = this.getCurrentStep();
        this.showConfirmationPopup = false;
        this.cleanContactList();
        if (this.confirmationAtStep == 3 && (this.TypeOfCompany == 'Client' || this.StorageService.get('SelectedHostCompany') != null || this.TypeOfCompany == 'BusinessUnit')) {
            this.confirmationAtStep = 5;
        }
        if (!(angular.equals(this.savedCompanyManagement.company, this.companyManagement.company)) && this.confirmationAtStep == 1) {
            console.log('Unsaved changes in step 1');
            this.showConfirmationPopup = true;
        }
        else if (this.confirmationAtStep == 2 && !(angular.equals(this.savedCompanyManagement.contactList, this.companyManagement.contactList))) {
            console.log('Unsaved changes in step 2');
            this.showConfirmationPopup = true;
        }
        else if (angular.isDefined(this.originalStepThree) && this.confirmationAtStep == 3) {
            console.log('Unsaved changes in step 3 :');
            if (!(angular.isDefined(this.selectedFourDotFiveAdmin[0]))) {
                this.showConfirmationPopup = true;
            }
            else if (!(angular.equals(this.originalStepThree.userId, this.selectedFourDotFiveAdmin[0].userId))) {
                this.showConfirmationPopup = true;
            }
        }
        else if (angular.isDefined(this.selectedFourDotFiveAdmin[0]) && this.confirmationAtStep == 3) {
            this.showConfirmationPopup = true;
        }
        else if (this.showRemoveButton) {
            if (this.form.companySecondaryContactPersonDetailsForm.$dirty && this.confirmationAtStep == 2 && !this.companyStepTwoSaved && !this.isCompanyDeleted) {
                console.log('Unsaved changes in step 2 secondary contact');
                this.showConfirmationPopup = true;
            }
            // } else if (this.confirmationAtStep == 2 && !this.companyStepTwoSaved) {
            //     console.log('Success 4.2');
            //     this.showConfirmationPopup = true;
            // }
        }
        else if (this.confirmationAtStep == 5 && !(angular.equals(this.companyManagement.licensePreferences, this.originalStepFive)) && !(angular.equals(this.originalStepFive, this.preferences))) {
            console.log('Unsaved changes in step 5 staffing company');
            console.log('Staffing company update step 5 changed: ' + angular.equals(this.originalStepFive, this.savedAssessmentWorkFlow));
            // if (!(angular.equals(this.originalStepFive, this.savedAssessmentWorkFlow))) {
            this.showConfirmationPopup = true;
            // }
        }
        else if (this.confirmationAtStep == 3 && !(angular.equals(this.companyManagement.licensePreferences, this.originalStepFive)) && this.$rootScope.userDetails.company.companyType != 'StaffingCompany' && (this.$rootScope.userDetails.company.companyType != 'Corporation') && this.StorageService.get('companyDetails') === null) {
            console.log('Unsaved changes in step 3 Host company. ' + angular.equals(this.originalStepFive, this.AssessmentWorkFlow));
            this.showConfirmationPopup = true;
        }
        else if (this.errorOcurred && (!angular.equals(this.originalStepOne, this.companyManagement.company)) && this.confirmationAtStep == 1) {
            this.showConfirmationPopup = true;
        }
        return this.showConfirmationPopup;
    };
    /**
     * Step changes
     */
    CompanyPageController.prototype.getStepChanges = function (stepclicked) {
        this.saveButtonClicked = false;
        this.nextButtonClicked = false;
        console.log('Step clicked: ' + stepclicked);
        if (stepclicked != 3 && (this.companyManagement.company.companyType == 'Client' || this.companyManagement.company.companyType == 'BusinessUnit')) {
            this.laststep = false;
        }
        else if (stepclicked != 4 && (this.companyManagement.company.companyType == 'StaffingCompany' || this.companyManagement.company.companyType == 'Corporation')) {
            this.laststep = false;
        }
    };
    CompanyPageController.prototype.changeAddressObject = function (type, obj) {
        console.log('............................................' + type);
        this.saveButtonClicked = false;
        this.nextButtonClicked = false;
        switch (type) {
            case 'city':
                console.log('type : ' + type + ' obj : ' + obj);
                for (var p = 0; p < this.geoLocationscopy.length; p++) {
                    if (this.geoLocationscopy[p].city === obj) {
                        this.companyManagement.company.addressState = this.geoLocationscopy[p].state;
                        this.companyManagement.company.country = this.geoLocationscopy[p].country;
                        this.companyManagement.company.countryCode = this.geoLocationscopy[p].countryCode;
                        this.companyManagement.company.county = this.geoLocationscopy[p].county;
                        if (angular.isDefined(this.geoLocationscopy[p].county) && (this.geoLocationscopy[p].county !== null)) {
                            this.isCountyExists = true;
                        }
                        else {
                            this.isCountyExists = false;
                        }
                    }
                }
                break;
            case 'state':
                console.log('type : ' + type + ' obj : ' + obj);
                for (var p = 0; p < this.geoLocationscopy.length; p++) {
                    if (this.geoLocationscopy[p].state === obj) {
                        this.companyManagement.company.city = this.geoLocationscopy[p].city;
                        this.companyManagement.company.country = this.geoLocationscopy[p].country;
                        this.companyManagement.company.countryCode = this.geoLocationscopy[p].countryCode;
                        this.companyManagement.company.county = this.geoLocationscopy[p].county;
                        if (angular.isDefined(this.geoLocationscopy[p].county) && (this.geoLocationscopy[p].county !== null)) {
                            this.isCountyExists = true;
                        }
                        else {
                            this.isCountyExists = false;
                        }
                    }
                }
                break;
            case 'country':
                console.log('type : ' + type + ' obj : ' + obj);
                for (var p = 0; p < this.geoLocationscopy.length; p++) {
                    if (this.geoLocationscopy[p].country === obj) {
                        this.companyManagement.company.city = this.geoLocationscopy[p].city;
                        this.companyManagement.company.addressState = this.geoLocationscopy[p].state;
                        this.companyManagement.company.county = this.geoLocationscopy[p].county;
                        if (angular.isDefined(this.geoLocationscopy[p].county) && (this.geoLocationscopy[p].county !== null)) {
                            this.isCountyExists = true;
                        }
                        else {
                            this.isCountyExists = false;
                        }
                    }
                }
                break;
            case 'county':
                for (var p = 0; p < this.geoLocationscopy.length; p++) {
                    if (this.geoLocationscopy[p].county === obj) {
                        this.companyManagement.company.city = this.geoLocationscopy[p].city;
                        this.companyManagement.company.addressState = this.geoLocationscopy[p].state;
                        this.companyManagement.company.country = this.geoLocationscopy[p].country;
                        this.companyManagement.company.countryCode = this.geoLocationscopy[p].countryCode;
                    }
                }
                break;
        }
    };
    CompanyPageController.prototype.complexityRestrictionChange = function (userType) {
        if (userType == 'user') {
            var element = document.getElementById('checkbox-warning-user');
            if ($('#checkbox-group-user :checkbox:checked').length == 0 && this.companyManagement.userConfiguration.passwordSettings[0].complexityRestrictionEnabled) {
                element.innerHTML = "<span class='text-danger'>Atleast one restriction has to be selected</span>";
            }
            else {
                element.innerHTML = "";
            }
        }
        else {
            var element = document.getElementById('checkbox-warning-administrator');
            if ($('#checkbox-group-administrator :checkbox:checked').length == 0 && this.companyManagement.userConfiguration.passwordSettings[1].complexityRestrictionEnabled) {
                element.innerHTML = "<span class='text-danger'>Atleast one restriction has to be selected</span>";
            }
            else {
                element.innerHTML = "";
            }
        }
    };
    CompanyPageController.prototype.showAddAssessmentCredentialsForm = function () {
        this.newAssessmentCredential = {
            assessmentType: null,
            useAccountDetails: null,
            useAccountCredDetails: null,
            userName: '',
            key: ''
        };
        this.showAddAssessmentCredentialsFormFlag = true;
        this._setHasUnsavedAssessmentCredentials();
    };
    CompanyPageController.prototype.cancelAddAssessmentKey = function () {
        this.showAddAssessmentCredentialsFormFlag = false;
        this.newAssessmentCredential = {};
        this._setHasUnsavedAssessmentCredentials();
    };
    CompanyPageController.prototype.addAssessmentKey = function () {
        var _this = this;
        var companyId = "";
        if (this.TypeOfCompany == "BusinessUnit") {
            companyId = this.clientOrBuCreationInProgress ? this.newlyCreatedCompanyId : this.companyManagement.company.id;
        }
        else {
            companyId = this.$rootScope.userDetails.company.companyId;
        }
        var alreadyPresent = false;
        var use4dot5Account;
        var use4dot5Credential;
        if (this.TypeOfCompany == 'Host') {
            use4dot5Account = true;
            use4dot5Credential = false;
        }
        else {
            if (this.newAssessmentCredential.useAccountDetails == '4dot5') {
                use4dot5Account = true;
            }
            else {
                use4dot5Account = false;
            }
            if (this.newAssessmentCredential.useAccountCredDetails == '4dot5') {
                use4dot5Credential = true;
            }
            else {
                use4dot5Credential = false;
            }
        }
        if (this.validateAssessmentCredsBeforeAdd(this.newAssessmentCredential.userName, this.newAssessmentCredential.key, use4dot5Account, use4dot5Credential)) {
            if (_.isNull(this.preferences.licenseAssessmentPreferences.assessmentCredentials)) {
                this.preferences.licenseAssessmentPreferences.assessmentCredentials = [];
            }
            angular.forEach(this.preferences.licenseAssessmentPreferences.assessmentCredentials, function (val, key) {
                if (_this.newAssessmentCredential.userName == val.userName && _this.newAssessmentCredential.assessmentType == val.assessmentType) {
                    alreadyPresent = true;
                    bootbox.alert({
                        closeButton: false,
                        title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Duplicate</strong></div>",
                        message: "Username already exists!",
                        className: "zIndex1060",
                        buttons: {
                            ok: {
                                label: 'Ok',
                                className: 'btn-info'
                            }
                        }
                    });
                }
            });
            if (!alreadyPresent) {
                var credentialDetails = {
                    userName: this.newAssessmentCredential.userName,
                    use4Dot5Account: use4dot5Account,
                    use4Dot5Credential: use4dot5Credential,
                    assessmentType: this.newAssessmentCredential.assessmentType
                };
                this.companyService.isAssessmentCredentialsValid(companyId, credentialDetails, function (data) {
                    if (data.credentialAccepted) {
                        _this.newAssessmentCredential.use4Dot5Account = use4dot5Account;
                        _this.newAssessmentCredential.use4Dot5Credential = use4dot5Credential;
                        _this.preferences.licenseAssessmentPreferences.assessmentCredentials.push(_this.newAssessmentCredential);
                        _this.showAddAssessmentCredentialsFormFlag = false;
                        _this.newAssessmentCredential = {};
                        _this.assessmentOrJobBoardCredentialsUpdated = true;
                        _this._setHasUnsavedAssessmentCredentials();
                    }
                    else {
                        bootbox.alert({
                            closeButton: false,
                            title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Alert!</strong></div>",
                            message: data.description,
                            className: "zIndex1060",
                            buttons: {
                                ok: {
                                    label: 'Ok',
                                    className: 'btn-info'
                                }
                            }
                        });
                    }
                }, function (error) {
                    //do nothing
                });
            }
            else {
                bootbox.alert({
                    closeButton: false,
                    title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>All details not provided!</strong></div>",
                    message: "Please provide all details to add credentials.",
                    className: "zIndex1060",
                    buttons: {
                        ok: {
                            label: 'Ok',
                            className: 'btn-info'
                        }
                    }
                });
            }
        }
    };
    CompanyPageController.prototype.showEditAssessmentPreferencesForm = function (assessmentCredential) {
        assessmentCredential.oldValue = angular.copy(assessmentCredential);
        if (assessmentCredential.use4Dot5Account == true) {
            assessmentCredential.useAccountDetails = "4dot5";
        }
        else {
            assessmentCredential.useAccountDetails = "My Own";
        }
        if (assessmentCredential.use4Dot5Credential == true) {
            assessmentCredential.useAccountCredDetails = "4dot5";
        }
        else {
            assessmentCredential.useAccountCredDetails = "My Own";
        }
        assessmentCredential.showEditForm = true;
        this._setHasUnsavedAssessmentCredentials();
    };
    CompanyPageController.prototype.cancelEditAssessmentPreferencesForm = function (assessmentCredential, index) {
        this.preferences.licenseAssessmentPreferences.assessmentCredentials[index] = angular.copy(assessmentCredential.oldValue);
        assessmentCredential.showEditForm = false;
        this._setHasUnsavedAssessmentCredentials();
    };
    CompanyPageController.prototype.updateEditedAssessmentPreferences = function (assessmentCredential, currentCredentialIndex) {
        var _this = this;
        var companyId = "";
        if (this.TypeOfCompany == "BusinessUnit") {
            companyId = this.clientOrBuCreationInProgress ? this.newlyCreatedCompanyId : this.companyManagement.company.id;
        }
        else {
            companyId = this.$rootScope.userDetails.company.companyId;
        }
        var alreadyPresent = false;
        var use4dot5Account;
        var use4dot5Credential;
        if (this.TypeOfCompany == 'Host') {
            use4dot5Account = true;
            use4dot5Credential = false;
        }
        else {
            if (assessmentCredential.useAccountDetails == '4dot5') {
                use4dot5Account = true;
            }
            else {
                use4dot5Account = false;
            }
            if (assessmentCredential.useAccountCredDetails == '4dot5') {
                use4dot5Credential = true;
            }
            else {
                use4dot5Credential = false;
            }
        }
        if (this.validateAssessmentCredsBeforeAdd(assessmentCredential.userName, assessmentCredential.key, use4dot5Account, use4dot5Credential)) {
            angular.forEach(this.preferences.licenseAssessmentPreferences.assessmentCredentials, function (val, key) {
                if (key != currentCredentialIndex && assessmentCredential.userName == val.userName && assessmentCredential.assessmentType == val.assessmentType) {
                    alreadyPresent = true;
                    bootbox.alert({
                        closeButton: false,
                        title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Duplicate</strong></div>",
                        message: "Username already exists!",
                        className: "zIndex1060",
                        buttons: {
                            ok: {
                                label: 'Ok',
                                className: 'btn-info'
                            }
                        }
                    });
                }
            });
            if (!alreadyPresent) {
                var credentialDetails = {
                    userName: assessmentCredential.userName,
                    use4Dot5Account: use4dot5Account,
                    use4Dot5Credential: use4dot5Credential,
                    assessmentType: assessmentCredential.assessmentType
                };
                this.companyService.isAssessmentCredentialsValid(companyId, credentialDetails, function (data) {
                    if (data.credentialAccepted) {
                        assessmentCredential.use4Dot5Account = use4dot5Account;
                        assessmentCredential.use4Dot5Credential = use4dot5Credential;
                        assessmentCredential.showEditForm = false;
                        _this.assessmentOrJobBoardCredentialsUpdated = true;
                        _this._setHasUnsavedAssessmentCredentials();
                    }
                    else {
                        bootbox.alert({
                            closeButton: false,
                            title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Alert!</strong></div>",
                            message: data.description,
                            className: "zIndex1060",
                            buttons: {
                                ok: {
                                    label: 'Ok',
                                    className: 'btn-info'
                                }
                            }
                        });
                    }
                }, function (error) {
                    //do nothing
                });
            }
        }
        else {
            bootbox.alert({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>All details not provided!</strong></div>",
                message: "Please provide all details to add credentials.",
                className: "zIndex1060",
                buttons: {
                    ok: {
                        label: 'Ok',
                        className: 'btn-info'
                    }
                }
            });
        }
    };
    CompanyPageController.prototype.isBlank = function (str) {
        return (!str || /^\s*$/.test(str));
    };
    CompanyPageController.prototype.validateAssessmentCredsBeforeAdd = function (username, key, use4dot5Account, use4dot5Credential) {
        if (use4dot5Account && use4dot5Credential && this.isBlank(username) && this.isBlank(key)) {
            return true;
        }
        else if (use4dot5Account && !use4dot5Credential && !this.isBlank(username) && this.isBlank(key)) {
            return true;
        }
        else if (!use4dot5Account && !this.isBlank(username) && !this.isBlank(key)) {
            return true;
        }
        else {
            return false;
        }
    };
    CompanyPageController.prototype.changeAddAssessmentCredentialAccountType = function () {
        if (this.newAssessmentCredential.useAccountDetails == 'My Own') {
            this.newAssessmentCredential.useAccountCredDetails = 'My Own';
            document.getElementById("addAssessmentCredentialUseAccountCredDetails").disabled = true;
        }
        else {
            this.newAssessmentCredential.useAccountCredDetails = '';
            document.getElementById("addAssessmentCredentialUseAccountCredDetails").disabled = false;
        }
    };
    CompanyPageController.prototype.changeAddAssessmentCredentialAccountDetails = function () {
        this.newAssessmentCredential.userName = '';
        this.newAssessmentCredential.key = '';
    };
    CompanyPageController.prototype.changeEditAssessmentCredentialAccountType = function (assessmentCredential, index) {
        if (assessmentCredential.useAccountDetails == 'My Own') {
            assessmentCredential.useAccountCredDetails = 'My Own';
            document.getElementById("editAssessmentCredentialUseAccountCredDetails-" + index).disabled = true;
            assessmentCredential.userName = '';
            assessmentCredential.key = '';
        }
        else {
            assessmentCredential.useAccountCredDetails = '';
            document.getElementById("editAssessmentCredentialUseAccountCredDetails-" + index).disabled = false;
            assessmentCredential.key = '';
        }
    };
    CompanyPageController.prototype.changeEditAssessmentCredentialAccountDetails = function (assessmentCredential) {
        assessmentCredential.userName = '';
        assessmentCredential.key = '';
    };
    CompanyPageController.prototype._setHasUnsavedAssessmentCredentials = function () {
        this.hasUnsavedAssessmentCredentials = this.showAddAssessmentCredentialsFormFlag || (this.preferences.licenseAssessmentPreferences.assessmentCredentials !== null && this.preferences.licenseAssessmentPreferences.assessmentCredentials.some(function (credential) { return credential.showEditForm; }));
    };
    CompanyPageController.prototype.jobBoardCredentialAdded = function (credential) {
        if (_.isNull(this.preferences.jobBoardCredentialList)) {
            this.preferences.jobBoardCredentialList = [];
        }
        this.preferences.jobBoardCredentialList.push(credential);
        this.assessmentOrJobBoardCredentialsUpdated = true;
        this._setHasUnsavedJobBoardCredentials();
    };
    CompanyPageController.prototype.showAddJobBoardKeyForm = function () {
        var _this = this;
        this.showCredentialTypeConfirmModal(function () {
            _this.newJobBoardCredential = {
                source: {},
                password: null,
                jobBoardId: null,
                sourceType: null,
                userName: '',
                key: null,
                loginOptions: null,
                credentialsAddedWithKey: !_this.addJobBoardByPasswordFlag
            };
        });
    };
    CompanyPageController.prototype.showCredentialTypeConfirmModal = function (successCallback) {
        var _this = this;
        var confirmCredentialTypeModal = this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            windowTopClass: 'four-dot-five-modal-small',
            component: 'chooseJobBoardCredentialTypeModal',
            resolve: {
                addJobBoardByPasswordFlag: function () {
                    return _this.addJobBoardByPasswordFlag;
                }
            }
        });
        confirmCredentialTypeModal.result.then(function (callbackObject) {
            if (callbackObject.callbackType == 'typeChange') {
                _this.addJobBoardByPasswordFlag = callbackObject.entity.addJobBoardByPasswordFlag;
                _this.showAddJobBoardCredentialsFormFlag = true;
                _this._setHasUnsavedJobBoardCredentials();
                successCallback();
            }
        }, function (dismiss) {
            //do nothing
        });
    };
    CompanyPageController.prototype.showEditJobBoardKeyForm = function (jobBoardCredential) {
        angular.forEach(this.jobSourceType, function (val, key) {
            if (jobBoardCredential.sourceType == val.sourceType) {
                jobBoardCredential.source = val;
            }
        });
        jobBoardCredential.oldValue = angular.copy(jobBoardCredential);
        jobBoardCredential.showEditForm = true;
        this._setHasUnsavedJobBoardCredentials();
    };
    CompanyPageController.prototype.updateEditJobBoardKeyForm = function (jobBoardCredential, index) {
        if ((!_.isNull(jobBoardCredential.source) && !_.isUndefined(jobBoardCredential.source.id)) && (!_.isUndefined(jobBoardCredential.userName) && (jobBoardCredential.userName != '')) && ((!jobBoardCredential.credentialsAddedWithKey && !_.isNull(jobBoardCredential.password) && !_.isUndefined(jobBoardCredential.password) && jobBoardCredential.password != '') || (jobBoardCredential.credentialsAddedWithKey && !_.isNull(jobBoardCredential.key) && !_.isUndefined(jobBoardCredential.key) && jobBoardCredential.key != ''))) {
            if ((jobBoardCredential.oldValue.jobBoardId != jobBoardCredential.source.id) || (jobBoardCredential.oldValue.userName != jobBoardCredential.userName) || (jobBoardCredential.oldValue.password != jobBoardCredential.password) || (jobBoardCredential.oldValue.loginOptions != jobBoardCredential.loginOptions)) {
                if (this.isJobBoardSourceDuplicate(jobBoardCredential, index)) {
                    bootbox.alert({
                        closeButton: false,
                        title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Duplicate!</strong></div>",
                        message: "Credentials already exist for this job board.",
                        className: "zIndex1060",
                        buttons: {
                            ok: {
                                label: 'Ok',
                                className: 'btn-info'
                            }
                        }
                    });
                }
                else {
                    jobBoardCredential.jobBoardId = jobBoardCredential.source.id;
                    jobBoardCredential.sourceType = jobBoardCredential.source.sourceType;
                    jobBoardCredential.edited = true;
                    jobBoardCredential.showEditForm = false;
                    delete jobBoardCredential.source;
                    this._setHasUnsavedJobBoardCredentials();
                }
            }
            else {
                bootbox.alert({
                    closeButton: false,
                    title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>No changes made!</strong></div>",
                    message: "Nothing to update.<br>No changes were made to the credentials.",
                    className: "zIndex1060",
                    buttons: {
                        ok: {
                            label: 'Ok',
                            className: 'btn-info'
                        }
                    }
                });
            }
        }
        else {
            bootbox.alert({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>All details not provided!</strong></div>",
                message: "Please provide all details to update credentials.",
                className: "zIndex1060",
                buttons: {
                    ok: {
                        label: 'Ok',
                        className: 'btn-info'
                    }
                }
            });
        }
    };
    CompanyPageController.prototype.deleteJobBoardDetails = function (jobBoardCredential) {
        var _this = this;
        //var jobBoard = this.preferences.jobBoardCredentialList[index];
        bootbox.confirm({
            closeButton: false,
            title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Warning!</strong></div>",
            message: "Are you sure you want to delete " + jobBoardCredential.sourceType + "'s credentials ?",
            buttons: {
                confirm: {
                    label: 'Yes',
                    className: 'btn-success'
                },
                cancel: {
                    label: 'Cancel',
                    className: 'btn-danger'
                }
            },
            callback: function (result) {
                if (result) {
                    _this.$timeout(function () {
                        if (jobBoardCredential.editable) {
                            // existing saved credentials are being deleted.
                            jobBoardCredential.delete = true;
                        }
                        else {
                            // new credentials added are being deleted. remove them from the list
                            var index = 0;
                            if (!jobBoardCredential.credentialsAddedWithKey) {
                                index = _.findIndex(_this.preferences.jobBoardCredentialList, { 'userName': jobBoardCredential.userName, 'password': jobBoardCredential.password });
                            }
                            else {
                                index = _.findIndex(_this.preferences.jobBoardCredentialList, { 'userName': jobBoardCredential.userName, 'key': jobBoardCredential.key });
                            }
                            _this.preferences.jobBoardCredentialList.splice(index, 1);
                        }
                        _this._setHasUnsavedJobBoardCredentials();
                    }, 100);
                }
            }
        });
    };
    CompanyPageController.prototype.cancelDeleteJobBoardKey = function (jobBoardCredential) {
        this.$timeout(function () {
            jobBoardCredential.delete = false;
        }, 100);
    };
    CompanyPageController.prototype.cancelEditJobBoardKeyForm = function (index) {
        var _this = this;
        this.$timeout(function () {
            _this.preferences.jobBoardCredentialList[index] = angular.copy(_this.preferences.jobBoardCredentialList[index].oldValue);
            _this.preferences.jobBoardCredentialList[index].password = null;
        }, 100);
        this._setHasUnsavedJobBoardCredentials();
    };
    CompanyPageController.prototype.jobBoardCredentialsAddSourceTypeChanged = function (index) {
        if (!_.isNull(this.newJobBoardCredential.source)) {
            this.newJobBoardCredential.jobBoardId = this.newJobBoardCredential.source.id;
            this.newJobBoardCredential.sourceType = this.newJobBoardCredential.source.sourceType;
            if (this.isJobBoardSourceDuplicate(this.newJobBoardCredential, index)) {
                var message = this.newJobBoardCredential.source.sourceType + " Credentials already exist.";
                bootbox.alert({
                    closeButton: false,
                    title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Duplicate</strong></div>",
                    message: message,
                    className: "zIndex1060",
                    buttons: {
                        ok: {
                            label: 'Ok',
                            className: 'btn-info'
                        }
                    }
                });
                this.newJobBoardCredential.jobBoardId = "";
                this.newJobBoardCredential.sourceType = "";
                this.newJobBoardCredential.source.id = "";
                this.newJobBoardCredential.source.sourceType = "";
            }
            else {
                this.newJobBoardCredential.jobBoardId = this.newJobBoardCredential.source.id;
                this.newJobBoardCredential.sourceType = this.newJobBoardCredential.source.sourceType;
                if (this.newJobBoardCredential.sourceType !== 'Dice') {
                    this.newJobBoardCredential.loginOptions = null;
                }
            }
        }
        else {
            this.newJobBoardCredential.jobBoardId = "";
            this.newJobBoardCredential.sourceType = "";
        }
        this._setHasUnsavedJobBoardCredentials();
    };
    CompanyPageController.prototype.jobBoardCredentialsEditSourceTypeChanged = function (jobBoardCredential) {
        if (!_.isNull(jobBoardCredential.source)) {
            jobBoardCredential.jobBoardId = jobBoardCredential.source.id;
            jobBoardCredential.sourceType = jobBoardCredential.source.sourceType;
            if (jobBoardCredential.source.sourceType !== 'Dice') {
                jobBoardCredential.loginOptions = null;
            }
        }
        else {
            jobBoardCredential.jobBoardId = "";
            jobBoardCredential.sourceType = "";
        }
    };
    CompanyPageController.prototype.addJobBoardKey = function () {
        // if(this.form.addCredentialsForm.$invalid){
        if ((!_.isNull(this.newJobBoardCredential.source) && !_.isUndefined(this.newJobBoardCredential.source.id)) && (!_.isUndefined(this.newJobBoardCredential.userName) && (this.newJobBoardCredential.userName != '')) && ((!this.newJobBoardCredential.credentialsAddedWithKey && !_.isNull(this.newJobBoardCredential.password) && !_.isUndefined(this.newJobBoardCredential.password) && this.newJobBoardCredential.password != '') || (this.newJobBoardCredential.credentialsAddedWithKey && !_.isNull(this.newJobBoardCredential.key) && !_.isUndefined(this.newJobBoardCredential.key) && this.newJobBoardCredential.key != ''))) {
            if (this.isJobBoardSourceDuplicate(this.newJobBoardCredential, -1)) {
                bootbox.alert({
                    closeButton: false,
                    title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Duplicate!</strong></div>",
                    message: "Credentials already exist for this job board.",
                    className: "zIndex1060",
                    buttons: {
                        ok: {
                            label: 'Ok',
                            className: 'btn-info'
                        }
                    }
                });
            }
            else {
                var newJobBoardCred = angular.copy(this.newJobBoardCredential);
                newJobBoardCred.jobBoardId = newJobBoardCred.source.id;
                newJobBoardCred.sourceType = newJobBoardCred.source.sourceType;
                delete newJobBoardCred.source;
                if (_.isNull(this.preferences.jobBoardCredentialList)) {
                    this.preferences.jobBoardCredentialList = [];
                }
                this.preferences.jobBoardCredentialList.push(newJobBoardCred);
                this.showAddJobBoardCredentialsFormFlag = false;
                this._setHasUnsavedJobBoardCredentials();
            }
        }
        else {
            bootbox.alert({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>All details not provided!</strong></div>",
                message: "Please provide all details to add credentials.",
                className: "zIndex1060",
                buttons: {
                    ok: {
                        label: 'Ok',
                        className: 'btn-info'
                    }
                }
            });
        }
    };
    CompanyPageController.prototype.isJobBoardSourceDuplicate = function (jobBoardCredential, currentCredentialIndex) {
        var isDuplicate = false;
        angular.forEach(this.preferences.jobBoardCredentialList, function (val, key) {
            if (key != currentCredentialIndex && val.sourceType == jobBoardCredential.source.sourceType) {
                isDuplicate = true;
            }
        });
        return isDuplicate;
    };
    CompanyPageController.prototype.cancelAddJobBoardKey = function () {
        var _this = this;
        this.$timeout(function () {
            _this.newJobBoardCredential = {};
            _this.showAddJobBoardCredentialsFormFlag = false;
            _this._setHasUnsavedJobBoardCredentials();
        }, 100);
    };
    CompanyPageController.prototype._setHasUnsavedJobBoardCredentials = function () {
        this.hasUnsavedJobBoardCredentials = this.showAddJobBoardCredentialsFormFlag || (this.preferences.jobBoardCredentialList !== null && this.preferences.jobBoardCredentialList.some(function (credential) { return credential.showEditForm; }));
    };
    CompanyPageController.prototype.toggleAssessmentWorkFlowValues1 = function (index, workflow) {
        if (workflow.selected) {
            workflow.selected = false;
        }
        else {
            workflow.selected = true;
        }
    };
    CompanyPageController.prototype.imageProctoringValueChanged = function () {
        if (!this.preferences.licenseAssessmentPreferences.imageProctoring) {
            this.preferences.licenseAssessmentPreferences.addProctoringImagesToReport = false;
        }
    };
    CompanyPageController.prototype.checkIfSelected = function (optionval) {
        if (this.preferences != null) {
            if (this.preferences.licenseAssessmentPreferences.accessTime == null) {
                return false;
            }
            if (this.preferences.licenseAssessmentPreferences.accessTime.indexOf(optionval.trim()) == -1) {
                return false;
            }
            else {
                return true;
            }
        }
    };
    CompanyPageController.prototype.checkIfDisabled = function (optionval) {
        if (this.preferences != null) {
            if (this.preferences.licenseAssessmentPreferences.accessTimeDisabledValues == null) {
                return false;
            }
            if (this.preferences.licenseAssessmentPreferences.accessTimeDisabledValues.indexOf(optionval.trim()) == -1) {
                return false;
            }
            else {
                return true;
            }
        }
    };
    CompanyPageController.prototype.deleteAssessmentUsername = function (index) {
        this.openDeleteAssessmentCredentialsModal(this.preferences.licenseAssessmentPreferences.assessmentCredentials[index], index);
    };
    CompanyPageController.prototype.openDeleteAssessmentCredentialsModal = function (assessmentCredentials, index) {
        var _this = this;
        var context = "";
        var buId = "";
        if (this.TypeOfCompany == "BusinessUnit") {
            context = "BU";
            buId = this.clientOrBuCreationInProgress ? this.newlyCreatedCompanyId : this.companyManagement.company.id;
        }
        else {
            context = "company";
        }
        var deleteAssessmentCredentialsModal = this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            windowClass: 'four-dot-five-modal-large',
            component: 'deleteAssessmentCredentialModal',
            resolve: {
                companyId: function () {
                    return _this.$rootScope.userDetails.company.companyId;
                },
                buId: function () {
                    return buId;
                },
                testOwnerEmail: function () {
                    return assessmentCredentials.userName;
                },
                context: function () {
                    return context;
                },
                isDeleteCredential: function () {
                    return true;
                }
            }
        });
        deleteAssessmentCredentialsModal.result.then(function (callbackObject) {
            if (callbackObject.callbackType == 'delete') {
                _this.preferences.licenseAssessmentPreferences.assessmentCredentials.splice(index, 1);
                _this.assessmentOrJobBoardCredentialsUpdated = true;
            }
        }, function (dismiss) {
            //do nothing
        });
    };
    CompanyPageController.prototype.modifyJobBoard = function (jobBoardCred, idVal) {
        document.getElementById("usernamejob").value = jobBoardCred.userName;
        document.getElementById("keyjob").value = jobBoardCred.key;
        this.selectedjobWorkFlowQuestion = idVal;
        for (var source in this.jobSourceType) {
            if (this.jobSourceType[source].sourceType == jobBoardCred.sourceType) {
                this.source = this.jobSourceType[source];
            }
        }
        this.buttonWorkFlowText = "Modify";
    };
    CompanyPageController.prototype.choosePlan = function (planIndex) {
        var isPlanModify = this.plans[planIndex].enabled;
        var planChangeStatus = "";
        this.isPlanChosen = true;
        this.selectedPlanName = this.plans[planIndex].plan;
        this.selectedPlanTypeList = angular.copy(this.plans[planIndex].planTypeList);
        if (!this.isActivePlanExists) {
            this.selectedPlan = this.getParsedSelectedPlan(this.plans[planIndex], planChangeStatus);
        }
        else if (this.savedCurrentActivePlan.planHeaderDto.planFeaturesCapabilityId !== this.plans[planIndex].id) {
            if (this.plans[planIndex].priority > this.savedCurrentActivePlanPriority) {
                planChangeStatus = "upgrade";
            }
            else {
                planChangeStatus = "downgrade";
            }
            this.selectedPlan = this.getParsedSelectedPlan(this.plans[planIndex], planChangeStatus);
            if (isPlanModify) {
                this.selectedPlan.planHeaderDto.id = this.savedCurrentActivePlan.planHeaderDto.id;
                this.selectedPlan.planDetailDto.id = this.savedCurrentActivePlan.planDetailDto.id;
                this.selectedPlan.planDetailDto.planHeaderId = this.savedCurrentActivePlan.planDetailDto.planHeaderId;
            }
            else {
                this.selectedPlan.planHeaderDto.id = '';
                this.selectedPlan.planDetailDto.id = '';
                this.selectedPlan.planDetailDto.planHeaderId = '';
                this.selectedPlan.planHeaderDto.timeZoneName = '';
            }
        }
        else {
            this.selectedPlan = angular.copy(this.savedCurrentActivePlan);
        }
        this.modifyPlan(isPlanModify);
    };
    CompanyPageController.prototype.getParsedSelectedPlan = function (selectedPlan, planChangeStatus) {
        if (this.newlyCreatedCompanyId == null && this.companyDetailsUpdateMode) {
            this.newlyCreatedCompanyId = this.companyManagement.company.id;
        }
        var taAllocated = 0;
        var jbiAllocated = 0;
        if (this.selectedPlanName.toLowerCase() !== 'vendor only') {
            var taAllocated = selectedPlan.features.filter(function (feature) {
                return feature.name == "Tech Assessments";
            })[0].limitValue;
            var jbiAllocated = selectedPlan.features.filter(function (feature) {
                return feature.name == "Job Board Integration";
            })[0].limitValue;
        }
        var planStartDate = new Date();
        var planEndDate = new Date();
        var taUsed = 0;
        var jbiUsed = 0;
        if (planChangeStatus == "upgrade" && this.selectedPlanName.toLowerCase() !== 'trial') {
            planStartDate = moment(planStartDate).add(1, 'd').toDate();
            // taUsed = this.savedCurrentActivePlan.planDetailDto.taUsed;
            // jbiUsed = this.savedCurrentActivePlan.planDetailDto.jbiUsed;
        }
        else if (planChangeStatus == "downgrade") {
            planStartDate = moment(this.savedCurrentActivePlan.planHeaderDto.unformattedEndDate).add(1, 'd').toDate();
            // taUsed = this.savedCurrentActivePlan.planDetailDto.taUsed;
            // jbiUsed = this.savedCurrentActivePlan.planDetailDto.jbiUsed;
        }
        var planType = "";
        if (this.selectedPlanName.toLowerCase() == "trial") {
            planType = "Month to Month";
            planStartDate = this.$filter('fourdotfiveDateFormat')(planStartDate);
            planEndDate = this.$filter('fourdotfiveDateFormat')(moment(planStartDate).add(1, 'M').toDate());
        }
        else if (this.selectedPlanName.toLowerCase() == "vendor only") {
            planType = "Unlimited";
            planStartDate = this.$filter('fourdotfiveDateFormat')(new Date());
            planEndDate = this.$filter('fourdotfiveDateFormat')(new Date(2099, 11, 31, 0, 0, 0, 0));
        }
        else {
            planType = "6 Months";
            planStartDate = this.$filter('fourdotfiveDateFormat')(planStartDate);
            planEndDate = this.$filter('fourdotfiveDateFormat')(moment(planStartDate).add(6, 'M').toDate());
        }
        return {
            "planHeaderDto": {
                "id": "",
                "planFeaturesCapabilityId": selectedPlan.id,
                "companyId": this.newlyCreatedCompanyId,
                "planType": planType,
                "planStartDate": this.dateTimeUtilityService.getDateTimeInAPIFormat(planStartDate),
                "planEndDate": this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date(planEndDate)),
                "planStartDateDisplay": planStartDate,
                "planEndDateDisplay": planEndDate,
                "unformattedStartDate": moment(planStartDate).toDate(),
                "unformattedEndDate": moment(planEndDate).toDate()
            },
            "planDetailDto": {
                "id": "",
                "planHeaderId": "",
                "taAllocated": taAllocated,
                "taUsed": taUsed,
                "taAdded": 0,
                "jbiAllocated": jbiAllocated,
                "jbiUsed": 0,
                "jbiAdded": jbiUsed
            }
        };
    };
    CompanyPageController.prototype.modifyPlan = function (isModify) {
        var _this = this;
        var modifyPlanModal = this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            windowTopClass: 'four-dot-five-modal-medium',
            component: 'modifyPlanModal',
            resolve: {
                selectedPlanName: function () {
                    return _this.selectedPlanName;
                },
                planTypeList: function () {
                    return _this.selectedPlanTypeList;
                },
                selectedPlan: function () {
                    return _this.selectedPlan;
                },
                futurePlan: function () {
                    return _this.futurePlan;
                },
                isModifyPlan: function () {
                    return isModify;
                },
                isFuturePlanExists: function () {
                    return _this.isFuturePlanExists;
                },
                isActivePlanExists: function () {
                    return _this.isActivePlanExists;
                },
                currentPlanEndDate: function () {
                    if (_this.isActivePlanExists) {
                        return new Date(_this.savedCurrentActivePlan.planHeaderDto.planEndDateDisplay);
                    }
                    else {
                        return new Date();
                    }
                }
            }
        });
        modifyPlanModal.result.then(function (callbackObject) {
            if (callbackObject.callbackType == 'cancel') {
                console.log('unmodified plan');
                _this.selectedPlan = angular.copy(_this.savedCurrentActivePlan);
                console.log(_this.selectedPlan);
            }
            else if (callbackObject.callbackType == 'save') {
                _this.getCurrentPlanDetails(_this.selectedPlan.planHeaderDto.companyId, false);
                console.log('modified plan');
                console.log(_this.selectedPlan);
            }
        }, function (dismiss) {
            //do nothing
        });
    };
    CompanyPageController.prototype.showUnsavedCredentialsWarning = function (message) {
        bootbox.alert({
            closeButton: false,
            title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Unsaved Data!</strong></div>",
            message: message,
            className: "zIndex1060",
            buttons: {
                ok: {
                    label: 'Ok',
                    className: 'btn-info'
                }
            }
        });
    };
    CompanyPageController.prototype.uploadCompanyLogo = function (isSmallHeaderLogo) {
        var _this = this;
        var file;
        if (isSmallHeaderLogo) {
            file = this.smallHeaderLogo;
            this.uploadCompanySmallHeaderLogoInProgress = true;
            this.uploadCompanyHeaderLogoInProgress = false;
        }
        else {
            file = this.headerLogo;
            this.uploadCompanySmallHeaderLogoInProgress = false;
            this.uploadCompanyHeaderLogoInProgress = true;
        }
        var imageInfo = new FormData();
        imageInfo.append('file', file);
        imageInfo.append('isSmallHeaderLogo', isSmallHeaderLogo);
        this.companyService.uploadCompanyLogo(imageInfo, this.$rootScope.userDetails.company.companyId, function (data) {
            _this.uploadCompanySmallHeaderLogoInProgress = false;
            _this.uploadCompanyHeaderLogoInProgress = false;
            if (!isSmallHeaderLogo) {
                _this.preferences.frontPageLogoS3Url = data.imageUrl;
                _this.headerLogo = undefined;
            }
            else {
                _this.preferences.smallHeaderLogoS3Url = data.imageUrl;
                _this.smallHeaderLogo = undefined;
            }
        }, function (error) {
            _this.uploadCompanyHeaderLogoInProgress = false;
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    CompanyPageController.prototype.isSuperUser = function (role) {
        return this.userRoleService.isSuperUser(role);
    };
    //Handle navigating away when data is unsaved
    CompanyPageController.prototype.uiCanExit = function (transitions) {
        var _this = this;
        var toState = transitions.to().name;
        var toParams = transitions.params();
        if (this.hasDataChanged() && !this.isCompanyDeleted && this.isTransitionAbortRequired && toState !== "login") {
            transitions.abort();
            bootbox.confirm({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Warning!</strong></div>",
                message: "Unsaved data on the page will be lost. Do you still want to continue?",
                buttons: {
                    confirm: {
                        label: 'Yes',
                        className: 'btn-success'
                    },
                    cancel: {
                        label: 'Cancel',
                        className: 'btn-danger'
                    }
                },
                callback: function (result) {
                    if (result) {
                        _this.isTransitionAbortRequired = false;
                        _this.clearData();
                        _this.errorOcurred = false;
                        if (_this.StorageService.get('clientOrBuToBeUpdated') != null) {
                            _this.StorageService.remove('clientOrBuToBeUpdated');
                        }
                        // Handling data change when clicked on Switch company 
                        if (_this.$rootScope.switchClicked) {
                            _this.$rootScope.switchClicked = false;
                            // this.companyService.showAllCompanies();
                            _this.uibModalService.showAllCompanies();
                        }
                        else {
                            _this.$state.go(toState, toParams, { reload: true });
                        }
                    }
                    else {
                        if (_this.$rootScope.switchClicked) {
                            _this.$rootScope.switchClicked = false;
                        }
                    }
                }
            });
        }
        else {
            // If clicked on switch company without changing data
            if (this.$rootScope.switchClicked && !this.hasDataChanged()) {
                transitions.abort();
                this.$timeout(function () {
                    // this.companyService.showAllCompanies();
                    _this.uibModalService.showAllCompanies();
                }, 150);
                this.$rootScope.switchClicked = false;
            }
        }
    };
    CompanyPageController.prototype._handleBrowserEvents = function () {
        var _this = this;
        //Handle Browser back/forward change
        var unbindLocationChangeEvent = this.$scope.$on('$locationChangeStart', function (event, toState, toParams, fromState, fromParams) {
            _this.isLocationChange = _this.isLocationChangeInitial;
            _this.isLocationChangeInitial = true;
        });
    };
    CompanyPageController.prototype.runCandidateScore = function () {
        var _this = this;
        this.alertsAndNotificationsService.showConfirm("Run Candidate Score", "Are you sure you want to run the candidate score?", "warning", true, function () {
            var requestObject = new RunCandidateScore(_this.$rootScope.userDetails.company.companyId, _this.$rootScope.userDetails.id);
            requestObject.rerunType = "GLOBAL";
            _this.resumeService.reRunResumeScore(requestObject, function (data) {
                _this.alertsAndNotificationsService.showAlertWithCallBack("Candidate scoring in Progress", data.message, "success", function () { });
            }, function (error) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        }, function () {
            //do nothing
        });
    };
    CompanyPageController.prototype.receiveFormalizedCommentForDescription = function (event) {
        this.companyManagement.company.description = event;
    };
    CompanyPageController.prototype.onVoiceTranscriptForDescription = function (transcript) {
        if (this.companyManagement.company.description) {
            this.companyManagement.company.description += ' ' + transcript;
        }
        else {
            this.companyManagement.company.description = transcript;
        }
    };
    CompanyPageController.prototype.receiveFormalizedCommentForBenefits = function (event) {
        this.$scope.skillsBenefits = event;
    };
    CompanyPageController.prototype.onVoiceTranscriptForBenefits = function (transcript) {
        if (this.$scope.skillsBenefits) {
            this.$scope.skillsBenefits += ' ' + transcript;
        }
        else {
            this.$scope.skillsBenefits = transcript;
        }
    };
    return CompanyPageController;
}());
export { CompanyPageController };
CompanyPageController.$inject = ['$scope', '$rootScope', '$state', '$transitions', '$timeout', '$compile', '$filter', '$uibModal', 'genericService', 'StorageService', 'userService', 'companyService', 'planService', 'dateTimeUtilityService', 'userRoleService', 'alertsAndNotificationsService', 'COMPANYMANAGEMENTCONSTANTS', 'MESSAGECONSTANTS', 'uibModalService', 'resumeService'];
// import * as TEMPLATE from './company-page.html';
import * as TEMPLATE from 'raw-loader!./company-page.html';
import { RunCandidateScore } from '../../../models/runCandidateScore';
export var CompanyPageComponent = {
    selector: 'companyPage',
    component: {
        bindings: { $transition$: '<' },
        // templateUrl: 'app/partials/missioncontrol/company/company-page.html',
        template: TEMPLATE.default,
        controller: CompanyPageController
    }
};
//# sourceMappingURL=company-page.component.js.map